export const dashboard = (
  <svg
    width={15}
    height={21}
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.961 19.54V1.56M1.968 19.54V5.555M13.953 19.54v-6.992"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const products = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.25"
    height="14.252"
    viewBox="0 0 14.25 14.252"
  >
    <path
      id="columns"
      d="M9.426,3h5a1.428,1.428,0,0,1,1.428,1.428v10a1.428,1.428,0,0,1-1.428,1.428h-5M9.426,3h-5A1.428,1.428,0,0,0,3,4.428v10a1.428,1.428,0,0,0,1.428,1.428h5M9.426,3V15.852"
      transform="translate(-2.301 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const programIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.25"
    height="14.252"
    viewBox="0 0 14.25 14.252"
  >
    <path
      id="columns"
      d="M9.426,3h5a1.428,1.428,0,0,1,1.428,1.428v10a1.428,1.428,0,0,1-1.428,1.428h-5M9.426,3h-5A1.428,1.428,0,0,0,3,4.428v10a1.428,1.428,0,0,0,1.428,1.428h5M9.426,3V15.852"
      transform="translate(-2.301 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const contactIcon = (
  <svg
    width={20}
    height={17}
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      fill="#fff"
    >
      <path d="M19.895 13.95a.763.763 0 00-.609-.31h-.234V3.424c0-.562-.458-1.019-1.02-1.019h-3.579v-1A1.22 1.22 0 0013.234.187H6.405c-.673 0-1.22.547-1.22 1.219v.999H1.969c-.563 0-1.02.457-1.02 1.019v10.218H.713a.763.763 0 00-.609.31.541.541 0 00-.074.498l.402 1.143c.14.394.37.594.684.594h17.767c.314 0 .544-.2.683-.594l.402-1.141a.542.542 0 00-.074-.5zM6.405 6.966h.904v1.392a.323.323 0 00.645 0V6.965h1.543V9.3a.323.323 0 00.645 0V6.965h1.586v1.392a.322.322 0 00.646 0V6.965h.86a1.22 1.22 0 001.22-1.218V4.55h2.274v7.612H3.273V4.551h1.912v1.196a1.22 1.22 0 001.22 1.218zm.141-.644l2.476-2.36.585.51a.322.322 0 00.425 0l.692-.603L13.3 6.314c-.022.002-.044.007-.067.007H6.546zm7.226-5.111a.568.568 0 01.036.195v4.342a.565.565 0 01-.02.14l-2.576-2.445 2.56-2.232zm-.547-.38L9.82 3.8 6.411.83h6.814zm-7.395.575c0-.068.014-.133.036-.194l2.668 2.325-2.623 2.5a.566.566 0 01-.081-.29V1.406zM1.593 3.423c0-.206.169-.374.376-.374h3.216v.857H2.95a.323.323 0 00-.323.323v8.257c0 .178.145.322.323.322h14.1a.323.323 0 00.323-.322V4.229a.322.322 0 00-.323-.323h-2.597V3.05h3.579c.207 0 .375.168.375.374V13.64h-5.4a.327.327 0 00-.246.119.333.333 0 00-.072.266c0 .082-.07.152-.153.152H7.464c-.082 0-.152-.07-.152-.162a.323.323 0 00-.318-.375h-5.4V3.423zm17.365 11.955c-.045.129-.077.161-.075.163H1.123a.483.483 0 01-.081-.163L.662 14.3a.126.126 0 01.052-.015H6.71a.799.799 0 00.754.537h5.072a.8.8 0 00.754-.537h5.996c.016 0 .036.007.052.015l-.38 1.077z" />
    </mask>
    <path
      d="M19.895 13.95a.763.763 0 00-.609-.31h-.234V3.424c0-.562-.458-1.019-1.02-1.019h-3.579v-1A1.22 1.22 0 0013.234.187H6.405c-.673 0-1.22.547-1.22 1.219v.999H1.969c-.563 0-1.02.457-1.02 1.019v10.218H.713a.763.763 0 00-.609.31.541.541 0 00-.074.498l.402 1.143c.14.394.37.594.684.594h17.767c.314 0 .544-.2.683-.594l.402-1.141a.542.542 0 00-.074-.5zM6.405 6.966h.904v1.392a.323.323 0 00.645 0V6.965h1.543V9.3a.323.323 0 00.645 0V6.965h1.586v1.392a.322.322 0 00.646 0V6.965h.86a1.22 1.22 0 001.22-1.218V4.55h2.274v7.612H3.273V4.551h1.912v1.196a1.22 1.22 0 001.22 1.218zm.141-.644l2.476-2.36.585.51a.322.322 0 00.425 0l.692-.603L13.3 6.314c-.022.002-.044.007-.067.007H6.546zm7.226-5.111a.568.568 0 01.036.195v4.342a.565.565 0 01-.02.14l-2.576-2.445 2.56-2.232zm-.547-.38L9.82 3.8 6.411.83h6.814zm-7.395.575c0-.068.014-.133.036-.194l2.668 2.325-2.623 2.5a.566.566 0 01-.081-.29V1.406zM1.593 3.423c0-.206.169-.374.376-.374h3.216v.857H2.95a.323.323 0 00-.323.323v8.257c0 .178.145.322.323.322h14.1a.323.323 0 00.323-.322V4.229a.322.322 0 00-.323-.323h-2.597V3.05h3.579c.207 0 .375.168.375.374V13.64h-5.4a.327.327 0 00-.246.119.333.333 0 00-.072.266c0 .082-.07.152-.153.152H7.464c-.082 0-.152-.07-.152-.162a.323.323 0 00-.318-.375h-5.4V3.423zm17.365 11.955c-.045.129-.077.161-.075.163H1.123a.483.483 0 01-.081-.163L.662 14.3a.126.126 0 01.052-.015H6.71a.799.799 0 00.754.537h5.072a.8.8 0 00.754-.537h5.996c.016 0 .036.007.052.015l-.38 1.077z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.1}
      mask="url(#a)"
    />
  </svg>
);

export const users = (
  <svg
    width={25}
    height={21}
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.954 19.383V17.39a4 4 0 0 0-4-4h-7.98a4 4 0 0 0-4 4v2M9.5 8.626a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM23.95 19.383V17.39a4 4 0 0 0-3-3.865M16.955 1.534a4 4 0 0 1 0 7.74"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const manage = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const marketing = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.715"
    height="15.705"
    viewBox="0 0 15.715 15.705"
  >
    <g
      id="pie-chart"
      transform="translate(0.734 0.7)"
    >
      <path
        id="Path_21721"
        data-name="Path 21721"
        d="M15.715,12.155A7.14,7.14,0,1,1,6.284,2.83"
        transform="translate(-1.999 -2.237)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21722"
        data-name="Path 21722"
        d="M19.14,9.14A7.14,7.14,0,0,0,12,2V9.14Z"
        transform="translate(-4.86 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const subscriptions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.158"
    height="15.93"
    viewBox="0 0 16.158 15.93"
  >
    <g
      id="check-circle"
      transform="translate(0.889 0.853)"
    >
      <path
        id="Path_21716"
        data-name="Path 21716"
        d="M16.279,8.481v.657a7.14,7.14,0,1,1-4.234-6.526"
        transform="translate(-2 -1.994)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21717"
        data-name="Path 21717"
        d="M18.282,4l-7.14,7.147L9,9"
        transform="translate(-4.002 -2.568)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const reports = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.688"
    height="10.548"
    viewBox="0 0 17.688 10.548"
  >
    <g
      id="trending-up"
      transform="translate(0.99 0.99)"
    >
      <path
        id="Path_21719"
        data-name="Path 21719"
        d="M16.707,6,9.925,12.783l-3.57-3.57L1,14.568"
        transform="translate(-1 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21720"
        data-name="Path 21720"
        d="M17,6h4.284v4.284"
        transform="translate(-5.576 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const website = (
  <svg
    className="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15.639"
    height="14.217"
    viewBox="0 0 15.639 14.217"
  >
    <g
      transform="translate(.219 .7)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    >
      <rect
        data-name="Rectangle 1574"
        width="14.24"
        height="9.68"
        rx={1}
        transform="translate(.48)"
      />
      <path
        data-name="Line 772"
        d="M4.98 12.816h5"
      />
      <path
        data-name="Line 773"
        d="M7.479 9.65v3.165"
      />
    </g>
  </svg>
);

export const settings = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.526 15.162C14.459 15.162 16.026 13.8188 16.026 12.162C16.026 10.5051 14.459 9.16199 12.526 9.16199C10.593 9.16199 9.026 10.5051 9.026 12.162C9.026 13.8188 10.593 15.162 12.526 15.162Z"
      stroke="#444850"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.377 14.983C19.2441 15.2843 19.2044 15.6186 19.2633 15.9426C19.3221 16.2666 19.4766 16.5656 19.707 16.801L19.767 16.861C19.9654 17.0436 20.1248 17.2644 20.2357 17.5102C20.3465 17.7559 20.4066 18.0216 20.4121 18.2911C20.4177 18.5607 20.3688 18.8286 20.2682 19.0788C20.1676 19.3289 20.0174 19.5561 19.8268 19.7468C19.6361 19.9374 19.4089 20.0876 19.1588 20.1882C18.9086 20.2888 18.6407 20.3377 18.3711 20.3321C18.1016 20.3266 17.8359 20.2665 17.5902 20.1557C17.3444 20.0448 17.1236 19.8854 16.941 19.687L16.881 19.627C16.6475 19.401 16.3528 19.2485 16.0335 19.1884C15.7142 19.1282 15.3842 19.163 15.0845 19.2885C14.7847 19.414 14.5284 19.6246 14.3472 19.8944C14.166 20.1641 14.0679 20.4811 14.065 20.806V20.976C14.065 21.5064 13.8543 22.0151 13.4792 22.3902C13.1041 22.7653 12.5954 22.976 12.065 22.976C11.5346 22.976 11.0259 22.7653 10.6508 22.3902C10.2757 22.0151 10.065 21.5064 10.065 20.976V20.886C10.0577 20.5557 9.95133 20.2352 9.75963 19.9661C9.56794 19.697 9.2998 19.4918 8.99 19.377C8.68869 19.2441 8.35445 19.2044 8.0304 19.2633C7.70636 19.3221 7.40737 19.4766 7.172 19.707L7.112 19.767C6.929 19.964 6.70817 20.122 6.4627 20.2317C6.21723 20.3414 5.95217 20.4004 5.68336 20.4054C5.41454 20.4103 5.1475 20.3609 4.89819 20.2603C4.64887 20.1597 4.42241 20.0098 4.23233 19.8196C4.04225 19.6295 3.89247 19.403 3.79192 19.1536C3.69137 18.9043 3.64213 18.6372 3.64714 18.3684C3.65215 18.0996 3.71131 17.8346 3.82108 17.5891C3.93084 17.3437 4.08897 17.1229 4.286 16.94L4.346 16.88C4.57197 16.6465 4.72448 16.3518 4.78465 16.0325C4.84482 15.7132 4.81 15.3832 4.68451 15.0835C4.55901 14.7837 4.34836 14.5274 4.07863 14.3462C3.80889 14.165 3.49193 14.0669 3.167 14.064H3C2.46957 14.064 1.96086 13.8533 1.58579 13.4782C1.21071 13.1031 1 12.5944 1 12.064C1 11.5336 1.21071 11.0249 1.58579 10.6498C1.96086 10.2747 2.46957 10.064 3 10.064H3.09C3.42035 10.057 3.74098 9.95084 4.01024 9.75932C4.27951 9.56781 4.48499 9.29977 4.6 8.99C4.73295 8.68869 4.77257 8.35445 4.71375 8.0304C4.65493 7.70636 4.50037 7.40737 4.27 7.172L4.21 7.112C4.00704 6.93083 3.84317 6.71015 3.72843 6.46346C3.61369 6.21678 3.55048 5.94928 3.54268 5.67733C3.53488 5.40538 3.58264 5.13469 3.68305 4.88184C3.78346 4.62898 3.9344 4.39927 4.12664 4.20676C4.31888 4.01424 4.54838 3.86297 4.80109 3.76221C5.05381 3.66144 5.32442 3.61329 5.59639 3.62071C5.86835 3.62813 6.13594 3.69096 6.38278 3.80535C6.62963 3.91974 6.85054 4.08329 7.032 4.286L7.092 4.346C7.32737 4.57637 7.62636 4.73093 7.9504 4.78975C8.27445 4.84857 8.60869 4.80895 8.91 4.676H8.99C9.28561 4.54959 9.53779 4.33946 9.71547 4.07152C9.89316 3.80357 9.98858 3.4895 9.99 3.168V3C9.99 2.46957 10.2007 1.96086 10.5758 1.58579C10.9509 1.21071 11.4596 1 11.99 1C12.5204 1 13.0291 1.21071 13.4042 1.58579C13.7793 1.96086 13.99 2.46957 13.99 3V3.09C13.9945 3.41348 14.0934 3.72859 14.2746 3.99665C14.4557 4.2647 14.7112 4.47402 15.0096 4.59892C15.308 4.72381 15.6364 4.75884 15.9545 4.6997C16.2725 4.64056 16.5664 4.48982 16.8 4.266L16.86 4.206C17.0426 4.00762 17.2634 3.8482 17.5092 3.73734C17.7549 3.62647 18.0206 3.56644 18.2901 3.56085C18.5597 3.55527 18.8276 3.60425 19.0778 3.70484C19.3279 3.80543 19.5551 3.95556 19.7458 4.14621C19.9364 4.33686 20.0866 4.56409 20.1872 4.81424C20.2878 5.06439 20.3367 5.33229 20.3311 5.60185C20.3256 5.87141 20.2655 6.13706 20.1547 6.38283C20.0438 6.6286 19.8844 6.84941 19.686 7.032L19.626 7.092C19.3963 7.32781 19.2425 7.62701 19.1844 7.95104C19.1263 8.27507 19.1665 8.60907 19.3 8.91V8.99C19.4264 9.28561 19.6365 9.53779 19.9045 9.71547C20.1724 9.89316 20.4865 9.98858 20.808 9.99H20.978C21.5084 9.99 22.0171 10.2007 22.3922 10.5758C22.7673 10.9509 22.978 11.4596 22.978 11.99C22.978 12.5204 22.7673 13.0291 22.3922 13.4042C22.0171 13.7793 21.5084 13.99 20.978 13.99H20.888C20.5668 13.9902 20.2526 14.0844 19.9842 14.2608C19.7157 14.4372 19.5047 14.6882 19.377 14.983V14.983Z"
      stroke="#444850"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const documents = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.822"
    height="15.68"
    viewBox="0 0 12.822 15.68"
  >
    <g
      id="file"
      transform="translate(0.699 0.7)"
    >
      <path
        id="Path_21714"
        data-name="Path 21714"
        d="M10.426,2h-5A1.428,1.428,0,0,0,4,3.428V14.852a1.428,1.428,0,0,0,1.428,1.428H14a1.428,1.428,0,0,0,1.428-1.428V7Z"
        transform="translate(-4 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21715"
        data-name="Path 21715"
        d="M13,2V7h5"
        transform="translate(-6.574 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5.241"
    height="11.265"
    viewBox="0 0 5.241 11.265"
  >
    <path
      id="Path_41"
      data-name="Path 41"
      d="M7212.063-9151.6l-3.56,4.65,3.56,4.651"
      transform="translate(-7207.804 9152.58)"
      fill="none"
      stroke="#acacb0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const externalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.822"
    height="13.535"
    viewBox="0 0 13.822 13.535"
  >
    <g
      id="external-link"
      transform="translate(0.699 0.035)"
    >
      <path
        id="Path_21436"
        data-name="Path 21436"
        d="M13.667,10.978v4.267a1.422,1.422,0,0,1-1.422,1.422H4.422A1.422,1.422,0,0,1,3,15.244V7.422A1.422,1.422,0,0,1,4.422,6H8.689"
        transform="translate(-3 -3.867)"
        fill="none"
        stroke="#a3a6ac"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21437"
        data-name="Path 21437"
        d="M15,3h3.361V6.36"
        transform="translate(-6.115 -2.253)"
        fill="none"
        stroke="#a3a6ac"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <line
        id="Line_123"
        data-name="Line 123"
        y1={7}
        x2={7}
        transform="translate(5.133 0.955)"
        fill="none"
        stroke="#a3a6ac"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const superadminIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-app-indicator"
    viewBox="0 0 16 16"
  >
    <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
    <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
  </svg>
);

export const profileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={18.4}
    viewBox="0 0 18.4 18.4"
  >
    <g
      data-name="Group 20504"
      transform="translate(-105.8 -129.8)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <g
        data-name="user (1)"
        transform="translate(109.9 134.051)"
      >
        <path
          data-name="Path 1"
          d="M10.2 11.471V9.903a2.89 2.89 0 00-2.552-3.138h-5.1A2.89 2.89 0 000 9.903v1.569"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.233}
          cy={3.233}
          r={3.233}
          transform="translate(1.8)"
        />
      </g>
      <circle
        cx={8.5}
        cy={8.5}
        r={8.5}
        transform="translate(106.5 130.5)"
      />
    </g>
  </svg>
);

export const logoutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box-arrow-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
    />
    <path
      fillRule="evenodd"
      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
    />
  </svg>
);

export const moonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-moon"
    viewBox="0 0 16 16"
  >
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
  </svg>
);

export const shield = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.326"
    height="17.558"
    viewBox="0 0 14.326 17.558"
  >
    <path
      id="Icon_feather-shield"
      data-name="Icon feather-shield"
      d="M12.463,19.158s6.463-3.232,6.463-8.079V5.424L12.463,3,6,5.424v5.655C6,15.926,12.463,19.158,12.463,19.158Z"
      transform="translate(-5.3 -2.3)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const mykademyLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={32}
    className="d-block my-1 mykademy-logo"
    viewBox="0 0 9367.293 1486.342"
  >
    {' '}
    <g transform="translate(34 -312)">
      {' '}
      <g transform="translate(-34 312)">
        {' '}
        <g transform="translate(2255.718 89.226)">
          {' '}
          <path
            d="M506.1,425.869c0-68.6-9.147-114.334-27.441-146.347-18.293-27.44-45.733-41.16-91.467-41.16h-41.16c-13.72,0-27.44,4.573-41.16,4.573V819.178H94.5V101.16c18.294-4.573,41.16-9.147,64.027-13.72s50.307-9.147,77.747-13.72,54.88-9.147,82.32-9.147C346.035,60,373.475,60,400.915,60c54.88,0,96.041,4.573,132.628,18.294C565.556,92.014,593,110.307,615.864,128.6c32.013-22.867,64.027-36.587,105.187-50.307S794.225,60,830.812,60c59.454,0,109.76,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.467,68.6,22.867,32.013,36.587,64.027,45.733,109.76q13.72,61.741,13.72,137.2V819.178H917.706V425.869c0-68.6-9.147-114.334-27.44-146.347-18.293-27.44-45.733-41.16-91.467-41.16-9.147,0-27.44,4.573-45.734,9.146s-36.587,13.72-50.307,22.867q6.86,34.3,13.72,68.6c0,22.866,4.574,50.307,4.574,77.747V823.751H510.677V425.869Z"
            transform="translate(-94.5 278.429)"
            fill="currentColor"
          />{' '}
          <path
            d="M873.3,64.773c-41.16,141.774-86.893,278.975-132.627,402.456S644.637,714.19,589.757,833.1c-18.293,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.027,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.014,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.454,13.72,18.294,4.573,36.587,4.573,54.88,4.573,36.587,0,68.6-9.147,86.894-32.013,18.293-18.294,36.587-50.307,50.307-82.321-50.307-96.041-96.041-201.228-146.348-320.135S169.007,206.548,123.274,60.2H347.368c9.147,36.587,22.867,77.747,32.014,118.907,13.72,41.16,27.44,86.894,41.16,132.627s27.44,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054,22.867-86.894,36.587-132.627c13.72-41.16,22.867-82.321,32.013-118.907H873.3Z"
            transform="translate(988.053 287.376)"
            fill="currentColor"
          />{' '}
          <path
            d="M348.076,674.577c22.867-22.867,41.16-45.734,64.027-68.6S457.837,555.67,476.13,532.8c22.867-22.867,41.16-45.734,59.454-68.6s32.013-41.16,45.733-54.88H832.852C782.545,468.776,732.238,523.656,686.5,573.963S585.891,679.15,531.011,734.031c27.44,27.44,59.454,54.88,86.894,91.467,32.013,36.587,59.454,73.174,86.893,109.761s54.88,77.747,77.747,114.334S828.279,1122.766,842,1154.78H599.61c-13.72-22.867-32.013-50.307-50.307-82.321s-41.16-59.454-59.454-91.467-45.734-59.454-68.6-86.894-45.734-50.307-73.174-68.6v324.708H137.7V84.613L348.075,52.6V674.577Z"
            transform="translate(1837.99 -52.6)"
            fill="currentColor"
          />{' '}
          <path
            d="M474.335,59.9c64.027,0,114.334,9.147,155.494,22.867S703,119.354,730.443,142.221q34.3,41.16,54.88,96.04c9.147,36.587,13.72,77.747,13.72,128.054V805.357c-32.013,4.573-73.174,13.72-128.054,22.867s-118.908,13.72-196.655,13.72c-50.307,0-91.467-4.573-132.627-13.72s-73.174-22.867-100.614-41.16-50.307-45.734-64.027-77.747S154.2,640.717,154.2,594.983s9.146-82.321,27.44-109.761c18.294-32.013,41.16-54.88,68.6-73.174s64.026-32.014,100.614-41.16,77.747-13.72,118.907-13.72c27.441,0,50.308,0,73.175,4.573s36.587,4.573,50.307,9.147V352.594c0-36.587-9.147-64.027-32.014-86.894S501.776,233.687,446.9,233.687c-36.587,0-73.174,4.573-105.187,9.147-36.587,4.573-64.027,13.72-91.467,22.867L222.8,96.486c13.72-4.573,27.441-9.147,45.734-13.72s36.587-9.147,59.454-9.147c22.867-4.573,45.734-4.573,68.6-9.147C424.029,59.9,446.895,59.9,474.335,59.9Zm18.294,617.4h59.454c18.293,0,32.013-4.573,45.733-4.573V512.663c-9.146,0-22.867-4.573-36.587-4.573-18.293,0-32.013-4.573-45.734-4.573-18.293,0-36.586,0-54.88,4.573s-32.013,9.147-45.734,13.72-22.867,13.72-32.013,27.44c-9.146,9.147-9.146,27.44-9.146,41.16,0,32.013,9.146,54.88,32.013,68.6C419.455,668.157,451.468,677.3,492.629,677.3Z"
            transform="translate(2576.096 273.955)"
            fill="currentColor"
          />{' '}
          <path
            d="M871.324,1127.339c-18.293,4.573-41.16,9.147-64.026,18.294-22.867,4.573-50.308,9.147-77.747,13.72s-54.881,4.573-82.321,9.147-54.88,4.573-82.321,4.573q-89.18,0-164.641-27.44c-50.307-18.294-86.893-45.734-123.481-77.747-32.013-32.014-59.453-73.174-77.747-123.481-18.293-45.734-27.44-100.614-27.44-160.068S180.746,670,194.467,619.7s36.586-91.467,64.027-123.481,64.026-59.454,105.187-77.747,86.894-27.44,141.775-27.44c27.44,0,54.88,4.573,77.747,9.147s45.733,13.72,68.6,22.867V84.614L862.178,52.6V1127.339Zm-480.2-356.722c0,64.027,13.72,118.907,45.734,155.494s73.174,59.454,132.627,59.454h50.307c18.294,0,27.441-4.573,41.16-4.573V596.83c-13.72-9.146-32.013-13.72-50.308-22.867-22.867-4.573-41.159-9.147-64.026-9.147C441.428,569.39,391.121,633.417,391.121,770.617Z"
            transform="translate(3354.46 -52.6)"
            fill="currentColor"
          />{' '}
          <path
            d="M190.4,457.782c0-64.027,9.147-123.48,32.013-173.788q27.439-75.46,82.32-123.481C336.747,128.5,377.908,101.06,419.068,87.34c41.16-18.293,86.893-27.44,132.627-27.44,105.188,0,187.508,32.014,251.536,96.041C862.683,219.968,894.7,316.008,894.7,439.489v41.16c0,13.72,0,27.44-4.574,41.16H409.92c4.574,45.734,22.867,77.747,59.454,105.187s82.32,36.587,146.348,36.587c36.586,0,77.747-4.573,114.333-9.147s68.6-13.72,91.467-27.44l27.441,173.788c-9.146,4.573-27.441,9.146-45.733,18.293-18.294,4.574-41.161,9.147-64.027,13.72s-45.733,9.146-73.174,9.146c-27.44,4.573-54.88,4.573-77.747,4.573-68.6,0-123.481-9.146-173.787-32.013q-75.462-27.44-123.481-82.321C259,695.6,236.134,659.011,217.839,608.7S190.4,512.663,190.4,457.782Zm498.5-82.32c0-18.293-4.574-36.587-9.146-50.307s-13.72-32.014-22.867-45.734-22.867-22.867-41.161-32.013-36.586-13.72-59.453-13.72-45.734,4.573-59.454,13.72c-18.293,9.147-32.013,18.293-41.16,32.013s-18.294,27.44-27.441,45.734q-6.86,27.44-13.72,54.88H688.9Z"
            transform="translate(4195.452 273.955)"
            fill="currentColor"
          />{' '}
          <path
            d="M620.9,425.869c0-68.6-9.146-114.334-27.44-146.347-18.293-27.44-45.734-41.16-91.467-41.16h-41.16c-13.72,0-27.441,4.573-41.16,4.573V819.178H209.3V101.16c18.294-4.573,41.161-9.147,64.026-13.72s50.308-9.147,77.748-13.72,54.88-9.147,82.32-9.147C460.835,60,488.274,60,515.715,60c54.88,0,96.041,4.573,132.627,18.294S707.8,110.307,730.663,128.6c32.013-22.867,64.026-36.587,105.187-50.307S909.024,60,945.611,60c59.454,0,109.761,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.468,68.6s36.588,64.027,45.734,109.76q13.72,61.741,13.72,137.2V819.178H1032.5V425.869c0-68.6-9.148-114.334-27.441-146.347-18.293-27.44-45.734-41.16-91.468-41.16-9.147,0-27.44,4.573-45.733,9.146s-36.586,13.72-50.307,22.867q6.862,34.3,13.721,68.6c0,22.866,4.573,50.307,4.573,77.747V823.751H625.475V425.869Z"
            transform="translate(5040.917 278.429)"
            fill="currentColor"
          />{' '}
          <path
            d="M988.1,64.773c-41.16,141.774-86.894,278.975-132.628,402.456S759.437,714.19,704.556,833.1c-18.294,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.026,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.013,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.453,13.72,18.293,4.573,36.587,4.573,54.881,4.573,36.586,0,68.6-9.147,86.893-32.013,18.293-18.294,36.588-50.307,50.307-82.321-50.307-96.041-96.04-201.228-146.347-320.135S283.808,206.548,238.074,60.2H462.168c9.146,36.587,22.866,77.747,32.013,118.907,13.721,41.16,27.44,86.894,41.16,132.627s27.441,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054S722.848,224.841,732,179.107c13.719-41.16,22.866-82.321,32.013-118.907H988.1Z"
            transform="translate(6123.47 287.376)"
            fill="currentColor"
          />{' '}
        </g>{' '}
        <g transform="translate(0)">
          {' '}
          <g transform="translate(1984.838) rotate(90)">
            {' '}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.582V274.4c4.573-73.174,45.733-137.2,114.334-164.641"
              transform="translate(0 352.149)"
              fill="#64caa1"
            />{' '}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.581V274.4c4.573-73.174,50.307-137.2,114.334-164.641"
              transform="translate(1056.446 256.108)"
              fill="#64caa1"
            />{' '}
            <path
              d="M0,0"
              transform="translate(320.135 818.631)"
              fill="#148f84"
            />{' '}
            <path
              d="M114.334,109.761,429.9,0V1710.437c0,73.174-45.734,137.2-114.334,164.641L0,1984.838V274.4c0-73.174,45.734-137.2,114.334-164.641"
              transform="translate(530.51)"
              fill="#64caa1"
            />{' '}
            <path
              d="M0,0Z"
              transform="translate(635.697 772.898)"
              fill="#148f84"
              fillRule="evenodd"
            />{' '}
          </g>{' '}
        </g>{' '}
      </g>{' '}
    </g>{' '}
  </svg>
);

export const viewLiveSiteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="currentColor"
    className="bi bi-box-arrow-up-right"
    viewBox="0 0 16 16"
  >
    {' '}
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />{' '}
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />{' '}
  </svg>
);

export const helpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-question-circle"
    viewBox="0 0 16 16"
  >
    {' '}
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />{' '}
    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />{' '}
  </svg>
);

export const bellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="15.62"
    viewBox="0 0 14.2 15.62"
  >
    {' '}
    <g
      id="bell"
      transform="translate(0.7 0.7)"
    >
      {' '}
      <path
        id="Path_21414"
        data-name="Path 21414"
        d="M13.667,6.267a4.267,4.267,0,1,0-8.533,0c0,4.978-2.133,6.4-2.133,6.4H15.8s-2.133-1.422-2.133-6.4"
        transform="translate(-3 -2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{' '}
      <path
        id="Path_21415"
        data-name="Path 21415"
        d="M12.73,21a1.422,1.422,0,0,1-2.46,0"
        transform="translate(-5.1 -7.489)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{' '}
    </g>{' '}
  </svg>
);

export const chatIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="14.2"
    viewBox="0 0 14.2 14.2"
  >
    {' '}
    <path
      id="message-square"
      d="M15.8,11.533a1.422,1.422,0,0,1-1.422,1.422H5.844L3,15.8V4.422A1.422,1.422,0,0,1,4.422,3h9.956A1.422,1.422,0,0,1,15.8,4.422Z"
      transform="translate(-2.3 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{' '}
  </svg>
);

export const rightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.718"
    height="4.631"
    viewBox="0 0 9.718 4.631"
  >
    {' '}
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{' '}
  </svg>
);

export const cubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-grid-3x3-gap"
    viewBox="0 0 16 16"
  >
    {' '}
    <path d="M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z" />{' '}
  </svg>
);

export const togglerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.2"
    height="20.2"
    viewBox="0 0 20.2 20.2"
  >
    <g
      id="Group_18767"
      data-name="Group 18767"
      transform="translate(-1619.701 -31.699)"
    >
      <g
        id="more-horizontal"
        transform="translate(1620.301 32.3)"
      >
        <circle
          id="Ellipse_263"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-2"
        data-name="more-horizontal"
        transform="translate(1620.301 40.123)"
      >
        <circle
          id="Ellipse_263-2"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-2"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-2"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-3"
        data-name="more-horizontal"
        transform="translate(1620.301 47.948)"
      >
        <circle
          id="Ellipse_263-3"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-3"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-3"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </g>
  </svg>
);

export const downArrowBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.119"
    height="11.658"
    viewBox="0 0 6.119 11.658"
  >
    <path
      id="Path_21616"
      data-name="Path 21616"
      d="M0,0,4.42,3.71,8.84,0"
      transform="translate(1.409 10.249) rotate(-90)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const calendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="currentColor"
    className="bi bi-calendar4"
    viewBox="0 0 16 16"
  >
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z" />
  </svg>
);

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.831"
    height="15.665"
    viewBox="0 0 15.831 15.665"
  >
    <path
      id="edit-2"
      d="M12.791,2.768a2.035,2.035,0,1,1,2.878,2.878L5.957,15.357,2,16.437,3.079,12.48Z"
      transform="translate(-1.3 -1.472)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const binIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.999"
    height="14.288"
    viewBox="0 0 12.999 14.288"
  >
    <g
      id="trash_1_"
      data-name="trash (1)"
      transform="translate(0.7 0.7)"
    >
      <path
        id="Path_13"
        data-name="Path 13"
        d="M3,6H14.6"
        transform="translate(-3 -3.422)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M14.021,4.578V13.6a1.289,1.289,0,0,1-1.289,1.289H6.289A1.289,1.289,0,0,1,5,13.6V4.578m1.933,0V3.289A1.289,1.289,0,0,1,8.222,2H10.8a1.289,1.289,0,0,1,1.289,1.289V4.578"
        transform="translate(-3.711 -2)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.075"
    height="9.914"
    viewBox="0 0 9.075 9.914"
  >
    {' '}
    <g
      id="Icon_feather-download"
      data-name="Icon feather-download"
      transform="translate(-5.902 -3.8)"
    >
      {' '}
      <path
        id="Path_40557"
        data-name="Path 40557"
        d="M10.5,15l3.547,3.547L17.595,15"
        transform="translate(-3.608 -5.534)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{' '}
      <path
        id="Path_40558"
        data-name="Path 40558"
        d="M18,13.014V4.5"
        transform="translate(-7.56)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{' '}
    </g>{' '}
  </svg>
);

export const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.733"
    height="12.734"
    viewBox="0 0 12.733 12.734"
  >
    <g
      id="Icon_feather-copy"
      data-name="Icon feather-copy"
      transform="translate(-2.3 -2.3)"
    >
      <path
        id="Path_40559"
        data-name="Path 40559"
        d="M14.633,13.5h5.1a1.133,1.133,0,0,1,1.133,1.133v5.1a1.133,1.133,0,0,1-1.133,1.133h-5.1A1.133,1.133,0,0,1,13.5,19.733v-5.1A1.133,1.133,0,0,1,14.633,13.5Z"
        transform="translate(-6.533 -6.533)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40560"
        data-name="Path 40560"
        d="M4.7,10.367H4.133A1.133,1.133,0,0,1,3,9.233v-5.1A1.133,1.133,0,0,1,4.133,3h5.1a1.133,1.133,0,0,1,1.133,1.133V4.7"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const menuHamburgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.837"
    height="16.558"
    viewBox="0 0 23.837 16.558"
  >
    <g
      data-name="Icon feather-menu"
      transform="translate(-3.5 -8)"
    >
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(0 -1.721)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40586"
        data-name="Path 40586"
        d="M4.5,9H26.337"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40587"
        data-name="Path 40587"
        d="M4.5,27H26.337"
        transform="translate(0 -3.442)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const menuCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.27"
    height="18.27"
    viewBox="0 0 18.27 18.27"
  >
    <g
      id="Icon_feather-menu"
      data-name="Icon feather-menu"
      transform="translate(-3.086 -7.144)"
    >
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(14.046 -7.351) rotate(45)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40588"
        data-name="Path 40588"
        d="M0,0H21.837"
        transform="translate(19.942 8.558) rotate(135)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const lockPadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.169"
    height="17.81"
    viewBox="0 0 16.169 17.81"
  >
    <g
      id="Icon_feather-lock"
      data-name="Icon feather-lock"
      transform="translate(-3.8 -2.3)"
    >
      <path
        id="Path_40549"
        data-name="Path 40549"
        d="M6.141,16.5H17.628a1.641,1.641,0,0,1,1.641,1.641v5.743a1.641,1.641,0,0,1-1.641,1.641H6.141A1.641,1.641,0,0,1,4.5,23.884V18.141A1.641,1.641,0,0,1,6.141,16.5Z"
        transform="translate(0 -6.116)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40550"
        data-name="Path 40550"
        d="M10.5,10.384V7.1a4.1,4.1,0,1,1,8.2,0v3.282"
        transform="translate(-2.718)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

export const chervonDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    viewBox="0 0 9.718 4.631"
  >
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const removeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.763"
    height="7.763"
    viewBox="0 0 7.763 7.763"
  >
    <g
      data-name="Group 17821"
      transform="translate(0.99 0.99)"
    >
      <path
        id="Path_21632"
        data-name="Path 21632"
        d="M0,0V8.177"
        transform="translate(5.783 0) rotate(45)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21633"
        data-name="Path 21633"
        d="M0,0V8.177"
        transform="translate(5.782 5.783) rotate(135)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const addIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.39"
    height="10.391"
    viewBox="0 0 10.39 10.391"
  >
    <g
      id="Group_17764"
      data-name="Group 17764"
      transform="translate(0.7 0.7)"
    >
      <path
        id="Path_9"
        data-name="Path 9"
        d="M1756.344,206.134h-8.99"
        transform="translate(-1747.354 -201.864)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_32"
        data-name="Path 32"
        d="M8.991,0H0"
        transform="translate(4.495) rotate(90)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const toolIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(-90 3 4)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const upArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(90 1.5 4.5)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const calendarIcon101 = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512' }}
    xmlSpace="preserve"
    fill="currentColor"
  >
    <g>
      <path
        d="M93.1,69.8v23.3h325.8c12.8,0,23.2,10.4,23.3,23.3v325.8c0,12.8-10.4,23.2-23.3,23.3H93.1c-12.8,0-23.2-10.4-23.3-23.3
		V116.4c0-12.8,10.4-23.3,23.3-23.3V69.8V46.5c-38.6,0-69.8,31.2-69.8,69.8v325.8c0,38.6,31.2,69.8,69.8,69.8h325.8
		c38.6,0,69.8-31.2,69.8-69.8V116.4c0-38.6-31.2-69.8-69.8-69.8H93.1V69.8z"
      />
      <path d="M325.8,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3s23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3S325.8,10.4,325.8,23.3" />
      <path
        d="M139.6,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3c12.9,0,23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3
		C150.1,0,139.6,10.4,139.6,23.3"
      />
      <path
        d="M46.5,232.7h418.9c12.9,0,23.3-10.4,23.3-23.3c0-12.9-10.4-23.3-23.3-23.3H46.5c-12.9,0-23.3,10.4-23.3,23.3
		C23.3,222.3,33.7,232.7,46.5,232.7"
      />
    </g>
  </svg>
);

export const filterIcon = (
  <svg
    width={21}
    height={13}
    viewBox="0 0 21 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.076 1.5H.354M16.532 6.5H3.897M13.09 11.5H7.35"
      stroke="#1B1C21"
      strokeWidth={2}
    />
  </svg>
);

export const dotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-three-dots"
    viewBox="0 0 16 16"
  >
    <path d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
  </svg>
);

export const fullAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.195}
    height={8.646}
    viewBox="0 0 17.195 8.646"
  >
    <path
      data-name="Path 40521"
      d="M113.593 160.776a5.767 5.767 0 00-1.794-1.651 4 4 0 00-1.239-.448 4.4 4.4 0 00-1.439-.009 4.161 4.161 0 00-1.984 7.29 4.129 4.129 0 00.978.613 4.477 4.477 0 001.286.344 4.059 4.059 0 002.54-.577 5.989 5.989 0 001.76-1.719 7.735 7.735 0 00.9-1.7c.021-.055.041-.107.064-.16l-.056.135a7.5 7.5 0 01.842-1.489l.073-.1.023-.028a.463.463 0 00-.043.056l.124-.154c.085-.1.171-.2.263-.3a4.857 4.857 0 01.44-.414c.024-.021.049-.039.073-.058s.07-.055 0 0-.008.006.008-.006a4.035 4.035 0 01.827-.479l-.135.056a3.529 3.529 0 01.888-.243l-.15.021a3.61 3.61 0 01.955 0l-.15-.021a3.635 3.635 0 01.9.246l-.135-.056a3.594 3.594 0 01.609.329c.047.032.094.066.141.1s.105.09-.036-.028c.024.021.051.041.077.062.085.071.167.145.244.224s.152.16.224.244c.013.015.06.056.062.077 0-.024-.094-.124-.028-.036.034.047.068.094.1.141a3.594 3.594 0 01.329.609l-.056-.135a3.656 3.656 0 01.246.9l-.021-.15a3.8 3.8 0 010 .991l.021-.15a3.634 3.634 0 01-.246.9l.056-.135a3.594 3.594 0 01-.329.609c-.032.047-.066.094-.1.141s-.09.105.028-.036c-.021.024-.041.051-.062.077-.071.085-.145.167-.224.244s-.16.152-.244.224c-.015.013-.056.06-.077.062.024 0 .124-.094.036-.028a6.106 6.106 0 01-.141.1 3.593 3.593 0 01-.609.329l.135-.056a3.657 3.657 0 01-.9.246l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.55 3.55 0 01-.888-.243l.135.056a3.76 3.76 0 01-.583-.31c-.087-.056-.173-.115-.256-.179s.075.06.028.023l-.062-.051-.122-.1a5.574 5.574 0 01-.438-.431c-.068-.075-.134-.152-.2-.229l-.085-.107c-.07-.088.064.085.028.036l-.051-.068a.61.61 0 00-.337-.26.564.564 0 00-.694.393.547.547 0 00.056.434 5.767 5.767 0 001.794 1.651 4 4 0 001.239.448 4.4 4.4 0 001.438.009 4.161 4.161 0 001.986-7.29 4.13 4.13 0 00-.978-.613 4.477 4.477 0 00-1.286-.344 4.059 4.059 0 00-2.54.577 5.989 5.989 0 00-1.76 1.719 7.735 7.735 0 00-.9 1.7 3.808 3.808 0 01-.064.16l.056-.135a7.565 7.565 0 01-.842 1.491l-.073.1-.023.028a.463.463 0 00.043-.056l-.124.154c-.085.1-.171.2-.263.3a4.857 4.857 0 01-.44.414c-.024.021-.049.039-.073.058s-.07.055 0 0 .008-.006-.008.006a4.036 4.036 0 01-.827.479l.135-.056a3.529 3.529 0 01-.888.243l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.634 3.634 0 01-.9-.246l.135.056a3.593 3.593 0 01-.609-.329c-.047-.032-.094-.066-.141-.1s-.105-.09.036.028c-.024-.021-.051-.041-.077-.062-.085-.071-.167-.145-.244-.224s-.152-.16-.224-.244c-.013-.015-.06-.056-.062-.077 0 .024.094.124.028.036-.034-.047-.068-.094-.1-.141a3.594 3.594 0 01-.329-.609l.056.135a3.656 3.656 0 01-.246-.9l.021.15a3.8 3.8 0 010-.991l-.021.15a3.634 3.634 0 01.246-.9l-.056.135a3.594 3.594 0 01.329-.609c.032-.047.066-.094.1-.141s.09-.105-.028.036c.021-.024.041-.051.062-.077.071-.085.145-.167.224-.244s.16-.152.244-.224c.015-.013.056-.06.077-.062-.024 0-.124.094-.036.028.047-.034.094-.068.141-.1a3.592 3.592 0 01.609-.329l-.135.056a3.657 3.657 0 01.9-.246l-.15.021a3.611 3.611 0 01.955 0l-.15-.021a3.55 3.55 0 01.888.243l-.135-.056a3.919 3.919 0 01.583.308c.086.056.173.115.256.179s-.075-.06-.028-.023l.062.051.122.1a5.569 5.569 0 01.438.431c.068.075.134.152.2.229l.085.107c.07.088-.064-.085-.028-.036l.051.068a.61.61 0 00.337.259.564.564 0 00.694-.393.557.557 0 00-.058-.434z"
      fill="#ced2d9"
      stroke="#ced2d9"
      strokeWidth={0.3}
      transform="translate(-105.462 -158.446)"
    />
  </svg>
);

export const daysIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#ced2d9"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 10"
        width={12.8}
        height={12.8}
        rx={2}
        transform="translate(0 1.422)"
      />
      <path
        data-name="Line 2"
        transform="translate(9.244)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 3"
        transform="translate(3.556)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 4"
        transform="translate(0 5.689)"
        strokeLinejoin="round"
        d="M0 0L12.8 0"
      />
    </g>
  </svg>
);

export const dateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g
      data-name="Group 18386"
      stroke="#ced2d9"
      strokeLinecap="round"
    >
      <g
        fill="none"
        strokeWidth={1.4}
        transform="translate(.7 .7)"
      >
        <rect
          data-name="Rectangle 10"
          width={12.8}
          height={12.8}
          rx={2}
          transform="translate(0 1.422)"
        />
        <path
          data-name="Line 2"
          transform="translate(9.244)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 3"
          transform="translate(3.556)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 4"
          transform="translate(0 5.689)"
          strokeLinejoin="round"
          d="M0 0L12.8 0"
        />
      </g>
      <g
        data-name="Ellipse 1"
        transform="translate(.7 .7) translate(7.944 9.244)"
        fill="#ced2d9"
        strokeWidth={1}
      >
        <circle
          cx={1.422}
          cy={1.422}
          r={1.422}
          stroke="none"
        />
        <circle
          cx={1.422}
          cy={1.422}
          r={0.922}
          fill="none"
        />
      </g>
    </g>
  </svg>
);

export const caretArrowIcon = (
  <svg
    width={11}
    height={6}
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.372 0l5.276 5.078L10.924 0H.372z"
      fill="#6f7070"
    />
  </svg>
);

export const userIcon = (
  <svg
    width={26}
    height={21}
    viewBox="0 0 26 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.53 19.515v-2.006a3.936 3.936 0 00-1.22-2.836 4.252 4.252 0 00-2.947-1.175H6.028a4.251 4.251 0 00-2.947 1.175 3.936 3.936 0 00-1.22 2.836v2.006M9.82 9c2.009 0 3.637-1.79 3.637-4S11.829 1 9.82 1C7.812 1 6.184 2.79 6.184 5S7.812 9 9.82 9zM24.783 19.514v-2.005c-.001-.889-.308-1.752-.874-2.455a4.183 4.183 0 00-2.252-1.426M17.49 1.595c.895.221 1.69.723 2.256 1.427.567.703.875 1.568.875 2.458 0 .89-.308 1.755-.875 2.458a4.183 4.183 0 01-2.256 1.427"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const penIcon = (
  <svg
    width={23}
    height={22}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.384 2.314a2.952 2.952 0 012.032-.774c.756.007 1.479.3 2.014.815a2.73 2.73 0 01.846 1.938 2.727 2.727 0 01-.805 1.955L6.677 19.528 1.057 21l1.532-5.41L16.385 2.315z"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const trashIcon = (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.425 5h18.702M6.62 5V3c0-.53.22-1.04.609-1.414A2.12 2.12 0 018.699 1h4.155c.552 0 1.08.21 1.47.586.39.375.608.884.608 1.414v2m3.117 0v14c0 .53-.218 1.04-.608 1.414a2.12 2.12 0 01-1.47.586H5.581a2.12 2.12 0 01-1.47-.586A1.963 1.963 0 013.504 19V5H18.05z"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const editPencilIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.142}
    height={12.999}
    viewBox="0 0 13.142 12.999"
  >
    <path
      d="M9.474 1.184a1.656 1.656 0 012.34 2.344l-7.9 7.9-3.214.87.877-3.217z"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const customiseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.4}
    height={13.4}
    viewBox="0 0 11.4 13.4"
  >
    <g
      transform="rotate(90 7.167 6.69)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 827"
        transform="translate(3.176 9.157)"
        d="M0 4L0 0"
      />
      <path
        data-name="Line 828"
        transform="translate(3.176 3.157)"
        d="M0 4L0 0"
      />
      <path
        data-name="Line 829"
        transform="translate(7.176 8.157)"
        d="M0 5L0 0"
      />
      <path
        data-name="Line 830"
        transform="translate(7.176 3.157)"
        d="M0 3L0 0"
      />
      <path
        data-name="Line 831"
        transform="translate(11.176 10.157)"
        d="M0 3L0 0"
      />
      <path
        data-name="Line 832"
        transform="translate(11.176 3.157)"
        d="M0 5L0 0"
      />
      <path
        data-name="Line 833"
        transform="translate(1.176 9.158)"
        d="M0 0L4 0"
      />
      <path
        data-name="Line 834"
        transform="translate(5.176 6.158)"
        d="M0 0L4 0"
      />
      <path
        data-name="Line 835"
        transform="translate(9.176 10.158)"
        d="M0 0L4 0"
      />
    </g>
  </svg>
);

export const boldTextIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.244}
    height={13.378}
    viewBox="0 0 11.244 13.378"
  >
    <g
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path
        data-name="Path 21620"
        d="M0 0h5.689a2.844 2.844 0 010 5.689H0z"
        transform="translate(1 1)"
      />
      <path
        data-name="Path 21621"
        d="M0 5.689h6.4a2.844 2.844 0 010 5.689H0z"
        transform="translate(1 1)"
      />
    </g>
  </svg>
);

export const italicTextIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.356}
    height={13.18}
    viewBox="0 0 11.356 13.18"
  >
    <g
      transform="translate(.7 .901)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 251"
        transform="translate(3.556)"
        d="M6.4 0L0 0"
      />
      <path
        data-name="Line 252"
        transform="translate(0 11.378)"
        d="M6.4 0L0 0"
      />
      <path
        data-name="Line 253"
        transform="translate(2.844)"
        d="M4.267 0L0 11.378"
      />
    </g>
  </svg>
);

export const underlineTextIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.778}
    height={14.2}
    viewBox="0 0 12.778 14.2"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21624"
        d="M1.422 0v4.978a4.267 4.267 0 108.533 0V0"
      />
      <path
        data-name="Line 261"
        transform="translate(0 12.8)"
        d="M0 0L11.378 0"
      />
    </g>
  </svg>
);

export const alignLeftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={9.933}
    viewBox="0 0 14.2 9.933"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 243"
        transform="translate(0 2.844)"
        d="M9.956 0L0 0"
      />
      <path
        data-name="Line 244"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 245"
        transform="translate(0 5.689)"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 246"
        transform="translate(0 8.533)"
        d="M9.956 0L0 0"
      />
    </g>
  </svg>
);

export const alignCentertIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={9.933}
    viewBox="0 0 14.2 9.933"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 239"
        transform="translate(2.133 2.844)"
        d="M8.533 0L0 0"
      />
      <path
        data-name="Line 240"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 241"
        transform="translate(0 5.689)"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 242"
        transform="translate(2.133 8.533)"
        d="M8.533 0L0 0"
      />
    </g>
  </svg>
);

export const alignRightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={9.933}
    viewBox="0 0 14.2 9.933"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 247"
        transform="translate(2.844 2.844)"
        d="M9.956 0L0 0"
      />
      <path
        data-name="Line 248"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 249"
        transform="translate(0 5.689)"
        d="M12.8 0L0 0"
      />
      <path
        data-name="Line 250"
        transform="translate(2.844 8.533)"
        d="M9.956 0L0 0"
      />
    </g>
  </svg>
);

export const editorFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.49}
    height={14.49}
    viewBox="0 0 14.49 14.49"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 857"
        width={12.8}
        height={12.8}
        rx={2}
      />
      <circle
        data-name="Ellipse 149"
        cx={1.067}
        cy={1.067}
        r={1.067}
        transform="translate(2.844 2.844)"
      />
      <path
        data-name="Path 21622"
        d="M12.8 8.534L9.244 4.978 1.422 12.8"
      />
    </g>
  </svg>
);

export const editorLinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.044}
    height={8.511}
    viewBox="0 0 17.044 8.511"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21623"
        d="M9.956 0h2.133a3.556 3.556 0 110 7.111H9.956m-4.267 0H3.556a3.556 3.556 0 110-7.111h2.133"
      />
      <path
        data-name="Line 254"
        transform="translate(4.978 3.556)"
        d="M0 0L5.689 0"
      />
    </g>
  </svg>
);

export const editorListIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={9.933}
    viewBox="0 0 14.2 9.933"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 255"
        transform="translate(3.556)"
        d="M0 0L9.244 0"
      />
      <path
        data-name="Line 256"
        transform="translate(3.556 4.267)"
        d="M0 0L9.244 0"
      />
      <path
        data-name="Line 257"
        transform="translate(3.556 8.533)"
        d="M0 0L9.244 0"
      />
      <path
        data-name="Line 258"
        d="M0 0L0.007 0"
      />
      <path
        data-name="Line 259"
        transform="translate(0 4.267)"
        d="M0 0L0.007 0"
      />
      <path
        data-name="Line 260"
        transform="translate(0 8.533)"
        d="M0 0L0.007 0"
      />
    </g>
  </svg>
);

export const externalLinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.823}
    height={13.535}
    viewBox="0 0 13.823 13.535"
  >
    <g
      transform="translate(.7 .035)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21436"
        d="M10.667 7.111v4.267A1.422 1.422 0 019.245 12.8H1.422A1.422 1.422 0 010 11.377V3.555a1.422 1.422 0 011.422-1.422h4.267"
      />
      <path
        data-name="Path 21437"
        d="M8.885.747h3.361v3.36"
      />
      <path
        data-name="Line 123"
        transform="translate(5.133 .955)"
        d="M0 7L7 0"
      />
    </g>
  </svg>
);

export const tagCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.764}
    height={7.764}
    viewBox="0 0 7.764 7.764"
  >
    <g
      data-name="Group 18380"
      fill="none"
      stroke="#979ba3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21632"
        d="M5.784 0L0 5.784"
        transform="translate(.99 .99)"
      />
      <path
        data-name="Path 21633"
        d="M5.784 5.784L0 0"
        transform="translate(.99 .99)"
      />
    </g>
  </svg>
);

export const previewContentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.823}
    height={13.535}
    viewBox="0 0 13.823 13.535"
  >
    <g
      transform="translate(.7 .035)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21436"
        d="M10.667 7.111v4.267A1.422 1.422 0 019.245 12.8H1.422A1.422 1.422 0 010 11.377V3.555a1.422 1.422 0 011.422-1.422h4.267"
      />
      <path
        data-name="Path 21437"
        d="M8.885.747h3.361v3.36"
      />
      <path
        data-name="Line 123"
        transform="translate(5.133 .955)"
        d="M0 7L7 0"
      />
    </g>
  </svg>
);

export const checkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.241}
    height={10.948}
    viewBox="0 0 15.241 10.948"
  >
    <path
      d="M16.413 6l-8.534 8.534L4 10.655"
      transform="translate(-2.586 -4.586)"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
    />
  </svg>
);

export const smallEditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.142}
    height={12.999}
    viewBox="0 0 13.142 12.999"
  >
    <path
      d="M10.774 2.656A1.655 1.655 0 0113.114 5l-7.9 7.9L2 13.77l.877-3.217z"
      transform="translate(-1.3 -1.472)"
      fill="none"
      stroke="#6f75bc"
      strokeWidth="1.4"
    />
  </svg>
);

export const resumeEditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.594}
    height={12.999}
    viewBox="0 0 13.594 12.999"
  >
    <g
      fill="none"
      stroke="#6f75bc"
    >
      <path
        data-name="Path 40525"
        d="M12 20h6.1"
        transform="translate(-2.3 -2.179) translate(-2.903 -5.522)"
        strokeWidth="1.4"
      />
      <path
        data-name="Path 40526"
        d="M12.146 3.3a1.437 1.437 0 112.032 2.032L5.71 13.8 3 14.478l.677-2.71z"
        transform="translate(-2.3 -2.179)"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const blackArrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 9.718 4.631"
  >
    <path
      data-name="Path 40581"
      d="M7.756 2.95L3.879 0 0 2.95"
      transform="rotate(180 4.369 1.966)"
      fill="none"
      stroke="#13171f"
      strokeWidth="1.4"
    />
  </svg>
);
export const blueArrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 9.718 4.631"
  >
    <path
      data-name="Path 40581"
      d="M7.756 2.95L3.879 0 0 2.95"
      transform="rotate(180 4.369 1.966)"
      fill="none"
      stroke="#6f75bc"
      strokeWidth="1.4"
    />
  </svg>
);

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.825}
    height={15.536}
    viewBox="0 0 14.825 15.536"
  >
    <g
      transform="translate(1.034 1.745)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 39"
        cx={6}
        cy={6}
        r={6}
        transform="translate(-.334 -1.045)"
      />
      <path
        data-name="Line 73"
        transform="translate(11.733 11.733)"
        d="M1.067 1.067L0 0"
      />
    </g>
  </svg>
);

export const explainIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
  >
    <g data-name="Group 17745">
      <g
        data-name="Ellipse 34"
        transform="translate(.045 .008) translate(-.045 -.008)"
        fill="#f2f4f7"
        stroke="#13171f"
        strokeWidth={1}
      >
        <circle
          cx={8.5}
          cy={8.5}
          r={8.5}
          stroke="none"
        />
        <circle
          cx={8.5}
          cy={8.5}
          r={8}
          fill="none"
        />
      </g>
      <text
        transform="translate(.045 .008) translate(6.955 11.992)"
        fill="#1b1c21"
        stroke="#000"
        strokeWidth={0.2}
        fontSize={10}
        fontFamily="Nunito-Bold, Nunito"
        fontWeight={700}
      >
        <tspan
          x={0}
          y={0}
        >
          {'i'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const dropdownArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6.119}
    height={11.658}
    viewBox="0 0 6.119 11.658"
  >
    <path
      data-name="Path 21616"
      d="M0 0l4.42 3.71L8.84 0"
      transform="rotate(-90 5.829 4.42)"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const sortingArrowUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="currentColor"
    className="bi bi-arrow-up-short"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 12a.5.5 0 00.5-.5V5.707l2.146 2.147a.5.5 0 00.708-.708l-3-3a.5.5 0 00-.708 0l-3 3a.5.5 0 10.708.708L7.5 5.707V11.5a.5.5 0 00.5.5z"
    />
  </svg>
);

export const sortingArrowDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="currentColor"
    className="bi bi-arrow-down-short"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 4a.5.5 0 01.5.5v5.793l2.146-2.147a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 11.708-.708L7.5 10.293V4.5A.5.5 0 018 4z"
    />
  </svg>
);

export const gridIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={20}
    viewBox="0 0 9 20"
  >
    <g
      data-name="Group 19506"
      fill="#84868b"
      stroke="#84868b"
      strokeWidth={1}
    >
      <g
        data-name="Ellipse 18"
        transform="translate(.483 -.258) translate(-.483 .258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 25"
        transform="translate(.483 -.258) translate(5.517 .258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 19"
        transform="translate(.483 -.258) translate(-.483 6.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 24"
        transform="translate(.483 -.258) translate(5.517 6.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 20"
        transform="translate(.483 -.258) translate(-.483 11.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 23"
        transform="translate(.483 -.258) translate(5.517 11.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 21"
        transform="translate(.483 -.258) translate(-.483 17.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 22"
        transform="translate(.483 -.258) translate(5.517 17.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
    </g>
  </svg>
);

export const fileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.788}
    height={15.636}
    viewBox="0 0 12.788 15.636"
  >
    <g
      fill="none"
      stroke="#ced2d9"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21658"
        d="M6.406 0H1.424A1.424 1.424 0 000 1.424v11.388a1.424 1.424 0 001.424 1.424h8.541a1.424 1.424 0 001.424-1.424v-7.83z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 21659"
        d="M6.406 0v4.982h4.982"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);

export const infoExplainIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.4}
    height={15.4}
    viewBox="0 0 15.4 15.4"
  >
    <g
      transform="translate(-1.3 -1.673)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 36"
        cx={7}
        cy={7}
        r={7}
        transform="translate(2 2.373)"
      />
      <path
        data-name="Line 161"
        transform="translate(9 9.373)"
        d="M0 3L0 0"
      />
      <path
        data-name="Line 162"
        transform="translate(9 6.373)"
        d="M0 0L0 0"
      />
    </g>
  </svg>
);

export const myPortfolioLogo = (
  <svg
    className="portfolio-logo"
    width={150}
    height={32}
    viewBox="0 0 624 147"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill="url(#pattern0)"
      d="M0 0H624V147H0z"
    />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_6_4"
          transform="scale(.0016 .0068)"
        />
      </pattern>
      <image
        id="image0_6_4"
        width={624}
        height={147}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const featherFolderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.409}
    height={10.271}
    viewBox="0 0 11.409 10.271"
  >
    <path
      data-name="Icon feather-folder"
      d="M10.709 8.586a.993.993 0 01-1 .986H1.7a.993.993 0 01-1-.986v-6.9A.993.993 0 011.7.7h2.5l1 1.479h4.5a.993.993 0 011 .986z"
      fill="#eaebf5"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const openBookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.2}
    height={10.972}
    viewBox="0 0 12.2 10.972"
  >
    <g
      fill="#eaebf5"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 17"
        d="M0 0h3.24A2.144 2.144 0 015.4 2.127v7.445a1.608 1.608 0 00-1.62-1.6H0z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 18"
        d="M10.8 0H7.56A2.144 2.144 0 005.4 2.127v7.445a1.608 1.608 0 011.62-1.6h3.78z"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);

export const filesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9.478}
    height={11.344}
    viewBox="0 0 9.478 11.344"
  >
    <g
      fill="#eaebf5"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 39"
        d="M4.544 0H1.01A1 1 0 000 .994V8.95a1 1 0 001.01.994h6.058a1 1 0 001.01-.994V3.48z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 40"
        d="M4.544 0v3.48h3.534"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);

export const blackArrowLeftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 9.718 4.631"
  >
    <path
      data-name="Path 40581"
      d="M7.756 2.95L3.879 0 0 2.95"
      transform="rotate(-90 3.369 1.966)"
      fill="none"
      stroke="#13171f"
      strokeWidth="1.4"
    />
  </svg>
);

export const subtractionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={9}
    viewBox="0 0 9 9"
  >
    <path
      data-name="Subtraction 1"
      d="M19201.064-4122h-1.125v-.887a3.609 3.609 0 01-2.021-1.028 3.611 3.611 0 01-1.029-2.021h-.889v-1.125h.889a3.626 3.626 0 011.029-2.023 3.621 3.621 0 012.021-1.03v-.886h1.125v.886a3.635 3.635 0 012.02 1.03 3.648 3.648 0 011.029 2.023h.887v1.125h-.887a3.641 3.641 0 01-1.029 2.021 3.62 3.62 0 01-2.02 1.028v.886zm-3.031-3.936a2.545 2.545 0 001.906 1.906v-.625a1.934 1.934 0 00.561.083 1.951 1.951 0 00.563-.083v.625a2.553 2.553 0 001.9-1.906h-.625a1.9 1.9 0 00.084-.564 1.889 1.889 0 00-.084-.561h.625a2.541 2.541 0 00-1.9-1.906v.624a1.922 1.922 0 00-.564-.084 1.9 1.9 0 00-.561.083v-.623a2.536 2.536 0 00-1.906 1.906h.623a1.887 1.887 0 00-.084.561 1.906 1.906 0 00.084.564z"
      transform="translate(-19196 4131.001)"
      fill="#8b90c9"
    />
  </svg>
);

export const uploadfileIcon = (
  <svg
    data-name="Group 19034"
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={19}
    viewBox="0 0 19.155 19.155"
  >
    <g
      data-name="Ellipse 94"
      fill="#fff"
      stroke="#1b1c21"
      strokeLinecap="round"
      strokeWidth={1}
    >
      <ellipse
        cx={9.578}
        cy={9.578}
        rx={9.578}
        ry={9.578}
        stroke="none"
      />
      <ellipse
        cx={9.578}
        cy={9.578}
        rx={9.078}
        ry={9.078}
        fill="none"
      />
    </g>
    <path
      data-name="Path 21524"
      d="M9.603 7.444v5.513"
      fill="none"
      stroke="#1b1c21"
      strokeLinecap="round"
      strokeWidth={1.4}
    />
    <path
      data-name="Path 21525"
      d="M6.812 9.079l2.882-2.882 2.882 2.882"
      fill="none"
      stroke="#1b1c21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const videoPlayIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
  >
    <g
      id="Group_19880"
      data-name="Group 19880"
      transform="translate(15068 -4879)"
    >
      <circle
        id="Ellipse_324"
        data-name="Ellipse 324"
        cx="17"
        cy="17"
        r="17"
        transform="translate(-15068 4879)"
        fill="#fff"
      />
      <path
        id="FontAwsome_play_"
        data-name="FontAwsome (play)"
        d="M10.67,5.429,1.82.2A1.2,1.2,0,0,0,0,1.235V11.7a1.206,1.206,0,0,0,1.82,1.038l8.85-5.229a1.206,1.206,0,0,0,0-2.077Z"
        transform="translate(-15056 4889.531)"
        fill="#8aa0fd"
      />
    </g>
  </svg>
);

export const tickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.241}
    height={10.948}
    viewBox="0 0 15.241 10.948"
  >
    <path
      d="M16.413 6l-8.534 8.534L4 10.655"
      transform="translate(-2.586 -4.586)"
      fill="none"
      stroke="#6F75BC"
      strokeWidth="2"
    />
  </svg>
);

export const messageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.459}
    height={13.459}
    viewBox="0 0 13.459 13.459"
  >
    <path
      d="M12.759 8.74a1.34 1.34 0 01-1.34 1.34H3.38L.7 12.759V2.04A1.34 1.34 0 012.04.7h9.379a1.34 1.34 0 011.34 1.34z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const plusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={8}
    viewBox="0 0 9.8 9.8"
    className="plus-icon"
  >
    <g
      data-name="Group 19766"
      transform="translate(-276.6 -233.6)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeWidth={1.8}
    >
      <path
        data-name="Line 917"
        transform="translate(281.5 234.5)"
        d="M0 0L0 8"
      />
      <path
        data-name="Line 918"
        transform="translate(277.5 238.5)"
        d="M8 0L0 0"
      />
    </g>
  </svg>
);

export const loginLightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.686}
    height={14.781}
    viewBox="0 0 13.686 14.781"
  >
    <path
      d="M10.1 0a3.186 3.186 0 013.182 3.182v8.009a3.194 3.194 0 01-3.19 3.19H6.584A3.185 3.185 0 013.4 11.2v-.677a.54.54 0 111.079 0v.677a2.106 2.106 0 002.1 2.1H10.1a2.113 2.113 0 002.111-2.111V3.182a2.106 2.106 0 00-2.1-2.1H6.592a2.112 2.112 0 00-2.11 2.11v.671a.54.54 0 01-1.079 0v-.675A3.192 3.192 0 016.592 0zM7.472 4.712l2.106 2.1a.543.543 0 01.048.055l-.048-.055a.529.529 0 01.075.093l.014.025a.326.326 0 01.021.041L9.7 7a.323.323 0 01.015.042l.008.034a.308.308 0 01.008.041v.02a.375.375 0 010 .057l-.005.057v.02l.006-.077a.54.54 0 01-.013.118l-.01.034a.321.321 0 01-.013.042l-.013.029a.326.326 0 01-.02.041l-.015.024a.336.336 0 01-.027.039l-.019.023a.338.338 0 01-.029.031l-2.106 2.1a.541.541 0 11-.755-.775l1.179-1.17H.539a.54.54 0 110-1.079h7.352L6.712 5.475a.54.54 0 01.761-.764z"
      fill="#6f75bc"
      stroke="#6f75bc"
      strokeWidth={0.4}
      fillRule="evenodd"
      transform="translate(-2.8 -1.8) translate(3 2)"
      data-name="Iconly/Light-Outline/Login"
    />
  </svg>
);

export const viewProfileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.067}
    height={13.4}
    viewBox="0 0 12.067 13.4"
  >
    <g
      transform="translate(-3.3 -2.3)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21410"
        d="M14.667 15v-1.333A2.667 2.667 0 0012 11H6.667A2.667 2.667 0 004 13.667V15"
      />
      <circle
        data-name="Ellipse 35"
        cx={2.667}
        cy={2.667}
        r={2.667}
        transform="translate(6.667 3)"
      />
    </g>
  </svg>
);

export const deactivateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.685}
    height={13.685}
    viewBox="0 0 13.685 13.685"
  >
    <path
      data-name="FontAwsome (ban)"
      d="M14.842 8a6.842 6.842 0 106.842 6.842A6.842 6.842 0 0014.842 8zm3.59 3.253a5.077 5.077 0 01.57 6.5l-7.072-7.072a5.077 5.077 0 016.5.57zm-7.179 7.179a5.077 5.077 0 01-.57-6.5L17.754 19a5.077 5.077 0 01-6.501-.568z"
      transform="translate(-8 -8)"
      fill="#6f75bc"
    />
  </svg>
);

export const eventCalendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.469}
    height={15.622}
    viewBox="0 0 14.469 15.622"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#ced2d9"
      strokeLinecap="round"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 10"
        width={13.069}
        height={12.8}
        rx={2}
        transform="translate(0 1.422)"
      />
      <path
        data-name="Line 2"
        transform="translate(9.439)"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 3"
        transform="translate(3.63)"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 4"
        transform="translate(0 5.689)"
        strokeLinejoin="round"
        d="M0 0L13.069 0"
      />
    </g>
  </svg>
);

export const bookmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.612}
    height={14.126}
    viewBox="0 0 11.612 14.126"
  >
    <path
      d="M7.7 0c2.232 0 3.513 1.1 3.513 3.03v9.565a1.119 1.119 0 01-1.667.974l-3.923-2.216-3.958 2.22A1.119 1.119 0 010 12.6V2.909C0 1.06 1.281 0 3.515 0zm0 .987H3.515C1.838.987.987 1.633.987 2.909V12.6a.124.124 0 00.065.113.123.123 0 00.13 0l4.2-2.356a.5.5 0 01.484 0l4.163 2.352a.123.123 0 00.131 0 .126.126 0 00.064-.113V2.955C10.22 2.388 10.11.987 7.7.987zm.289 3.44a.494.494 0 010 .987H3.173a.494.494 0 110-.987z"
      fill="#6f75bc"
      stroke="#6f75bc"
      strokeWidth={0.4}
      fillRule="evenodd"
      transform="translate(-2.8 -1.8) translate(3 2)"
      data-name="Iconly/Light-Outline/Bookmark"
    />
  </svg>
);

export const dashUserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 12.067 13.4"
  >
    <g
      transform="translate(-3.3 -2.3)"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21410"
        d="M14.667 15v-1.333A2.667 2.667 0 0012 11H6.667A2.667 2.667 0 004 13.667V15"
      />
      <circle
        data-name="Ellipse 35"
        cx={2.667}
        cy={2.667}
        r={2.667}
        transform="translate(6.667 3)"
      />
    </g>
  </svg>
);

export const thumbnailPrimaryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
  >
    <defs>
      <clipPath id="a">
        <rect
          data-name="Rectangle 1285"
          width={32}
          height={32}
          rx={16}
          fill="#6877c6"
        />
      </clipPath>
    </defs>
    <g
      data-name="Group 19148"
      transform="translate(21033 -7974) translate(-21033 7974)"
    >
      <rect
        data-name="Rectangle 173"
        width={32}
        height={32}
        rx={16}
        fill="#6877c6"
      />
      <g
        data-name="Mask Group 2"
        clipPath="url(#a)"
        fill="rgba(255,255,255,0)"
        stroke="#7887d9"
        strokeWidth={1}
      >
        <g data-name="Group 18161">
          <path
            data-name="Path 40503"
            d="M0 0c3.368 0 3.368 3.1 6.736 3.1S10.104 0 13.473 0s3.367 3.1 6.736 3.1S23.577 0 26.945 0s3.368 3.1 6.737 3.1S37.05 0 40.419 0s3.368 3.1 6.736 3.1S50.523 0 53.892 0s3.368 3.1 6.737 3.1S63.997 0 67.366 0s3.368 3.1 6.737 3.1"
            transform="translate(6.606 5.938)"
          />
          <path
            data-name="Path 40504"
            d="M0 3.386c3.368 0 3.368 3.1 6.736 3.1s3.368-3.1 6.737-3.1 3.367 3.1 6.736 3.1 3.368-3.1 6.736-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.736 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1"
            transform="translate(6.606 5.938)"
          />
        </g>
        <circle
          data-name="Ellipse 118"
          cx={8}
          cy={8}
          r={8}
          transform="translate(-3.2 21.6)"
        />
      </g>
    </g>
  </svg>
);

export const thumbnailSecondaryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
  >
    <defs>
      <clipPath id="a">
        <rect
          data-name="Rectangle 1593"
          width={32}
          height={32}
          rx={16}
          fill="#6877c6"
        />
      </clipPath>
    </defs>
    <g data-name="Group 19155">
      <g
        data-name="Group 18458"
        transform="translate(21033 -8102) translate(-21033 8102)"
      >
        <rect
          data-name="Rectangle 730"
          width={32}
          height={32}
          rx={16}
          fill="#8bbfc6"
        />
        <g
          data-name="Mask Group 83"
          clipPath="url(#a)"
          fill="rgba(255,255,255,0)"
          stroke="#acdae0"
          strokeWidth={1}
        >
          <g data-name="Group 18401">
            <path
              data-name="Path 40513"
              d="M0 0c3.368 0 3.368 3.1 6.736 3.1S10.104 0 13.473 0s3.367 3.1 6.736 3.1S23.577 0 26.945 0s3.368 3.1 6.737 3.1S37.05 0 40.419 0s3.368 3.1 6.736 3.1S50.523 0 53.892 0s3.368 3.1 6.737 3.1S63.997 0 67.366 0s3.368 3.1 6.737 3.1"
              transform="translate(-55.376 6.934)"
            />
            <path
              data-name="Path 40514"
              d="M0 3.386c3.368 0 3.368 3.1 6.736 3.1s3.368-3.1 6.737-3.1 3.367 3.1 6.736 3.1 3.368-3.1 6.736-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.736 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1"
              transform="translate(-55.376 6.934)"
            />
          </g>
          <ellipse
            data-name="Ellipse 252"
            cx={7.6}
            cy={8}
            rx={7.6}
            ry={8}
            transform="translate(8 26.4)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const thumbnailInfoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
  >
    <defs>
      <clipPath id="a">
        <rect
          data-name="Rectangle 1287"
          width={32}
          height={32}
          rx={16}
          fill="#6877c6"
        />
      </clipPath>
    </defs>
    <g data-name="Group 19151">
      <g
        data-name="Group 18459"
        transform="translate(21033 -8038) translate(-21033 8038)"
      >
        <rect
          data-name="Rectangle 727"
          width={32}
          height={32}
          rx={16}
          fill="#7295c4"
        />
        <g
          data-name="Mask Group 4"
          clipPath="url(#a)"
          fill="rgba(255,255,255,0)"
          stroke="#8fb2e2"
          strokeWidth={1}
        >
          <g data-name="Group 18163">
            <path
              data-name="Path 40507"
              d="M0 0c3.368 0 3.368 3.1 6.736 3.1S10.104 0 13.473 0s3.367 3.1 6.736 3.1S23.577 0 26.945 0s3.368 3.1 6.737 3.1S37.05 0 40.419 0s3.368 3.1 6.736 3.1S50.523 0 53.892 0s3.368 3.1 6.737 3.1S63.997 0 67.366 0s3.368 3.1 6.737 3.1"
              transform="translate(-20.511 20.116)"
            />
            <path
              data-name="Path 40508"
              d="M0 3.386c3.368 0 3.368 3.1 6.736 3.1s3.368-3.1 6.737-3.1 3.367 3.1 6.736 3.1 3.368-3.1 6.736-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.736 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1 3.368-3.1 6.737-3.1 3.368 3.1 6.737 3.1"
              transform="translate(-20.511 20.116)"
            />
          </g>
          <circle
            data-name="Ellipse 120"
            cx={8}
            cy={8}
            r={8}
            transform="translate(20.8 -6.4)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const primaryLineSvg = (
  <svg
    width={60}
    height={30}
    viewBox="0 0 1000 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14.997c12.6.55 37.8-3.07 63 2.745 25.2 5.815 37.8 12.946 63 26.329 25.2 13.383 37.8 35.687 63 40.586 25.2 4.899 37.8-28.135 63-16.09 25.2 12.044 37.8 54.286 63 76.312 25.2 22.027 37.8 19.735 63 33.82 25.2 14.084 37.8 44.589 63 36.6 25.2-7.987 37.8-82.275 63-76.54 25.2 5.735 37.8 92.023 63 105.214 25.2 13.192 37.8-39.406 63-39.256 25.2.15 37.8 37.322 63 40.006 25.2 2.685 37.8-24.392 63-26.582 25.2-2.19 37.8-16.726 63 15.631 25.2 32.358 37.8 129.176 63 146.156 25.2 16.98 37.8-40.982 63-61.256 25.2-20.274 50.4-32.09 63-40.114L1000 500H0z"
      fill="#6877c61a"
    />
    <path
      d="M0 14.997c12.6.55 37.8-3.07 63 2.745 25.2 5.815 37.8 12.946 63 26.329 25.2 13.383 37.8 35.687 63 40.586 25.2 4.899 37.8-28.135 63-16.09 25.2 12.044 37.8 54.286 63 76.312 25.2 22.027 37.8 19.735 63 33.82 25.2 14.084 37.8 44.589 63 36.6 25.2-7.987 37.8-82.275 63-76.54 25.2 5.735 37.8 92.023 63 105.214 25.2 13.192 37.8-39.406 63-39.256 25.2.15 37.8 37.322 63 40.006 25.2 2.685 37.8-24.392 63-26.582 25.2-2.19 37.8-16.726 63 15.631 25.2 32.358 37.8 129.176 63 146.156 25.2 16.98 37.8-40.982 63-61.256 25.2-20.274 50.4-32.09 63-40.114"
      fill="none"
      stroke="#6877c6"
      strokeWidth="10px"
    />
  </svg>
);

export const secondaryLineSvg = (
  <svg
    width={60}
    height={30}
    viewBox="0 0 1000 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 101.866c7.2 7.432 21.6-4.15 36 37.162 14.4 41.313 21.6 182.798 36 169.402 14.4-13.397 21.6-240.077 36-236.383 14.4 3.694 21.6 230.841 36 254.854 14.4 24.013 21.6-104.815 36-134.79 14.4-29.975 21.6 4.273 36-15.085 14.4-19.358 21.6-70.309 36-81.705 14.4-11.395 21.6-13.247 36 24.727 14.4 37.975 21.6 156.166 36 165.147 14.4 8.98 21.6-100.074 36-120.241 14.4-20.167 21.6 32.821 36 19.407 14.4-13.413 21.6-64.776 36-86.476 14.4-21.7 21.6-54.292 36-22.024 14.4 32.267 21.6 129.508 36 183.36 14.4 53.853 21.6 107.4 36 85.901 14.4-21.499 21.6-182.72 36-193.396 14.4-10.677 21.6 130.11 36 140.012 14.4 9.904 21.6-52.04 36-90.496 14.4-38.456 21.6-84.952 36-101.785 14.4-16.833 21.6-11.667 36 17.62 14.4 29.289 21.6 134.257 36 128.82 14.4-5.438 21.6-163.349 36-156.005 14.4 7.343 21.6 138.388 36 192.723 14.4 54.334 21.6 63.235 36 78.95 14.4 15.716 21.6-2.464 36-.374 14.4 2.09 21.6 33.17 36 10.826 14.4-22.344 21.6-106.15 36-122.544 14.4-16.394 28.8 32.46 36 40.575L1000 500H0z"
      fill="#f67c521a"
    />
    <path
      d="M0 101.866c7.2 7.432 21.6-4.15 36 37.162 14.4 41.313 21.6 182.798 36 169.402 14.4-13.397 21.6-240.077 36-236.383 14.4 3.694 21.6 230.841 36 254.854 14.4 24.013 21.6-104.815 36-134.79 14.4-29.975 21.6 4.273 36-15.085 14.4-19.358 21.6-70.309 36-81.705 14.4-11.395 21.6-13.247 36 24.727 14.4 37.975 21.6 156.166 36 165.147 14.4 8.98 21.6-100.074 36-120.241 14.4-20.167 21.6 32.821 36 19.407 14.4-13.413 21.6-64.776 36-86.476 14.4-21.7 21.6-54.292 36-22.024 14.4 32.267 21.6 129.508 36 183.36 14.4 53.853 21.6 107.4 36 85.901 14.4-21.499 21.6-182.72 36-193.396 14.4-10.677 21.6 130.11 36 140.012 14.4 9.904 21.6-52.04 36-90.496 14.4-38.456 21.6-84.952 36-101.785 14.4-16.833 21.6-11.667 36 17.62 14.4 29.289 21.6 134.257 36 128.82 14.4-5.438 21.6-163.349 36-156.005 14.4 7.343 21.6 138.388 36 192.723 14.4 54.334 21.6 63.235 36 78.95 14.4 15.716 21.6-2.464 36-.374 14.4 2.09 21.6 33.17 36 10.826 14.4-22.344 21.6-106.15 36-122.544 14.4-16.394 28.8 32.46 36 40.575"
      fill="none"
      stroke="#F67C52"
      strokeWidth="10px"
    />
  </svg>
);

export const longArrowUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="#55c172"
    className="bi bi-arrow-up-short"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 12a.5.5 0 00.5-.5V5.707l2.146 2.147a.5.5 0 00.708-.708l-3-3a.5.5 0 00-.708 0l-3 3a.5.5 0 10.708.708L7.5 5.707V11.5a.5.5 0 00.5.5z"
    />
  </svg>
);

export const longArrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="#f67c52"
    className="bi bi-arrow-down-short"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 4a.5.5 0 01.5.5v5.793l2.146-2.147a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 11.708-.708L7.5 10.293V4.5A.5.5 0 018 4z"
    />
  </svg>
);

export const StarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.75}
    height={10.22}
    viewBox="0 0 10.75 10.22"
  >
    <path
      d="M5.114.787a.247.247 0 00-.228.138L3.929 2.84a1.038 1.038 0 01-.782.561L1 3.71a.245.245 0 00-.2.169.232.232 0 00.063.244l1.551 1.49a1.024 1.024 0 01.3.915l-.365 2.1a.234.234 0 00.1.234.248.248 0 00.271.02l1.917-.994a1.051 1.051 0 01.963 0l1.917.993a.254.254 0 00.272-.02.234.234 0 00.1-.234l-.366-2.1a1.024 1.024 0 01.3-.915l1.551-1.49a.23.23 0 00.063-.244.243.243 0 00-.2-.169L7.081 3.4a1.037 1.037 0 01-.781-.561L5.341.925a.246.246 0 00-.227-.138M2.595 9.7a1.043 1.043 0 01-.616-.2 1.02 1.02 0 01-.406-1l.365-2.1a.238.238 0 00-.071-.213L.317 4.691A1.017 1.017 0 01.05 3.639a1.028 1.028 0 01.841-.707l2.144-.309a.249.249 0 00.19-.135L4.183.572A1.034 1.034 0 015.114 0h0a1.034 1.034 0 01.931.572L7 2.487a.25.25 0 00.189.135l2.144.309a1.028 1.028 0 01.841.707 1.017 1.017 0 01-.268 1.052L8.355 6.18a.238.238 0 00-.07.212l.366 2.1a1.02 1.02 0 01-.407 1 1.035 1.035 0 01-1.1.083l-1.916-.993a.261.261 0 00-.24 0l-1.916.993a1.044 1.044 0 01-.483.119"
      fill="#6f75bc"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeWidth={0.5}
      fillRule="evenodd"
      transform="translate(.261 .25)"
      data-name="Iconly/Light-Outline/Star"
    />
  </svg>
);

export const mandatoryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.22}
    height={22.614}
    viewBox="0 0 19.22 22.614"
  >
    <g data-name="Group 19888">
      <g
        stroke="#6f75bc"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 21658"
          d="M7.042 0H1.565A1.565 1.565 0 000 1.565v12.519a1.565 1.565 0 001.565 1.565h9.389a1.565 1.565 0 001.565-1.565V5.477z"
          fill="#eaebf5"
          transform="translate(-279.976 -941.935) translate(280.676 948.2)"
        />
        <path
          data-name="Path 21659"
          d="M7.042 0v5.477h5.477"
          fill="none"
          transform="translate(-279.976 -941.935) translate(280.676 948.2)"
        />
      </g>
      <text
        data-name="*"
        transform="translate(-279.976 -941.935) translate(292.195 955.935)"
        fill="#e86d40"
        fontSize={14}
        fontFamily="SofiaPro-Black, Sofia Pro"
        fontWeight={800}
      >
        <tspan
          x={0}
          y={0}
        >
          {'*'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const PathwayIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.22}
    height={22.614}
    viewBox="0 0 19.22 22.614"
  >
    <g data-name="Group 19888">
      <g
        stroke="#6f75bc"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 21658"
          d="M7.042 0H1.565A1.565 1.565 0 000 1.565v12.519a1.565 1.565 0 001.565 1.565h9.389a1.565 1.565 0 001.565-1.565V5.477z"
          fill="#eaebf5"
          transform="translate(-279.976 -941.935) translate(280.676 948.2)"
        />
        <path
          data-name="Path 21659"
          d="M7.042 0v5.477h5.477"
          fill="none"
          transform="translate(-279.976 -941.935) translate(280.676 948.2)"
        />
      </g>
      <text
        data-name="*"
        transform="translate(-279.976 -941.935) translate(292.195 955.935)"
        fill="#e86d40"
        fontSize={14}
        fontFamily="SofiaPro-Black, Sofia Pro"
        fontWeight={800}
      ></text>
    </g>
  </svg>
);

export const updateScoreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.964}
    height={8.964}
    viewBox="0 0 8.964 8.964"
  >
    <g
      data-name="Icon feather-upload"
      fill="none"
      stroke="#454b93"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40595"
        d="M12.064 9.543v1.681a.84.84 0 01-.84.84H5.34a.84.84 0 01-.84-.84V9.543"
        transform="translate(-3.8 -3.8)"
      />
      <path
        data-name="Path 40596"
        d="M10.381 6.6l-2.1-2.1-2.1 2.1"
        transform="translate(-3.8 -3.8)"
      />
      <path
        data-name="Path 40597"
        d="M8.282 4.5v5.043"
        transform="translate(-3.8 -3.8)"
      />
    </g>
  </svg>
);

export const envelopeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M0 4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v.217l7 4.2 7-4.2V4a1 1 0 00-1-1H2zm13 2.383l-4.708 2.825L15 11.105V5.383zm-.034 6.876l-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 002 13h12a1 1 0 00.966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z" />
  </svg>
);

export const phoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.718}
    height={12.741}
    viewBox="0 0 12.718 12.741"
  >
    <path
      d="M12.017 9.19v1.71a1.138 1.138 0 01-1.241 1.138 11.261 11.261 0 01-4.911-1.747 11.1 11.1 0 01-3.414-3.417A11.261 11.261 0 01.704 1.94 1.138 1.138 0 011.837.7h1.707a1.138 1.138 0 011.138.979 7.307 7.307 0 00.4 1.6 1.138 1.138 0 01-.256 1.2l-.724.721a9.1 9.1 0 003.414 3.415l.723-.723a1.138 1.138 0 011.2-.256 7.307 7.307 0 001.6.4 1.138 1.138 0 01.979 1.155z"
      fill="rgba(0,0,0,0)"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const memberIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 100-6 3 3 0 000 6zm2-3a2 2 0 11-4 0 2 2 0 014 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

export const sectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 15 15"
  >
    <g
      data-name="Group 20473"
      transform="translate(-19523 14526.988)"
      fill="none"
      stroke="#6f75bc"
      strokeWidth={1.4}
    >
      <g
        data-name="Rectangle 11038"
        transform="translate(19523 -14526.988)"
      >
        <rect
          width={15}
          height={15}
          rx={4}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={13.6}
          height={13.6}
          rx={3.3}
        />
      </g>
      <path
        data-name="Line 1438"
        transform="translate(19528.135 -14526.604)"
        d="M0 0L0 14.222"
      />
      <path
        data-name="Line 1439"
        transform="translate(19528.135 -14517.124)"
        d="M0 0L9.481 0"
      />
      <path
        data-name="Line 1440"
        transform="translate(19532.877 -14526.604)"
        d="M0 9.481L0 0"
      />
    </g>
  </svg>
);

export const courseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.398}
    height={16.4}
    viewBox="0 0 13.398 16.4"
  >
    <g
      data-name="Group 20468"
      fill="none"
      stroke="#6f75bc"
      strokeWidth={1.4}
    >
      <path
        data-name="Rectangle 11029"
        d="M19293.451-14611.686h9a1 1 0 011 1v13a1 1 0 01-1 1h-9a2 2 0 01-2-2v-11a2 2 0 012-2z"
        transform="translate(-19290.752 14612.387)"
      />
      <path
        data-name="Rectangle 11030"
        d="M19293.451-14600.686h9.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-9.5a2 2 0 01-2-2h0a2 2 0 012-2z"
        transform="translate(-19290.752 14612.387)"
      />
    </g>
  </svg>
);

export const questionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
  >
    <g data-name="Group 20469">
      <g
        data-name="Ellipse 424"
        transform="translate(-19302 14547) translate(19302 -14547)"
        fill="none"
        stroke="#6f75bc"
        strokeWidth={1.4}
      >
        <circle
          cx={8.5}
          cy={8.5}
          r={8.5}
          stroke="none"
        />
        <circle
          cx={8.5}
          cy={8.5}
          r={7.8}
        />
      </g>
      <text
        data-name="?"
        transform="translate(-19302 14547) translate(19308 -14534)"
        fill="#6f75bc"
        fontSize={12}
        fontFamily="Lato-Bold, Lato"
        fontWeight={700}
      >
        <tspan
          x={0}
          y={0}
        >
          {'?'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const assignmentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.398}
    height={17.7}
    viewBox="0 0 14.398 17.7"
  >
    <g
      data-name="Group 20471"
      transform="translate(-19280.301 14499.511)"
      fill="none"
      stroke="#6f75bc"
      strokeWidth={1.4}
    >
      <path
        data-name="Subtraction 6"
        d="M19292.5-14482.511h-10a1.5 1.5 0 01-1.5-1.5v-12a1.5 1.5 0 011.5-1.5h1.935v1.356a.8.8 0 00.8.8h4.528a.8.8 0 00.8-.8v-1.356h1.937a1.5 1.5 0 011.5 1.5v12a1.5 1.5 0 01-1.5 1.5z"
      />
      <g
        data-name="Rectangle 11033"
        transform="translate(19284 -14499.511)"
      >
        <rect
          width={7}
          height={5}
          rx={1.5}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={5.6}
          height={3.6}
          rx={0.8}
        />
      </g>
      <path
        data-name="Line 1435"
        transform="translate(19284.223 -14491.256)"
        strokeLinecap="round"
        d="M0 0L6.443 0"
      />
      <path
        data-name="Line 1436"
        transform="translate(19284.223 -14487.573)"
        strokeLinecap="round"
        d="M0 0L6.443 0"
      />
    </g>
  </svg>
);

export const resourcesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.826}
    height={15.285}
    viewBox="0 0 16.826 15.285"
  >
    <path
      data-name="Icon feather-folder"
      d="M16.127 13.042a1.543 1.543 0 01-1.543 1.543H2.242a1.543 1.543 0 01-1.543-1.543V2.243A1.543 1.543 0 012.242.7h3.857l1.542 2.314h6.942a1.543 1.543 0 011.543 1.543z"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const formIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={18}
    viewBox="0 0 17 18"
  >
    <g
      data-name="Group 20470"
      transform="translate(-19302 14500)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
    >
      <g
        data-name="Rectangle 11031"
        transform="translate(19302 -14500)"
      >
        <rect
          width={17}
          height={18}
          rx={3}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={15.6}
          height={16.6}
          rx={2.3}
        />
      </g>
      <path
        data-name="Line 1432"
        transform="translate(19307.5 -14494.899)"
        strokeLinecap="round"
        d="M0 0L6.322 0"
      />
      <path
        data-name="Line 1433"
        transform="translate(19307.5 -14491.19)"
        strokeLinecap="round"
        d="M0 0L6.322 0"
      />
      <path
        data-name="Line 1434"
        transform="translate(19307.5 -14487.479)"
        strokeLinecap="round"
        d="M0 0L4 0"
      />
    </g>
  </svg>
);

export const otjIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    viewBox="0 0 14 15"
  >
    <g
      data-name="Group 20472"
      transform="translate(-19378 14498)"
      fill="none"
      stroke="#6f75bc"
    >
      <g
        data-name="Rectangle 11036"
        transform="translate(19378 -14495)"
        strokeWidth={1.4}
      >
        <rect
          width={14}
          height={12}
          rx={2}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={12.6}
          height={10.6}
          rx={1.3}
        />
      </g>
      <g
        data-name="Rectangle 11037"
        transform="translate(19382 -14498)"
        strokeWidth={1.2}
      >
        <rect
          width={6}
          height={4}
          rx={1}
          stroke="none"
        />
        <rect
          x={0.6}
          y={0.6}
          width={4.8}
          height={2.8}
          rx={0.4}
        />
      </g>
      <path
        data-name="Line 1437"
        transform="translate(19378.5 -14490.5)"
        strokeWidth={1.4}
        d="M0 0L13 0"
      />
    </g>
  </svg>
);

export const cameraIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={17.818}
    viewBox="0 0 20 17.818"
  >
    <path
      d="M13.318.354a2.793 2.793 0 011.366 1.265l.122.212.452.867.015.024.014.021.038.053a1.188 1.188 0 00.778.36A3.9 3.9 0 0120 6.852l.005.2v5.795a4.971 4.971 0 01-4.754 4.965H4.97A4.97 4.97 0 010 13.063V7.052a3.9 3.9 0 013.9-3.9 1.191 1.191 0 00.778-.36l.007-.008.009-.012.049-.072.451-.866A2.965 2.965 0 016.682.354a15.7 15.7 0 016.636 0zM7.237 1.748a1.433 1.433 0 00-.636.646l-.093.161-.385.745-.095.171a2.078 2.078 0 01-.248.341 2.7 2.7 0 01-1.709.838l-.171.006-.164.006a2.4 2.4 0 00-2.23 2.226l-.006.164v5.795a3.47 3.47 0 003.28 3.465l.19.005h10.06a3.471 3.471 0 003.465-3.28l.005-.19V7.052a2.4 2.4 0 00-2.233-2.39l-.167-.006-.174-.007a2.694 2.694 0 01-1.706-.839 2.074 2.074 0 01-.246-.338l-.019-.032-.023-.04-.116-.218-.324-.628a1.867 1.867 0 00-.635-.762l-.094-.045-.119-.04a16.078 16.078 0 00-5.407.041zM10 6.2a3.929 3.929 0 11-3.929 3.929A3.929 3.929 0 0110 6.2zm0 1.5a2.429 2.429 0 102.429 2.429A2.429 2.429 0 0010 7.7zm5.5-2.2a1 1 0 01.117 1.993L15.5 7.5a1 1 0 01-.126-1.993z"
      fill="currentColor"
      transform="translate(-2 -3) translate(2 3)"
      data-name="Iconly/Light-Outline/Camera"
    />
  </svg>
);

export const clockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-clock"
  >
    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
  </svg>
);
export const checkCircleFill = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-check-circle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05z" />
  </svg>
);
export const thumbsUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 235.5 250"
    xmlSpace="preserve"
  >
    <path
      d="M194.9 78.7c-23.9-.2-60.7.1-60.7.1s1-4.2 3.5-38.1c2.5-34.2-39.1-38.9-43.5-38-4.5.9-5.2 3-6.5 6.3-1.3 3.3-27.4 69.4-27.4 69.4s-30.2-.2-37 .6c-9.2.7-19.1 9.7-19.1 20.8V227c2 11.1 10.9 16.6 17.8 19.1 7.5.2 22.5.5 29.5.4 8.2-.2 15.4-7.7 18.5-12 6.8 4.3 27.5 11.9 37.2 11.8 11.5-.1 31.2.4 64 0 29.8-.4 36.6-20.7 38.6-28 3.9-13.7 10-45.6 19.7-80.6 13.1-47.4-19.9-58.8-34.6-59zM57.2 224.5c0 2.3-3 6.1-5.7 6.7-3.2 0-23.2.2-25.3 0-1.9-.4-6.9-1.3-6.7-10.4.1-7 .2-113.5 0-118.4-.2-5 3.5-8.4 6.2-8.4h31.5v130.5zm158.3-94.4c-5.9 23.3-17.9 75.6-21.3 87.2-2.5 8.3-14 13.9-20.6 13.7-13.7-.4-60.4.7-67.6 0-15.6-1.5-26.9-8.9-33.2-12.2.1-4.4 0-131 0-131l28.1-69.9s23.6 3 22.1 24.3c-1.1 15.7-4.4 34.9-4.6 44.4-.1 4.5 3.8 7.4 6.4 7.4 2.7 0 50.6-.3 70.9.3 13.7.5 26.1 11.1 19.8 35.8z"
      fill="currentColor"
    />
  </svg>
);
export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    xmlSpace="preserve"
  >
    <circle
      cx={25}
      cy={25}
      r={25}
      fill="#fff"
    />
    <path
      fill="#13171f"
      d="M31.5 25L18.5 17.5 18.5 32.5z"
    />
  </svg>
);

export const starIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-star-fill"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
  </svg>
);

export const bookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-book"
    viewBox="0 0 16 16"
  >
    <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 000 2.5v11a.5.5 0 00.707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 00.78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0016 13.5v-11a.5.5 0 00-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
  </svg>
);

export const checkCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.072}
    height={12.831}
    viewBox="0 0 13.072 12.831"
  >
    <g
      fill="none"
      stroke="#a4a7ad"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21716"
        d="M11.229 5.106v.517A5.615 5.615 0 117.9.486"
        transform="translate(.853 .822)"
      />
      <path
        data-name="Path 21717"
        d="M11.23 1.126l-5.616 5.62L3.93 5.062"
        transform="translate(.853 .822)"
      />
    </g>
  </svg>
);

export const fileDarkIocn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.925}
    height={13.307}
    viewBox="0 0 10.925 13.307"
  >
    <g
      fill="none"
      stroke="#84868b"
      strokeWidth={1.4}
      data-name="Group 20492"
    >
      <path
        data-name="Path 21658"
        d="M5.358 0H1.191A1.191 1.191 0 000 1.191v9.525a1.191 1.191 0 001.191 1.191h7.144a1.191 1.191 0 001.191-1.191V4.167z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 21659"
        d="M5.358 0v4.167h4.167"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);

export const questionDarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
  >
    <g data-name="Group 20469">
      <g
        data-name="Ellipse 424"
        transform="translate(-19302 14546.875) translate(19302 -14546.875)"
        fill="none"
        stroke="#84868b"
        strokeWidth={1.4}
      >
        <circle
          cx={7}
          cy={7}
          r={7}
          stroke="none"
        />
        <circle
          cx={7}
          cy={7}
          r={6.3}
        />
      </g>
      <text
        data-name="?"
        transform="translate(-19302 14546.875) translate(19307 -14535.875)"
        fill="#84868b"
        fontSize={10}
        fontFamily="Lato-Bold, Lato"
        fontWeight={700}
      >
        <tspan
          x={0}
          y={0}
        >
          {'?'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const assignmentDarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.4}
    height={14.701}
    viewBox="0 0 11.4 14.701"
  >
    <g
      data-name="Group 20471"
      transform="translate(-19280.301 14499.974)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <path
        data-name="Subtraction 6"
        d="M19289.5-14485.974h-7a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h1.142v.925a.8.8 0 00.8.8h3.114a.8.8 0 00.8-.8v-.925h1.144a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5z"
      />
      <g
        data-name="Rectangle 11033"
        transform="translate(19283 -14499.974)"
      >
        <rect
          width={6}
          height={4}
          rx={1.5}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={4.6}
          height={2.6}
          rx={0.8}
        />
      </g>
      <path
        data-name="Line 1435"
        transform="translate(19283.557 -14492.914)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
      <path
        data-name="Line 1436"
        transform="translate(19283.557 -14489.99)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
    </g>
  </svg>
);

export const formDarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
  >
    <g
      data-name="Group 20470"
      transform="translate(-19302 14499.549)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <g
        data-name="Rectangle 11031"
        transform="translate(19302 -14499.549)"
      >
        <rect
          width={13}
          height={13}
          rx={3}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={11.6}
          height={11.6}
          rx={2.3}
        />
      </g>
      <path
        data-name="Line 1432"
        transform="translate(19306.109 -14496.188)"
        strokeLinecap="round"
        d="M0 0L4.725 0"
      />
      <path
        data-name="Line 1433"
        transform="translate(19306.109 -14493.417)"
        strokeLinecap="round"
        d="M0 0L4.725 0"
      />
      <path
        data-name="Line 1434"
        transform="translate(19306.109 -14490.644)"
        strokeLinecap="round"
        d="M0 0L2.989 0"
      />
    </g>
  </svg>
);

export const subSectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
  >
    <g
      data-name="Group 20473"
      transform="translate(-19523.156 14527.022)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <g
        data-name="Rectangle 11038"
        transform="translate(19523.156 -14527.022)"
      >
        <rect
          width={13}
          height={13}
          rx={4}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={11.6}
          height={11.6}
          rx={3.3}
        />
      </g>
      <path
        data-name="Line 1438"
        transform="translate(19527.492 -14526.654)"
        d="M0 0L0 12.443"
      />
      <path
        data-name="Line 1439"
        transform="translate(19527.492 -14518.359)"
        d="M0 0L8.295 0"
      />
      <path
        data-name="Line 1440"
        transform="translate(19531.641 -14526.654)"
        d="M0 8.295L0 0"
      />
    </g>
  </svg>
);

export const clockGrayIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-clock"
  >
    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
  </svg>
);

export const commentsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={29}
    fill="currentColor"
    className="bi bi-chat-dots"
    viewBox="0 0 16 16"
  >
    <path d="M5 8a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z" />
    <path d="M2.165 15.803l.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 008 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 01-.524 2.318l-.003.011a10.722 10.722 0 01-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 00.693-.125zm.8-3.108a1 1 0 00-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 01-2.088-.272 1 1 0 00-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 00.398-2z" />
  </svg>
);

export const docsFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.921}
    height={9.133}
    viewBox="0 0 7.921 9.133"
  >
    <g
      data-name="Group 19960"
      fill="currentColor"
    >
      <path
        data-name="Path 43336"
        d="M213.984 608.132v-3.545a.979.979 0 011.028-1.016h4.143c.094 0 .109.026.109.111q-.006.912 0 1.823a.978.978 0 00.763.973 1.173 1.173 0 00.286.03h1.495c.07 0 .1.008.1.09v5.134a.975.975 0 01-.98.972h-5.958a.976.976 0 01-.98-.972v-3.6"
        transform="translate(.001) translate(-213.985 -603.568)"
      />
      <path
        data-name="Path 43337"
        d="M429.481 611.086l1.79 2.065c-.024.028-.054.015-.079.015h-1.359a.324.324 0 01-.353-.347v-1.734"
        transform="translate(.001) translate(-423.543 -610.881)"
      />
    </g>
  </svg>
);

export const imageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.219}
    height={8.073}
    viewBox="0 0 8.219 8.073"
  >
    <g
      data-name="Group 19961"
      fill="currentColor"
    >
      <path
        data-name="Path 43334"
        d="M429.02 4.063V1.205A1.213 1.213 0 00427.8 0H422a1.174 1.174 0 00-.24.021 1.161 1.161 0 00-.949 1.153v5.724a1.122 1.122 0 00.023.237 1.168 1.168 0 001.178.936h5.822a1.353 1.353 0 00.25-.023 1.173 1.173 0 00.945-1.157c-.008-.943 0-1.887 0-2.83m-.717.942l-.017.007-.41-.683c-.216-.36-.431-.72-.65-1.079a.666.666 0 00-1-.175.622.622 0 00-.112.122l-1.325 1.777-1.056-1.072a.85.85 0 00-.366-.244.6.6 0 00-.665.211c-.366.425-.726.854-1.088 1.281l-.135.157V5.2 1.212a.493.493 0 01.548-.538h5.757a.5.5 0 01.51.5v3.832"
        transform="translate(-420.803 .001)"
      />
      <path
        data-name="Path 43335"
        d="M480.965 58.137a.683.683 0 11.69.664.684.684 0 01-.69-.664"
        transform="translate(-479.466 -56.037)"
      />
    </g>
  </svg>
);

export const youTubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.5}
    height={6.605}
    viewBox="0 0 8.5 6.605"
  >
    <path
      data-name="Path 43333"
      d="M8.5 369.836c-.015-.1-.01-.2-.016-.3a1.323 1.323 0 00-.926-1.326 3.491 3.491 0 00-1.016-.147c-.771-.007-1.542-.006-2.313 0-.845.006-1.691-.025-2.536.018a2.559 2.559 0 00-.945.212 1.2 1.2 0 00-.662.81 2.918 2.918 0 00-.083.808c0 .917-.01 1.834.005 2.751a3.07 3.07 0 00.1.743A1.476 1.476 0 001 374.463a2.8 2.8 0 001.049.2c1.158.006 2.316 0 3.474 0 .417 0 .834.019 1.251-.017a2.649 2.649 0 00.779-.166 1.3 1.3 0 00.545-.4 2.034 2.034 0 00.378-1.048c.015-.125.008-.253.025-.378v-.145c-.018-.036 0-.074-.008-.111a.385.385 0 01.008-.125v-1.78a.433.433 0 01-.008-.133v-.319a.41.41 0 01.008-.129zm-2.933 1.632a.325.325 0 01-.134.131l-1.725.986c-.225.128-.427-.008-.429-.288v-.98-.953c0-.3.2-.435.446-.3l1.7.966a.313.313 0 01.145.434"
      transform="translate(0 -368.059)"
      fill="currentColor"
    />
  </svg>
);

export const attachmentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.181}
    height={9.502}
    viewBox="0 0 10.181 9.502"
  >
    <path
      data-name="Path 43338"
      d="M754.175 461.784a.994.994 0 00.055-.253 2.309 2.309 0 01.653-1.152l3.886-3.833a3.293 3.293 0 014.2-.381 3.089 3.089 0 011.236 1.665 3.122 3.122 0 01-.283 2.557 3.317 3.317 0 01-.564.717l-3.849 3.8a.494.494 0 01-.527.155.453.453 0 01-.224-.709 1.2 1.2 0 01.107-.116q1.911-1.886 3.823-3.77a2.3 2.3 0 00.68-1.191 2.288 2.288 0 00-1.816-2.725 2.285 2.285 0 00-2.107.64q-1.963 1.924-3.914 3.86a1.381 1.381 0 001.882 2.019c.033-.027.064-.057.095-.087l3.562-3.514a.45.45 0 00.109-.568.464.464 0 00-.681-.148 1.09 1.09 0 00-.11.1l-2.27 2.238a.471.471 0 01-.657.066.453.453 0 01-.074-.638.846.846 0 01.067-.073q1.159-1.144 2.32-2.286a1.409 1.409 0 011.678-.247 1.359 1.359 0 01.3 2.186c-1.192 1.19-2.4 2.369-3.6 3.55a2.282 2.282 0 01-1.638.678 2.311 2.311 0 01-2.194-1.5 2 2 0 01-.123-.5c0-.014 0-.026-.02-.03z"
      transform="translate(-754.175 -455.582)"
      fill="currentColor"
    />
  </svg>
);

export const multiLevelDrodownArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.02}
    height={6.191}
    viewBox="0 0 4.02 6.191"
  >
    <path
      data-name="Path 43318"
      d="M.5.5l3.02 2.718L.5 5.691z"
      fill="#707070"
      stroke="#707070"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    />
  </svg>
);

export const documentMenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.654}
    height={12.281}
    viewBox="0 0 8.654 12.281"
  >
    <g
      transform="rotate(-90 6.14 5.44)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Line 769"
        transform="translate(0 3.627)"
        d="M0 0L10.881 0"
      />
      <path
        data-name="Line 770"
        d="M0 0L8.463 0"
      />
      <path
        data-name="Line 771"
        transform="translate(0 7.254)"
        d="M0 0L4.231 0"
      />
    </g>
  </svg>
);

export const shareIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9.852}
    height={10.835}
    viewBox="0 0 9.852 10.835"
  >
    <g
      data-name="Icon feather-share-2"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <path
        data-name="Path 43321"
        d="M13.352 4.475A1.475 1.475 0 1111.876 3a1.475 1.475 0 011.475 1.475z"
        transform="translate(-4 -2.5)"
      />
      <path
        data-name="Path 43322"
        d="M7.451 7.917a1.475 1.475 0 11-1.476-1.475 1.475 1.475 0 011.476 1.475z"
        transform="translate(-4 -2.5)"
      />
      <path
        data-name="Path 43323"
        d="M13.352 11.36a1.475 1.475 0 11-1.476-1.475 1.475 1.475 0 011.476 1.475z"
        transform="translate(-4 -2.5)"
      />
      <path
        data-name="Path 43324"
        d="M7.249 8.66l3.359 1.957"
        transform="translate(-4 -2.5)"
      />
      <path
        data-name="Path 43325"
        d="M10.603 5.218L7.249 7.175"
        transform="translate(-4 -2.5)"
      />
    </g>
  </svg>
);

export const starredIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.638}
    height={10.104}
    viewBox="0 0 10.638 10.104"
  >
    <path
      d="M7.159 3.794a.249.249 0 00-.23.139l-.966 1.932a1.047 1.047 0 01-.788.566l-2.163.312a.247.247 0 00-.206.171.234.234 0 00.064.246l1.564 1.5a1.033 1.033 0 01.3.923l-.368 2.122a.236.236 0 00.1.237.25.25 0 00.274.021l1.934-1a1.06 1.06 0 01.972 0l1.934 1a.256.256 0 00.275-.02.236.236 0 00.1-.237l-.374-2.12a1.033 1.033 0 01.3-.923l1.564-1.5a.232.232 0 00.064-.246.245.245 0 00-.206-.171l-2.159-.315a1.047 1.047 0 01-.788-.567l-.968-1.931a.248.248 0 00-.229-.139m-2.542 9a1.052 1.052 0 01-.621-.2 1.029 1.029 0 01-.41-1.013l.369-2.131a.241.241 0 00-.071-.215L2.32 7.732a1.026 1.026 0 01-.27-1.061 1.037 1.037 0 01.85-.714l2.163-.312a.252.252 0 00.192-.136l.965-1.932A1.043 1.043 0 017.159 3h0a1.043 1.043 0 01.939.577l.967 1.932a.252.252 0 00.191.137l2.163.312a1.037 1.037 0 01.848.713A1.026 1.026 0 0112 7.732l-1.564 1.5a.24.24 0 00-.071.214l.369 2.122a1.029 1.029 0 01-.411 1.013 1.044 1.044 0 01-1.109.084l-1.933-1a.264.264 0 00-.242 0l-1.933 1a1.053 1.053 0 01-.487.12"
      fill="#84868b"
      stroke="#84868b"
      strokeLinecap="round"
      strokeWidth={0.3}
      fillRule="evenodd"
      transform="translate(-1.84 -2.85)"
      data-name="Iconly/Light-Outline/Star"
    />
  </svg>
);

export const dustbinIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.48}
    height={9.311}
    viewBox="0 0 8.48 9.311"
  >
    <g
      data-name="trash (1)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <path
        data-name="Path 13"
        d="M0 1.662h7.48"
        transform="translate(.5 .5)"
      />
      <path
        data-name="Path 14"
        d="M6.649 1.662V7.48a.831.831 0 01-.831.831H1.662a.831.831 0 01-.831-.831V1.662m1.247 0V.831A.831.831 0 012.909 0h1.662a.831.831 0 01.831.831v.831"
        transform="translate(.5 .5)"
      />
    </g>
  </svg>
);

export const folderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.507}
    height={11.397}
    viewBox="0 0 12.507 11.397"
  >
    <path
      data-name="Icon feather-folder"
      d="M11.807 9.586A1.111 1.111 0 0110.7 10.7H1.811A1.111 1.111 0 01.7 9.586V1.811A1.111 1.111 0 011.811.7h2.777L5.7 2.366h5a1.111 1.111 0 011.111 1.111z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const filePostIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.452}
    height={12.74}
    viewBox="0 0 10.452 12.74"
  >
    <g
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
    >
      <path
        data-name="Path 21714"
        d="M5.148 0h-4A1.144 1.144 0 000 1.144V10.3a1.144 1.144 0 001.144 1.14h6.864a1.144 1.144 0 001.144-1.14V4z"
        transform="translate(.65 .65)"
      />
      <path
        data-name="Path 21715"
        d="M5.148 0v4h4"
        transform="translate(.65 .65)"
      />
    </g>
  </svg>
);

export const moveFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.245}
    height={13.241}
    viewBox="0 0 13.245 13.241"
  >
    <g
      data-name="Group 19972"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40596"
        d="M852.287 882.99l-4.305-3.554-4.3 3.554"
        fill="none"
        transform="rotate(45 1484.959 -570.896)"
      />
      <path
        data-name="Path 40597"
        d="M847.981 879.436v11.34"
        fill="#6f75bc"
        transform="rotate(45 1484.959 -570.896)"
      />
    </g>
  </svg>
);

export const downloadFileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.783}
    height={13.686}
    viewBox="0 0 14.783 13.686"
  >
    <path
      data-name="Subtraction 5"
      d="M13.342 16.286H5.333A3.192 3.192 0 012.142 13.1v-1.9h1.08v1.9a2.113 2.113 0 002.111 2.109h8.009a2.107 2.107 0 002.105-2.1V11.2h1.08v1.907a3.187 3.187 0 01-3.185 3.179zM9.39 12.737h-.176l-.006-.006h-.01a.018.018 0 01-.016 0h-.005a.017.017 0 00-.01 0 .038.038 0 01-.025-.031.03.03 0 00-.021 0s0-.006-.006-.006a.114.114 0 01-.047-.021h0a.011.011 0 01-.01-.01.021.021 0 01-.016-.009.072.072 0 01-.037-.025.1.1 0 01-.025-.021h-.006a.071.071 0 01-.02-.016h-.006l-2.094-2.1a.563.563 0 01-.156-.385.535.535 0 01.156-.379.521.521 0 01.379-.156.536.536 0 01.385.156l1.174 1.166V3.541a.541.541 0 011.082 0v7.353l1.174-1.18a.528.528 0 01.385-.156.521.521 0 01.379.156.547.547 0 010 .764l-2.1 2.1c-.016.015-.031.031-.051.047v-.006a.017.017 0 01-.008.006h-.006a.1.1 0 01-.018.013l-.016.01v.006h-.004l-.01.01a.144.144 0 01-.043.021H9.54a.022.022 0 00-.016 0h-.008a.042.042 0 01-.018.006h-.016a.02.02 0 01-.016 0 .018.018 0 00-.016.006h-.008a.054.054 0 00-.02 0h-.01a.035.035 0 00-.021 0z"
      fill="#6f75bc"
      stroke="#6f75bc"
      strokeWidth={0.4}
      transform="translate(-1.942 -2.8)"
    />
  </svg>
);

export const crossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.584}
    height={17.583}
    viewBox="0 0 17.584 17.583"
  >
    <g
      data-name="Group 19570"
      opacity={0.787}
      fill="none"
      stroke="#6d7079"
      strokeLinecap="round"
      strokeWidth={3}
    >
      <path
        data-name="Path 24"
        d="M.001 0l13.341 13.341"
        transform="translate(2.121 2.121)"
      />
      <path
        data-name="Path 25"
        d="M13.341 0L.001 13.341"
        transform="translate(2.121 2.121)"
      />
    </g>
  </svg>
);

export const openIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="#6d7079"
    className="bi bi-justify-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm-4-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0-3a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5z"
    />
  </svg>
);

export const pdfIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-filetype-pdf"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 01-2 2h-1v-1h1a1 1 0 001-1V4.5h-2A1.5 1.5 0 019.5 3V1H4a1 1 0 00-1 1v9H2V2a2 2 0 012-2h5.5L14 4.5zM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 00.161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 00-.46-.477c-.2-.12-.443-.179-.732-.179zm.545 1.333a.795.795 0 01-.085.38.574.574 0 01-.238.241.794.794 0 01-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 00.595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 00-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 01.354.454c.079.201.118.452.118.753a2.3 2.3 0 01-.068.592 1.14 1.14 0 01-.196.422.8.8 0 01-.334.252 1.298 1.298 0 01-.483.082h-.563v-2.707zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896z"
    />
  </svg>
);

export const zipIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-file-zip-fill"
    viewBox="0 0 16 16"
  >
    <path d="M8.5 9.438V8.5h-1v.938a1 1 0 01-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 01-.03-.243z" />
    <path d="M4 0h8a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2zm2.5 8.5v.938l-.4 1.599a1 1 0 00.416 1.074l.93.62a1 1 0 001.109 0l.93-.62a1 1 0 00.415-1.074l-.4-1.599V8.5a1 1 0 00-1-1h-1a1 1 0 00-1 1zm1-5.5h-1v1h1v1h-1v1h1v1H9V6H8V5h1V4H8V3h1V2H8V1H6.5v1h1v1z" />
  </svg>
);

export const componentsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.773}
    height={12.763}
    viewBox="0 0 12.773 12.763"
  >
    <path
      data-name="Path 48724"
      d="M11.063 6.77h1.075a.348.348 0 00.384-.3V2.834a.371.371 0 00-.382-.322H9.273c-.15 0-.155-.007-.157-.154 0-.243 0-.485-.02-.728A1.51 1.51 0 008.558.586a1.148 1.148 0 00-.777-.321c-.045-.006-.093.013-.137-.012h-.312a2.622 2.622 0 00-.3.052 1.526 1.526 0 00-1 1.186 4.921 4.921 0 00-.025.835c0 .183 0 .184-.189.184H3.135c-.459 0-.6.141-.6.6v2.7c0 .162-.006.167-.169.168-.2 0-.407-.008-.61 0a1.509 1.509 0 00-1.388.933 1.618 1.618 0 00-.063 1.044 1.528 1.528 0 001.3 1.112c.247.022.493.023.74.024.187 0 .188 0 .188.184V12.133a.394.394 0 00.419.38c.969-.009 1.937 0 2.906 0h.574a.338.338 0 00.341-.263.683.683 0 00.017-.19v-1a.821.821 0 01.2-.563.728.728 0 01.817-.2.74.74 0 01.486.7v1.017a.853.853 0 00.02.214.356.356 0 00.37.291h3.48c.22 0 .3-.063.353-.275V8.599a.372.372 0 00-.383-.32h-.143c-.339 0-.677.005-1.016 0a.751.751 0 01-.683-.983.775.775 0 01.765-.522m-.311 2.247a4.872 4.872 0 00.919.024c.1 0 .137.021.137.133q-.008 1.25 0 2.5c0 .092-.025.109-.112.109q-1.261-.005-2.523 0c-.081 0-.107-.016-.106-.1 0-.267.012-.534-.008-.8a1.509 1.509 0 00-3-.138 6.394 6.394 0 00-.02.931c0 .086-.017.112-.109.112q-1.261-.006-2.523 0c-.093 0-.11-.026-.109-.112v-1.471-1.435c0-.315-.136-.449-.453-.449H1.786a.776.776 0 01-.791-.694.785.785 0 01.639-.868 4.462 4.462 0 01.632-.019h.67a.346.346 0 00.344-.3 1.091 1.091 0 00.011-.167v-2.87c0-.1.028-.117.119-.116h2.87a1.064 1.064 0 00.155-.01.348.348 0 00.312-.36v-1.1a.8.8 0 01.584-.806.782.782 0 01.994.713c.01.374 0 .749 0 1.124a.383.383 0 00.44.438h2.905c.1 0 .122.027.121.124q-.006 1.25 0 2.5c0 .09-.017.118-.114.119a6.583 6.583 0 00-.942.02 1.512 1.512 0 000 2.979"
      fill="#84868a"
      stroke="#84868a"
      strokeWidth={0.5}
    />
  </svg>
);

export const targetIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.653}
    height={12.648}
    viewBox="0 0 12.653 12.648"
  >
    <g
      data-name="Group 20549"
      fill="#84868a"
    >
      <path
        data-name="Path 48721"
        d="M682.67 63.73a5.834 5.834 0 01-1.127-11.558 5.314 5.314 0 011.538-.092.652.652 0 01.609.71.642.642 0 01-.7.591 4.056 4.056 0 00-1.944.286 4.36 4.36 0 00-2.825 3.426 4.491 4.491 0 003.408 5.212 4.542 4.542 0 005.457-3.38 4.1 4.1 0 00.1-1.324.656.656 0 01.63-.712.649.649 0 01.667.609 5.821 5.821 0 01-4.66 6.119 5.527 5.527 0 01-1.16.112"
        transform="translate(-236.953 -670.956) translate(-439.882 619.873)"
      />
      <path
        data-name="Path 48722"
        d="M809.278 29.473c0 .339.005.678 0 1.017 0 .123.027.162.156.161.673-.007 1.346 0 2.019 0a.483.483 0 01.251.043.317.317 0 01.079.5c-.58.587-1.161 1.173-1.754 1.745a1.144 1.144 0 01-.819.3h-1.473a.282.282 0 00-.224.093q-.984.991-1.975 1.976a.652.652 0 11-.912-.93q.981-.984 1.966-1.964a.282.282 0 00.095-.223c-.005-.486 0-.972 0-1.458a1.239 1.239 0 01.361-.9c.55-.559 1.107-1.111 1.662-1.666a.31.31 0 01.358-.089.318.318 0 01.214.317v1.078z"
        transform="translate(-236.953 -670.956) translate(-562.267 642.902)"
      />
      <path
        data-name="Path 48723"
        d="M744.1 124.363a3.24 3.24 0 01-.781-6.384.647.647 0 01.774.464.641.641 0 01-.427.783 2.131 2.131 0 00-.816.413 1.864 1.864 0 00-.621 2 1.823 1.823 0 001.517 1.393 1.912 1.912 0 002.218-1.386.668.668 0 01.594-.525.659.659 0 01.632.364.684.684 0 01.036.5 3.241 3.241 0 01-2.7 2.357 3.477 3.477 0 01-.424.026"
        transform="translate(-236.953 -670.956) translate(-501.303 556.645)"
      />
    </g>
  </svg>
);

export const scoreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.92}
    height={15.168}
    viewBox="0 0 11.92 15.168"
  >
    <g data-name="Group 20548">
      <path
        data-name="Path 48708"
        d="M570.23 485.051a1.443 1.443 0 00-.018-.269 1.612 1.612 0 00-1.667-1.37c-2.842 0-5.685.012-8.527-.007a1.684 1.684 0 00-1.706 1.7c.022 1.962.007 3.925.007 5.887v5.921a1.613 1.613 0 001.649 1.658h6.412a.646.646 0 00.484-.194q1.59-1.592 3.182-3.182a.6.6 0 00.185-.453v-9.693m-3.247 11.592c0-.237-.007-.512 0-.786a.542.542 0 01.543-.534h.779l-1.324 1.32m2-2.4c-.479-.01-.959-.005-1.438 0a1.615 1.615 0 00-1.641 1.649v1.472c0 .1-.024.13-.13.13q-2.893-.005-5.786 0a.555.555 0 01-.585-.615v-5.887-5.819c0-.471.2-.672.663-.672h8.425c.454 0 .658.205.658.661v8.915c0 .14-.031.177-.173.174"
        transform="translate(-302.899 -1006.832) translate(-255.413 523.428)"
        fill="#84868a"
      />
      <path
        data-name="Path 48709"
        d="M610.967 584.437a.562.562 0 01-.43.552.539.539 0 01-.615-.336c-.155-.379-.3-.761-.445-1.144a.182.182 0 00-.206-.141c-.5.008-.992.007-1.489 0a.173.173 0 00-.2.13c-.142.378-.293.752-.441 1.128a.543.543 0 01-.727.355.549.549 0 01-.288-.745l1.864-4.8a.554.554 0 011.072 0l1.839 4.754a.55.55 0 01.061.245"
        transform="translate(-302.899 -1006.832) translate(-301.023 432.13)"
        fill="#84868a"
      />
      <path
        data-name="Path 48710"
        d="M702.858 557.551a2.307 2.307 0 01-.287 0 .546.546 0 01-.45-.582.535.535 0 01.506-.495 7.46 7.46 0 01.473 0c.079 0 .109-.017.106-.1-.007-.152 0-.3 0-.456a.541.541 0 011.082 0v.439c0 .084.016.12.11.115.146-.008.293 0 .439 0a.542.542 0 010 1.083c-.178.005-.416-.076-.516.033s-.024.331-.027.5a.541.541 0 11-1.083-.005c0-.135-.007-.271 0-.405.007-.1-.02-.145-.128-.13a1.7 1.7 0 01-.22 0"
        transform="translate(-302.899 -1006.832) translate(-392.718 454.698)"
        fill="#84868a"
      />
      <path
        data-name="Path 48711"
        d="M650.906 625.819h-.928l.462-1.193.466 1.193"
        transform="translate(-302.899 -1006.832) translate(-342.934 388.593)"
        fill="#f5f6f7"
      />
    </g>
  </svg>
);

export const weightageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12.981}
    viewBox="0 0 13 12.981"
  >
    <g
      data-name="Group 20547"
      fill="#84868a"
    >
      <path
        data-name="Path 48715"
        d="M45.31 36.775v-3.1a1.835 1.835 0 011.278-1.788 2.191 2.191 0 01.8-.158q.778-.012 1.556 0a.653.653 0 01.7.574.618.618 0 01-.533.675.985.985 0 01-.2.016h-1.37c-.481 0-.782.258-.783.68v6.223c0 .442.271.666.781.668h1.387a.648.648 0 01.721.6.629.629 0 01-.671.66 16.5 16.5 0 01-1.858-.022 1.96 1.96 0 01-1.794-1.655c-.051-1.039-.01-2.079-.019-3.118v-.251"
        transform="translate(-279.698 -984.969) translate(234.395 954.687)"
      />
      <path
        data-name="Path 48716"
        d="M273.034 36.632v3.1a1.833 1.833 0 01-1.278 1.788 2.24 2.24 0 01-.817.16q-.761.011-1.522 0c-.585-.008-.916-.526-.626-.972a.663.663 0 01.586-.293h1.421c.517 0 .784-.227.784-.68v-6.209c0-.46-.266-.682-.8-.682h-1.37a.648.648 0 01-.721-.6.629.629 0 01.67-.66 16.814 16.814 0 011.841.02 1.953 1.953 0 011.812 1.67c.05 1.063.01 2.128.019 3.192v.163"
        transform="translate(-279.698 -984.969) translate(19.657 954.827)"
      />
      <path
        data-name="Path 48717"
        d="M190.567 6.507v5.7a1.079 1.079 0 01-.032.332.691.691 0 01-.772.437.627.627 0 01-.636-.544 1.924 1.924 0 01-.012-.227V.771a1.088 1.088 0 01.032-.332.693.693 0 01.772-.439.626.626 0 01.635.544 2.083 2.083 0 01.012.243v5.717"
        transform="translate(-279.698 -984.969) translate(96.357 984.97)"
      />
    </g>
  </svg>
);

export const offthejobIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.071}
    height={13}
    viewBox="0 0 12.071 13"
  >
    <g
      data-name="Group 20546"
      transform="translate(-19378 14497.885)"
      fill="none"
      stroke="currentColor"
    >
      <g
        data-name="Rectangle 11036"
        transform="translate(19378 -14494.885)"
        strokeWidth={1}
      >
        <rect
          width={12.071}
          height={10}
          rx={2}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={10.671}
          height={8.6}
          rx={1.3}
        />
      </g>
      <g
        data-name="Rectangle 11037"
        transform="translate(19381.535 -14497.885)"
        strokeWidth={1}
      >
        <rect
          width={5}
          height={4}
          rx={1}
          stroke="none"
        />
        <rect
          x={0.6}
          y={0.6}
          width={3.8}
          height={2.8}
          rx={0.4}
        />
      </g>
      <path
        data-name="Line 1437"
        transform="translate(19378.471 -14491.438)"
        strokeWidth={1.4}
        d="M0 0L11.305 0"
      />
    </g>
  </svg>
);

export const usefulNoteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12.2}
    viewBox="0 0 12 12.2"
  >
    <g
      data-name="Group 20568"
      stroke="#f46582"
    >
      <g
        data-name="Ellipse 34"
        fill="rgba(242,244,247,0)"
        strokeWidth={1}
        transform="translate(0 .2)"
      >
        <circle
          cx={6}
          cy={6}
          r={6}
          stroke="none"
        />
        <circle
          cx={6}
          cy={6}
          r={5.5}
          fill="none"
        />
      </g>
      <text
        transform="translate(0 .2) translate(5 8)"
        fill="#f46582"
        strokeWidth={0.2}
        fontSize={8}
        fontFamily="Nunito-Bold, Nunito"
        fontWeight={700}
      >
        <tspan
          x={0}
          y={0}
        >
          {'i'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const explainNoteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
  >
    <g
      transform="translate(.651 .902)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <circle
        data-name="Ellipse 36"
        cx={7}
        cy={7}
        r={7}
        transform="translate(.349 .098)"
        fill="#1b1c21"
        stroke="#1b1c21"
      />
      <path
        data-name="Line 161"
        transform="translate(7.349 7.098)"
        fill="none"
        stroke="#fff"
        d="M0 3L0 0"
      />
      <path
        data-name="Line 162"
        transform="translate(7.349 4.098)"
        fill="none"
        stroke="#fff"
        d="M0 0L0 0"
      />
    </g>
  </svg>
);

export const scoreTargetIcon = (
  <svg
    data-name="Group 20581"
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={9.645}
    viewBox="0 0 15 9.645"
  >
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 11102"
          fill="#5d63a7"
          d="M0 0H15V9.645H0z"
        />
      </clipPath>
    </defs>
    <g
      data-name="Group 20580"
      clipPath="url(#a)"
      fill="#5d63a7"
    >
      <path
        data-name="Path 48725"
        d="M309.8 73.687a.576.576 0 01-.595.322c-.8-.01-1.6-.012-2.4 0a.5.5 0 01-.558-.523 3.237 3.237 0 00-.2-1.131.246.246 0 01.014-.206c.165-.346.319-.7.488-1.042a1.293 1.293 0 00.06-1.112.139.139 0 01.041-.176q.574-.565 1.138-1.139c.074-.076.106-.055.164.013a7.575 7.575 0 011.713 3.48 5.335 5.335 0 01.1.752c0 .03-.016.07.028.089v.264a.3.3 0 000 .205z"
        transform="translate(-294.797 -66.112)"
      />
      <path
        data-name="Path 48726"
        d="M407.727 195.393a.169.169 0 010-.205z"
        transform="translate(-392.727 -188.023)"
      />
      <path
        data-name="Path 48727"
        d="M156.363 110.36a1.746 1.746 0 01.844-1.5q1.862-1.195 3.731-2.378a.444.444 0 01.711.215.463.463 0 01-.04.352c-.626 1.347-1.249 2.7-1.881 4.041a1.76 1.76 0 01-3.279-.186 1.589 1.589 0 01-.085-.546"
        transform="translate(-150.623 -102.482)"
      />
      <path
        data-name="Path 48728"
        d="M1.763 73.945H.519a.456.456 0 01-.519-.52 7.251 7.251 0 011.243-3.994c.186-.281.394-.545.606-.805.056-.069.086-.078.154-.009q1.171 1.179 2.35 2.349c.062.061.065.1.012.165a3.893 3.893 0 00-.745 1.644 4.867 4.867 0 00-.074.7.452.452 0 01-.494.473H1.764"
        transform="translate(0 -66.052)"
      />
      <path
        data-name="Path 48729"
        d="M74.539.023a.287.287 0 01.011.139v3.263c0 .084 0 .143-.111.157a3.7 3.7 0 00-1.8.738c-.084.063-.124.063-.2-.013q-1.159-1.169-2.328-2.329c-.064-.064-.077-.093 0-.161A7.526 7.526 0 0173.3.2a6.771 6.771 0 011.239-.177"
        transform="translate(-67.49 -.022)"
      />
      <path
        data-name="Path 48730"
        d="M216.245 0a7.4 7.4 0 012.381.543 7.583 7.583 0 012.067 1.273c.062.053.042.077 0 .121q-.582.578-1.159 1.16a.127.127 0 01-.164.033 1.243 1.243 0 00-1.2.117c-.258.166-.519.326-.775.5a.206.206 0 01-.214.027 3.279 3.279 0 00-.846-.213c-.068-.007-.1-.029-.1-.108v-3.4a.286.286 0 01.01-.053"
        transform="translate(-208.296)"
      />
    </g>
  </svg>
);

export const sectionGridIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={13}
    viewBox="0 0 8 13"
  >
    <g
      data-name="Group 19616"
      fill="#84868b"
      stroke="#84868b"
      strokeWidth={1}
    >
      <g
        data-name="Ellipse 18"
        transform="translate(.383 -.258) translate(-.383 .258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 25"
        transform="translate(.383 -.258) translate(4.617 .258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 19"
        transform="translate(.383 -.258) translate(-.383 5.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 24"
        transform="translate(.383 -.258) translate(4.617 5.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 20"
        transform="translate(.383 -.258) translate(-.383 10.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
      <g
        data-name="Ellipse 23"
        transform="translate(.383 -.258) translate(4.617 10.258)"
      >
        <circle
          cx={1.5}
          cy={1.5}
          r={1.5}
          stroke="none"
        />
        <circle
          cx={1.5}
          cy={1.5}
          r={1}
          fill="none"
        />
      </g>
    </g>
  </svg>
);

export const sectionMenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={10}
    viewBox="0 0 12 10"
  >
    <g
      data-name="Group 20609"
      transform="translate(14346 4029)"
      fill="#84868b"
    >
      <rect
        data-name="Rectangle 7518"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14346 -4029)"
      />
      <rect
        data-name="Rectangle 7519"
        width={8}
        height={2}
        rx={1}
        transform="translate(-14344 -4025)"
      />
      <rect
        data-name="Rectangle 7520"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14346 -4021)"
      />
    </g>
  </svg>
);

export const wifiIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={10}
    viewBox="0 0 12 10"
  >
    <g
      data-name="Group 20610"
      transform="translate(14152 3972)"
      fill="#84868b"
    >
      <rect
        data-name="Rectangle 7539"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14152 -3972)"
      />
      <rect
        data-name="Rectangle 7540"
        width={8}
        height={2}
        rx={1}
        transform="translate(-14150 -3968)"
      />
      <rect
        data-name="Rectangle 7541"
        width={2}
        height={2}
        rx={1}
        transform="translate(-14147 -3964)"
      />
    </g>
  </svg>
);

export const headingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={15}
    viewBox="0 0 10 15"
  >
    <text
      transform="translate(0 12)"
      fill="#84868b"
      fontSize={12}
      fontFamily="Mulish-Bold, Mulish"
      fontWeight={700}
    >
      <tspan
        x={0}
        y={0}
      >
        {'H'}
      </tspan>
    </text>
  </svg>
);

export const labelIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={14}
    viewBox="0 0 8 14"
  >
    <g
      data-name="Group 20613"
      transform="translate(14141 3721)"
    >
      <rect
        data-name="Rectangle 7550"
        width={8}
        height={1}
        rx={0.5}
        transform="translate(-14141 -3709)"
        fill="#eae8e8"
      />
      <text
        transform="translate(-14141 -3710)"
        fill="#84868b"
        fontSize={12}
        fontFamily="Baskerville"
      >
        <tspan
          x={0}
          y={0}
        >
          {'L'}
        </tspan>
      </text>
    </g>
  </svg>
);

export const singleLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={10}
    viewBox="0 0 12 10"
  >
    <g
      data-name="Group 20611"
      transform="translate(14349 3843)"
    >
      <rect
        data-name="Rectangle 7518"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14349 -3843)"
        fill="#84868b"
      />
      <rect
        data-name="Rectangle 7519"
        width={12}
        height={6}
        rx={1}
        transform="translate(-14349 -3839)"
        fill="#eae8e8"
      />
    </g>
  </svg>
);

export const multipleLineIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={10}
    viewBox="0 0 12 10"
  >
    <g
      data-name="Group 20612"
      transform="translate(14344 3781)"
    >
      <rect
        data-name="Rectangle 7544"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14344 -3781)"
        fill="#84868b"
      />
      <rect
        data-name="Rectangle 7546"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14344 -3777)"
        fill="#84868b"
      />
      <rect
        data-name="Rectangle 7545"
        width={12}
        height={2}
        rx={1}
        transform="translate(-14344 -3773)"
        fill="#eae8e8"
      />
    </g>
  </svg>
);

export const calendarDateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9.691}
    height={10.657}
    viewBox="0 0 9.691 10.657"
  >
    <g
      transform="translate(.5 .5)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeWidth={1}
    >
      <rect
        data-name="Rectangle 10"
        width={8.692}
        height={8.692}
        rx={2}
        transform="translate(0 .966)"
      />
      <path
        data-name="Line 2"
        transform="translate(6.277)"
        strokeLinejoin="round"
        d="M0 0L0 1.932"
      />
      <path
        data-name="Line 3"
        transform="translate(2.414)"
        strokeLinejoin="round"
        d="M0 0L0 1.932"
      />
      <path
        data-name="Line 4"
        transform="translate(0 3.863)"
        strokeLinejoin="round"
        d="M0 0L8.692 0"
      />
    </g>
  </svg>
);

export const dateTimeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.5}
    height={12.157}
    viewBox="0 0 11.5 12.157"
  >
    <g
      data-name="Group 20614"
      stroke="#84868b"
    >
      <g
        transform="translate(14141.5 3584.157) translate(-14141 -3583.657)"
        fill="none"
        strokeLinecap="round"
        strokeWidth={1}
      >
        <rect
          data-name="Rectangle 10"
          width={8.692}
          height={8.692}
          rx={2}
          transform="translate(0 .966)"
        />
        <path
          data-name="Line 2"
          transform="translate(6.277)"
          strokeLinejoin="round"
          d="M0 0L0 1.932"
        />
        <path
          data-name="Line 3"
          transform="translate(2.414)"
          strokeLinejoin="round"
          d="M0 0L0 1.932"
        />
        <path
          data-name="Line 4"
          transform="translate(0 3.863)"
          strokeLinejoin="round"
          d="M0 0L8.692 0"
        />
      </g>
      <g
        data-name="Ellipse 322"
        transform="translate(14141.5 3584.157) translate(-14136 -3578)"
        fill="#fff"
        strokeWidth={1}
      >
        <circle
          cx={3}
          cy={3}
          r={3}
          stroke="none"
        />
        <circle
          cx={3}
          cy={3}
          r={2.5}
          fill="none"
        />
      </g>
      <path
        data-name="Path 43265"
        d="M-14133-3575.971v1.136h1.008"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        transform="translate(14141.5 3584.157)"
      />
    </g>
  </svg>
);

export const switchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9.889}
    height={6.593}
    viewBox="0 0 9.889 6.593"
  >
    <path
      data-name="FontAwsome (toggle-on)"
      d="M6.592 64H3.3a3.3 3.3 0 000 6.592h3.3A3.3 3.3 0 006.6 64zm0 5.494a2.2 2.2 0 112.2-2.2 2.2 2.2 0 01-2.2 2.2z"
      transform="translate(0 -64)"
      fill="#84868b"
    />
  </svg>
);

export const dropdownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    viewBox="0 0 11 11"
  >
    <g
      data-name="Group 20615"
      stroke="#84868b"
      strokeWidth={1}
    >
      <g
        data-name="Rectangle 7555"
        transform="translate(14345 3444) translate(-14345 -3444)"
        fill="#fff"
      >
        <rect
          width={11}
          height={11}
          rx={3}
          stroke="none"
        />
        <rect
          x={0.5}
          y={0.5}
          width={10}
          height={10}
          rx={2.5}
          fill="none"
        />
      </g>
      <path
        data-name="Path 43266"
        d="M-14340.839-3438.5l1.339 1.339 1.339-1.339z"
        fill="#84868b"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(14345 3444)"
      />
    </g>
  </svg>
);

export const checkboxIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    viewBox="0 0 11 11"
  >
    <g
      data-name="Group 20616"
      stroke="#84868b"
      strokeWidth={1}
    >
      <g
        data-name="Rectangle 7557"
        transform="translate(14345 3389) translate(-14345 -3389)"
        fill="#fff"
      >
        <rect
          width={11}
          height={11}
          rx={3}
          stroke="none"
        />
        <rect
          x={0.5}
          y={0.5}
          width={10}
          height={10}
          rx={2.5}
          fill="none"
        />
      </g>
      <path
        data-name="Path 43267"
        d="M-14341.489-3383.016l1.35 1.35 2.633-2.632"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(14345 3389)"
      />
    </g>
  </svg>
);

export const checklistIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.5}
    height={6.5}
    viewBox="0 0 12.5 6.5"
  >
    <g
      data-name="Group 19618"
      transform="translate(14143.5 3341.5)"
    >
      <circle
        data-name="Ellipse 18"
        cx={1}
        cy={1}
        r={1}
        transform="translate(-14143 -3341)"
        fill="none"
        stroke="#84868b"
        strokeWidth={1}
      />
      <g
        data-name="Ellipse 19"
        transform="translate(-14143 -3337)"
        fill="#84868b"
        stroke="#84868b"
        strokeWidth={1}
      >
        <circle
          cx={1}
          cy={1}
          r={1}
          stroke="none"
        />
        <circle
          cx={1}
          cy={1}
          r={0.5}
          fill="none"
        />
      </g>
      <rect
        data-name="Rectangle 7518"
        width={9}
        height={2}
        rx={1}
        transform="translate(-14140 -3341)"
        fill="#84868b"
      />
      <rect
        data-name="Rectangle 7519"
        width={9}
        height={2}
        rx={1}
        transform="translate(-14140 -3337)"
        fill="#84868b"
      />
    </g>
  </svg>
);

export const profileUserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.369}
    height={9.564}
    viewBox="0 0 8.369 9.564"
  >
    <path
      data-name="FontAwsome (user)"
      d="M5.858 5.679c-.536 0-.794.3-1.674.3s-1.136-.3-1.674-.3A2.511 2.511 0 000 8.189v.478a.9.9 0 00.9.9h6.572a.9.9 0 00.9-.9v-.478a2.511 2.511 0 00-2.514-2.51zm1.614 2.989H.9v-.479a1.617 1.617 0 011.611-1.614 7.314 7.314 0 001.674.3 7.244 7.244 0 001.674-.3 1.617 1.617 0 011.613 1.614zM4.184 5.38a2.69 2.69 0 10-2.69-2.69 2.691 2.691 0 002.69 2.69zm0-4.48a1.793 1.793 0 11-1.793 1.79A1.8 1.8 0 014.184.9z"
      fill="#84868b"
    />
  </svg>
);

export const attachementsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={9.143}
    viewBox="0 0 8 9.143"
  >
    <path
      data-name="FontAwsome (paperclip)"
      d="M.772 8.323A2.8 2.8 0 01.8 4.438L4.543.607a2 2 0 012.869 0 2.079 2.079 0 010 2.9L4.147 6.841a1.332 1.332 0 01-1.928-.018 1.384 1.384 0 01.026-1.91l2.566-2.622a.286.286 0 01.4 0l.408.4a.286.286 0 010 .4L3.061 5.712a.241.241 0 00-.012.327.19.19 0 00.28 0l3.266-3.334a.935.935 0 000-1.3.856.856 0 00-1.235 0L1.614 5.237a1.654 1.654 0 00-.021 2.291 1.523 1.523 0 002.2.005l3.07-3.143a.286.286 0 01.4 0l.409.4a.286.286 0 010 .4L4.608 8.332a2.664 2.664 0 01-3.836-.009z"
      fill="#84868b"
    />
  </svg>
);

export const imagesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={7.5}
    viewBox="0 0 10 7.5"
  >
    <path
      data-name="FontAwsome (image)"
      d="M9.063 64H.938a.937.937 0 00-.938.938v5.625a.937.937 0 00.938.938h8.125a.937.937 0 00.937-.938v-5.625A.937.937 0 009.063 64zm-.117 6.563H1.055a.117.117 0 01-.117-.117v-5.391a.117.117 0 01.117-.117h7.89a.117.117 0 01.117.117v5.391a.117.117 0 01-.117.117zM2.5 65.719a.781.781 0 10.781.781.781.781 0 00-.781-.781zm-.625 3.906h6.25v-1.562l-1.709-1.71a.234.234 0 00-.331 0L3.75 68.688l-.772-.772a.234.234 0 00-.331 0l-.772.772z"
      transform="translate(0 -64)"
      fill="#84868b"
    />
  </svg>
);
export const closeNotificationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.775"
    height="7.775"
    viewBox="0 0 7.775 7.775"
  >
    <g
      id="Group_18235"
      data-name="Group 18235"
      transform="translate(-2.409 -8.639)"
    >
      <g
        id="Group_20988"
        data-name="Group 20988"
        transform="translate(3.399 9.629)"
      >
        <path
          id="Path_21521"
          data-name="Path 21521"
          d="M5035.352,5196.5l5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_21522"
          data-name="Path 21522"
          d="M5041.146,5196.5l-5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </g>
  </svg>
);
export const unSubscribeMessageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.775"
    heunsubcribedMessageIconight="7.775"
    viewBox="0 0 7.775 7.775"
  >
    <g
      id="Group_18235"
      data-name="Group 18235"
      transform="translate(-2.409 -8.639)"
    >
      <g
        id="Group_20988"
        data-name="Group 20988"
        transform="translate(3.399 9.629)"
      >
        <path
          id="Path_21521"
          data-name="Path 21521"
          d="M5035.352,5196.5l5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_21522"
          data-name="Path 21522"
          d="M5041.146,5196.5l-5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </g>
  </svg>
);

export const featherCalendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.925}
    height={16.427}
    viewBox="0 0 14.925 16.427"
  >
    <g
      data-name="Icon feather-calendar"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40570"
        d="M6 4.503h10.522a1.5 1.5 0 011.5 1.5v10.522a1.5 1.5 0 01-1.5 1.5H6a1.5 1.5 0 01-1.5-1.5V6.003a1.5 1.5 0 011.5-1.5z"
        transform="translate(-3.8 -2.3)"
      />
      <path
        data-name="Path 40571"
        d="M14.268 3v3.005"
        transform="translate(-3.8 -2.3)"
      />
      <path
        data-name="Path 40572"
        d="M8.257 3v3.005"
        transform="translate(-3.8 -2.3)"
      />
      <path
        data-name="Path 40573"
        d="M4.5 9.011h13.525"
        transform="translate(-3.8 -2.3)"
      />
    </g>
  </svg>
);

export const restoreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrow-repeat"
    viewBox="0 0 16 16"
  >
    <path d="M11.534 7h3.932a.25.25 0 01.192.41l-1.966 2.36a.25.25 0 01-.384 0l-1.966-2.36a.25.25 0 01.192-.41zm-11 2h3.932a.25.25 0 00.192-.41L2.692 6.23a.25.25 0 00-.384 0L.342 8.59A.25.25 0 00.534 9z" />
    <path
      fillRule="evenodd"
      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 11-.771-.636A6.002 6.002 0 0113.917 7H12.9A5.002 5.002 0 008 3zM3.1 9a5.002 5.002 0 008.757 2.182.5.5 0 11.771.636A6.002 6.002 0 012.083 9H3.1z"
    />
  </svg>
);

export const coursePlayIcon = (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
  >
    <path d="M20 24H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4zM4 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" />
    <path d="M9 17c-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.9V8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l7 4c.3.2.5.5.5.9s-.2.7-.5.9l-7 4c-.2.1-.3.1-.5.1zm1-7.3v4.6l4-2.3-4-2.3z" />
  </svg>
);

export const resourceIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      clipPath="url(#clip0_4_155)"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.000853333}
    >
      <path d="M18.115 0H5.075c-1.042 0-1.89.72-1.89 1.606V2.71H1.89C.847 2.709 0 3.429 0 4.315v10.996c0 .43.194.83.551 1.134l3.63 3.087A2.05 2.05 0 005.516 20h9.41c1.042 0 1.89-.72 1.89-1.606V17.29h1.296c1.042 0 1.889-.72 1.889-1.606V1.606C20 .72 19.153 0 18.115 0zM4.362 18.106L2.237 16.3h2.125v1.807zm11.146.288c0 .271-.26.492-.579.492H5.663V15.74c0-.307-.291-.555-.653-.555h-3.7V4.311c0-.272.26-.492.58-.492h13.04c.319 0 .578.22.578.492v14.083zm2.607-2.213H16.82V4.311c0-.886-.848-1.606-1.89-1.606H4.496V1.602c0-.271.26-.492.58-.492H18.11c.32 0 .578.22.578.492V15.69h.005c0 .272-.26.492-.579.492z" />
      <path d="M13.698 5.11H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 7.953H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555 0-.307-.292-.555-.648-.555zM13.698 10.8H8.062c-.361 0-.653.247-.653.554 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 13.642H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 16.484H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.303-.292-.555-.648-.555zM5.737 4.807H3.126c-.361 0-.653.248-.653.555v2.225c0 .307.292.555.653.555h2.611c.362 0 .653-.248.653-.555V5.362c0-.307-.291-.555-.653-.555zm-.653 2.22H3.78v-1.11h1.305v1.11zM5.737 9.004H3.126c-.361 0-.653.248-.653.555v2.22c0 .308.292.556.653.556h2.611c.362 0 .653-.248.653-.555V9.56c0-.308-.291-.556-.653-.556zm-.653 2.22H3.78v-1.11h1.305v1.11z" />
    </g>
    <defs>
      <clipPath id="clip0_4_155">
        <path
          fill="#fff"
          d="M0 0H20V20H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const collapseSectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 30 30"
  >
    <defs>
      <marker
        orient="auto"
        refX={0}
        refY={0}
        overflow="visible"
      >
        <path
          d="M8.72 4.03L-2.21.02 8.72-4c-1.75 2.37-1.74 5.62 0 8.03z"
          transform="matrix(.3 0 0 .3 -.69 0)"
          fill="#000"
          fillOpacity={1}
          stroke="#000"
          strokeOpacity={1}
        />
      </marker>
      <marker
        orient="auto"
        refX={0}
        refY={0}
        overflow="visible"
      >
        <path
          d="M8.72 4.03L-2.21.02 8.72-4c-1.75 2.37-1.74 5.62 0 8.03z"
          transform="matrix(-.3 0 0 -.3 .69 0)"
          fill="#000"
          fillOpacity={1}
          stroke="#000"
          strokeOpacity={1}
        />
      </marker>
    </defs>
    <path
      style={{
        lineHeight: 'normal',
        fontVariantLigatures: 'normal',
        fontVariantPosition: 'normal',
        fontVariantCaps: 'normal',
        fontVariantNumeric: 'normal',
        fontVariantAlternates: 'normal',
        fontFeatureSettings: 'normal',
        textIndent: 0,
        textAlign: 'start',
        textDecorationLine: 'none',
        textDecorationStyle: 'solid',
        textDecorationColor: '#000',
        textTransform: 'none',
        textOrientation: 'mixed',
        whiteSpace: 'normal',
        shapePadding: 0,
        isolation: 'auto',
        mixBlendMode: 'normal',
        solidColor: '#000',
        solidOpacity: 1,
      }}
      d="M6 296.017l6.96 6.96a3.015 3.015 0 004.243 0l6.961-6.96a12.05 12.05 0 00-1.422-1.406l-6.953 6.953a.976.976 0 01-1.414 0l-6.953-6.953c-.515.426-.985.9-1.422 1.406z"
      color="#000"
      fontStyle="normal"
      fontVariant="normal"
      fontWeight={400}
      fontStretch="normal"
      fontSize="medium"
      fontFamily="sans-serif"
      textDecoration="none"
      letterSpacing="normal"
      wordSpacing="normal"
      writingMode="lr-tb"
      direction="ltr"
      dominantBaseline="auto"
      baselineShift="baseline"
      textAnchor="start"
      clipRule="nonzero"
      display="inline"
      overflow="visible"
      visibility="visible"
      opacity={0.87000002}
      colorInterpolation="sRGB"
      colorInterpolationFilters="linearRGB"
      vectorEffect="none"
      fill="currentColor"
      fillOpacity={1}
      fillRule="nonzero"
      stroke="none"
      strokeWidth={2}
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit={4}
      strokeDasharray="none"
      strokeDashoffset={0}
      strokeOpacity={1}
      colorRendering="auto"
      imageRendering="auto"
      shapeRendering="auto"
      textRendering="auto"
      transform="translate(0 -284.65)"
    />
  </svg>
);

export const assignmentSbIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.4}
    height={14.701}
    viewBox="0 0 11.4 14.701"
  >
    <g
      data-name="Group 20471"
      transform="translate(-19280.301 14499.974)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <path
        data-name="Subtraction 6"
        d="M19289.5-14485.974h-7a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h1.142v.925a.8.8 0 00.8.8h3.114a.8.8 0 00.8-.8v-.925h1.144a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5z"
      />
      <g
        data-name="Rectangle 11033"
        transform="translate(19283 -14499.974)"
      >
        <rect
          width={6}
          height={4}
          rx={1.5}
          stroke="none"
        />
        <rect
          x={0.7}
          y={0.7}
          width={4.6}
          height={2.6}
          rx={0.8}
        />
      </g>
      <path
        data-name="Line 1435"
        transform="translate(19283.557 -14492.914)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
      <path
        data-name="Line 1436"
        transform="translate(19283.557 -14489.99)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
    </g>
  </svg>
);

export const clearBtn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
  >
    <g
      data-name="close"
      transform="translate(-1137 -293)"
    >
      <rect
        data-name="Rectangle 753"
        width={26}
        height={26}
        rx={13}
        transform="translate(1137 293)"
        fill="#f7f8fa"
      />
      <g
        data-name="Group 17821"
        fill="none"
        stroke="#13171f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.7}
      >
        <path
          data-name="Path 21632"
          d="M5.947 0L0 5.947"
          transform="translate(1147.027 303.027)"
        />
        <path
          data-name="Path 21633"
          d="M5.947 5.947L0 0"
          transform="translate(1147.027 303.027)"
        />
      </g>
    </g>
  </svg>
);

export const defaultUserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 1280 1280"
    xmlSpace="preserve"
  >
    <path
      fill="#E6483F"
      opacity={1}
      d="M618 1281H1V1h1280v1280H618M350.966 998.052s-.026.061.099.522c.175.297.435.465.862.491 0 0 .013.085.269.616.643.416 1.285.832 2.464 1.703.793.854 1.585 1.708 2.348 2.742 0 0 .307 0 .806.19.136.116.271.232.57.856.26.236.521.471.66.747 0 0 .105-.075.219.576 2.085 1.55 4.17 3.1 6.648 4.836 0 0 .296.318.666.85.792.28 1.584.56 2.915 1.202 1.515.836 3.03 1.671 4.86 2.951.327.144.653.289 1.331.534 0 0 .295.217.563.828 3.653 1.64 7.306 3.278 11.07 4.886 0 0 .037.11.012.387l.322.23s.362-.137 1.021-.032c.44.068.88.135 1.848.583 3.25 1.287 6.5 2.575 9.717 3.972 0 0 .077-.086.47.492 2.424.457 4.848.915 8.083 1.245 1.36-.015 2.72-.03 4.03.47 1.72.76 3.44 1.519 5.838 2.219.452-.017.905-.033 1.862.323 1.525-.071 3.05-.142 5.38-.598 3.893.684 7.705-.464 11.734 2.543 3.006 2.243 8.5 1.498 12.886 1.5 124.479.063 248.958.069 373.437-.012 4.996-.003 9.985-1.005 14.989-1.413 3.172-.26 6.302.78 9.24-2.176 1.35-1.358 4.892-.6 7.444-.684 2.91-.096 5.93.425 8.713-.186 5.208-1.145 10.216-3.878 15.419-4.215 9.812-.635 15.517-10.112 25.116-10.663.13-.008.354-.204.36-.32.16-3.535 3.342-2.89 5.314-3.618 3.204-1.183 5.204-2.635 2.692-6.74 7.742 1.553 11.034-4.334 15.913-7.35 5.3-3.274 4.87-11.299 11.694-13.204.878-.246 1.195-2.885 1.554-4.465.25-1.096-.282-2.53.242-3.375 2.127-3.434 4.526-6.7 7.363-10.805 2.744-.068 4.736-2.236 5.546-6.259.867-4.297 1.649-8.923 3.843-12.581 5.488-9.15 5.94-19.268 6.606-29.298.728-10.98 1.017-22.02.81-33.022-.29-15.267-.654-30.574-2.07-45.763-1.008-10.82-3.907-21.456-5.75-32.21-.864-5.036.297-11.16-2.215-14.977-2.904-4.41 1.73-11.02-4.864-13.516 1.46-4.375-.625-8.039-1.952-12.025-.908-2.726.926-6.526-3.894-7.172-.278-.037-.756-1.959-.419-2.652 2.548-5.229-.166-6.781-5.282-6.828 0-2.116-.298-3.981.051-5.716 1.56-7.757-3.973-13.7-5.166-20.738-.08-.47-.982-.758-1.406-1.219-.884-.961-1.957-1.86-2.504-2.999-2.421-5.047-4.532-10.248-7.104-15.213-.69-1.333-2.658-1.969-3.946-3.038-.784-.651-1.925-1.476-1.99-2.296-.598-7.484-4.459-12.585-10.99-15.961-.604-.313-1.159-1.333-1.19-2.048-.27-6.218-4.81-8.268-8.487-9.658-1.724-2.691-2.55-4.965-4.16-6.284-3.154-2.585-6.72-4.678-10.161-6.902-3.73-2.409-6.255-7.01-11.634-6.443-2.918-6.64-10.326-6.37-15.314-9.87-8.303-5.83-19.335-3.795-27.966-9.09-1.126-.69-2.931-.307-4.424-.362-1.497-.055-3.055.226-4.488-.09-11.22-2.47-22.242-4.399-33.692-.123-4.098 1.53-7.634 2.01-7.164 7.477-3.19.153-6.408-.551-8.682.602-4.387 2.224-8.14 5.658-12.337 8.301-8.016 5.048-16.21 9.814-24.215 14.88-1.924 1.218-3.396 3.152-5.076 4.757-6.48 3.104-15.585 1.526-19.337 10.805-7.27 1.59-14.661 2.15-22.112 4.617-11.55 3.823-24.234 5.103-36.513 5.604-12.827.523-25.8-.632-38.603-2.028-10.082-1.1-20.003-3.675-29.992-5.612-1.3-.253-3.217-.184-3.766-.996-3.17-4.684-8.462-5.352-13.017-7.439-6.426-2.943-13.037-5.595-19.113-9.15-4.015-2.35-9.39-2.258-12.143-7.114-1.278-2.254-3.621-4.119-5.862-5.575-9.121-5.926-18.193-11.982-27.694-17.246-4.167-2.308-9.272-3.743-14.037-4.007-19.92-1.103-39.06 3.318-57.785 9.654-1.968.666-3.44 2.799-5.652 4.686-4.514-1.357-17.131 5.48-18.704 11.198-4.49-.112-9.682-1.02-9.461 6.2-7.028-.214-9.542 3.94-10.014 9.786-6.828.564-8.809 2.563-9.656 8.46-2.552 2.17-4.73 3.499-6.175 5.39-1.546 2.023-2.101 4.8-3.633 6.84-2.063 2.748-5.176 4.79-6.905 7.69-4.559 7.65-8.698 15.557-12.811 23.463-1.026 1.971-1.32 4.323-2.04 6.808-.74.97-2.176 2.196-2.778 3.747-2.866 7.383-5.658 14.802-8.164 22.312-1.476 4.424-2.308 9.059-3.545 13.567-.856 3.12-2.894 6.256-2.682 9.264.558 7.936-2.891 14.675-5.31 22.158 0 0 .074.384.023.941-.073.172-.147.343-.756.915-.134 2.243-.268 4.486-.33 7.453-.179.696-.358 1.392-.902 2.31a74.77 74.77 0 00-.081 2.57c-.131.405-.262.809-.814 1.375-.09.655-.18 1.31-.286 2.612-.132.41-.264.819-.805 1.67.106 1.606.212 3.212.157 4.78 0 0 .158.056-.398.542-.269 3.126-.537 6.251-.85 10.022-.139.406-.276.813-.787 1.429l-.287 2.72c-.046 1.067-.093 2.135-.439 3.879-.335 5.556-.67 11.112-.866 17.42-.035 1.527-.07 3.053-.45 5.392a1300.25 1300.25 0 01-.337 14.42c-.13 7.691-.261 15.382-.748 23.556.246 1.531.491 3.063.95 5.308.01.739.02 1.478-.292 2.765.38 1.536.76 3.071 1.29 4.611 0 0 .046.145.175.759.167 3.01.125 6.052.553 9.025.54 3.754 1.462 7.453 2.496 11.484 0 0 .125.394.115 1.21 1.882 5.488 3.764 10.977 6.228 16.57.194.031.389.063.957.444.48.157.96.313 1.58 1.089-.022.421-.044.842-.445 1.925-1.989 7.171 6.257 10.142 6.812 16.31.006.069 1.791-.023 2.8-.059 0 0 .015.054-.026.611.177.514.354 1.027.62 2.207.022.447.046.894-.128 1.755.454.53.909 1.058 1.429 1.587 0 0-.03.058.082.641.602.46 1.204.92 2.28 1.71.176.34.351.678.583 1.37.13.234.329.345 1.007.543 0 0 .295.355.429.874.25.247.5.495.653.78 0 0 .083-.064.142.57.873.862 1.745 1.724 2.721 2.632 0 0-.019.11.054.746.986.713 1.973 1.426 3.318 2.595.581.508 1.162 1.016 1.904 1.978.17.294.42.484.816.57M677.57 621.995c3.786-1.472 8.748-1.974 11.002-4.709 1.964-2.382 4.12-2.796 6.276-3.666 1.053-.425 2.877 1.32 4.107 1.033 4.171-.972 8.466-1.929 12.288-3.773 8.21-3.96 16.228-8.345 24.13-12.894 1.155-.664 1.242-3.18 2.053-5.497 5.592 1.718 9.414-3.022 13.78-6.455 1.094-.86 1.696-2.34 2.781-3.214 4.678-3.77 10.577-6.61 13.949-11.288 6.486-9 16.88-15.006 20.264-26.338.085-.282.929-.262 1.206-.573 1.906-2.133 3.921-4.2 5.576-6.52 1.652-2.315 3.052-4.836 4.332-7.383 1.734-3.452 4.458-6.987 4.539-10.538.094-4.128.225-6.813 4.676-7.091.553-1.784.988-3.293 1.488-4.782 2.535-7.55 5.269-15.039 7.556-22.662 1.178-3.925 1.268-8.17 2.37-12.126 4.106-14.748 4.28-29.8 3.469-44.875-.418-7.768-1.672-15.503-2.781-23.219-.794-5.518-1.957-10.983-3.005-16.463-.15-.787-.438-2.062-.91-2.19-3.028-.817-2.33-3.023-2.37-5.171-.025-1.377-.651-2.775-1.164-4.104-.738-1.91-1.765-3.715-2.407-5.652-1.571-4.742-2.413-9.822-4.604-14.242-3.748-7.56-7.866-15.02-12.638-21.967-5.164-7.518-11.181-14.46-16.973-21.532-2.742-3.35-5.238-7.214-10.584-6.864-.872.057-1.85-1.523-2.78-2.346l2.64-2.673c-7.26-6-14.08-12.556-21.797-17.788-10.123-6.863-20.693-13.19-31.574-18.765-6.785-3.476-14.701-4.671-21.75-7.723-11.063-4.79-22.39-6.942-34.383-5.864-1.438.13-3.15.055-4.36-.609-5.963-3.277-12.502-3.6-18.925-3.276-8.018.405-15.998 1.663-23.975 2.699-5.415.703-11.37.5-16.042 2.808-5.344 2.64-11.038 2.492-16.299 4.44-5.304 1.965-11.52 2.27-15.002 7.863-.385.619-1.773 1.044-2.578.9-4.445-.796-7.622 1.794-11.011 3.851-2.325 1.412-4.456 3.455-6.972 4.174-5.196 1.487-9.849 2.969-8.494 10.37-3.05 0-6.268-.932-8.031.27-1.66 1.13-1.784 4.512-2.668 7.159-4.071-.495-9.329-2.91-9.383 4.556-6.082.77-9.46 3.966-10.003 9.752-5.616.104-9.44 4.76-9.718 9.994-4.58-.432-4.984 2.951-5.742 6.294-.31 1.36-1.321 2.735-2.375 3.714-1.828 1.699-4.03 2.99-5.913 4.639-5.32 4.66-3.84 13.24-10.56 17.649-2.01 1.318-1.634 6.7-4.612 9.615-1.187 1.163-.195 4.55-.195 6.923l-1-.9c-1.15 1.096-2.98 2.003-3.344 3.317-3.225 11.637-9.817 22.583-7.548 35.399.103.578-.284 1.259-.494 1.875-1.061 3.11-2.75 6.15-3.075 9.333-.556 5.442-.27 10.972-.323 16.465-.164 16.716-.522 33.448 3.466 49.873.186.768.712 1.446.969 2.204.586 1.725 1.14 3.463 1.642 5.215 1.342 4.694 1.303 10.72 4.3 13.777 4.11 4.192 5.184 8.567 5.63 13.658.395 4.515 2.199 7.543 7.405 7.697.195 10.635 4.905 18.689 13.115 24.549.117 1.254-.244 2.919.426 3.695 5.318 6.17 10.559 12.45 16.362 18.148 5.974 5.866 12.442 11.252 18.908 16.59 4.729 3.903 9.648 7.626 14.784 10.965 2.836 1.844 8.359-.645 8.763 5.415.002.039 2.167-.37 3.132-.03 2.026.713 4.062 1.58 5.836 2.768 1.688 1.13 2.819 3.413 4.595 4.024 4.233 1.456 8.707 2.207 13.072 3.29.589.146 1.579.55 1.59.863.152 4.088 3.836 2.98 5.943 3.928 2.38 1.072 5.053 1.607 7.654 2.057 11.346 1.962 22.703 5.29 34.074 5.365 19.129.124 38.503 1.862 58.214-3.411z"
    />
    <path
      fill="#FFF"
      opacity={1}
      d="M412.87 1029.413c-1.36.016-2.721.031-4.84-.077a481.503 481.503 0 01-7.717-1.7s-.077.086-.268-.234c-3.48-1.557-6.767-2.795-10.055-4.032a9.392 9.392 0 01-1.768-.428c-.45-.224-.87-.25-.87-.25s-.036-.11-.289-.324c-.793-.72-1.605-1.127-1.83-1.746-1.58-4.36-4.942-5.686-9.255-3.537 0 0-.295-.217-.597-.525-.65-.43-.997-.55-1.345-.67-1.515-.836-3.03-1.671-4.948-2.988-1.23-.739-2.056-.996-2.881-1.253 0 0-.296-.318-.542-.781.068-5.29-4.741-3.07-6.516-5.024 0 0-.105.075-.073-.23-.264-.52-.56-.736-.855-.95-.136-.116-.271-.232-.62-.55-.213-.201-.563-.168-.563-.168-.793-.854-1.585-1.708-2.756-3.067-1.032-.913-1.687-1.32-2.342-1.729 0 0-.013-.085-.128-.301-.288-.506-.54-.679-.872-.736 0 0 .026-.06-.04-.317-.348-.427-.63-.598-.91-.768-.582-.508-1.163-1.016-1.956-2.057-1.2-1.255-2.19-1.976-3.179-2.697 0 0 .02-.111-.093-.44-.965-1.198-1.816-2.067-2.668-2.937 0 0-.083.063-.061-.237-.256-.533-.533-.765-.81-.998 0 0-.294-.355-.52-.641-.358-.53-.561-.638-.837-.61-.176-.339-.351-.678-.87-1.446a28.774 28.774 0 00-2.048-1.864s.029-.058-.034-.36c-.431-.767-.8-1.233-1.17-1.699-.022-.447-.046-.894.018-1.963-.163-1.129-.414-1.635-.665-2.142 0 0-.016-.054-.32-.27-5.795-1.44-2.606-6.184-3.91-9.105-4.425-1.296-4.425-1.296-5.018-7.592.022-.421.044-.842-.036-1.893-.685-.69-1.269-.75-1.852-.809-.194-.031-.389-.063-.956-.545-.83-2.7-1.053-5.034-1.803-7.183-1.157-3.317-2.676-6.507-4.042-9.752 0 0-.125-.394-.356-.947-.331-5.13-.196-9.73-.633-14.274-.206-2.153-1.508-4.2-2.314-6.296 0 0-.045-.145-.182-.516-.368-1.843-.6-3.315-.832-4.787-.01-.74-.02-1.48-.055-2.938-.206-2.17-.388-3.62-.57-5.072.132-7.69.263-15.38.62-23.889.303-5.35.38-9.883.455-14.415.035-1.527.07-3.053.236-5.25 4.792-6.02 2.41-11.75 1.034-17.426.047-1.068.094-2.136.378-3.822.3-1.182.36-1.746.422-2.31.138-.407.275-.814.607-1.9.533-3.73.873-6.78 1.213-9.828 0 0-.158-.055.063-.386.157-1.85.094-3.371.03-4.892.133-.409.265-.818.581-1.777.298-1.108.41-1.667.524-2.225.13-.404.261-.808.552-1.77.202-1.118.244-1.676.286-2.235.179-.696.358-1.392.62-2.832.317-2.865.55-4.988.783-7.11.073-.17.147-.342.36-.845.266-.606.21-.821-.03-.977 2.286-7.116 5.735-13.855 5.177-21.791-.212-3.008 1.826-6.144 2.682-9.264 1.237-4.508 2.069-9.143 3.545-13.567 2.506-7.51 5.298-14.93 8.164-22.312.602-1.55 2.038-2.778 2.779-3.747.72-2.485 1.013-4.837 2.039-6.808 4.113-7.906 8.252-15.813 12.811-23.463 1.729-2.9 4.842-4.942 6.905-7.69 1.532-2.04 2.087-4.817 3.633-6.84 1.445-1.891 3.623-3.22 6.175-5.39.847-5.897 2.828-7.896 9.656-8.46.472-5.846 2.986-10 10.014-9.787-.221-7.219 4.97-6.311 9.461-6.199 1.573-5.717 14.19-12.555 18.704-11.198 2.212-1.887 3.684-4.02 5.652-4.686 18.726-6.336 37.864-10.757 57.785-9.654 4.765.264 9.87 1.699 14.037 4.007 9.501 5.264 18.573 11.32 27.694 17.246 2.24 1.456 4.584 3.321 5.862 5.575 2.753 4.856 8.128 4.765 12.143 7.114 6.076 3.555 12.687 6.207 19.113 9.15 4.555 2.087 9.848 2.755 13.017 7.44.549.811 2.465.742 3.766.995 9.99 1.937 19.91 4.512 29.992 5.612 12.803 1.396 25.776 2.551 38.603 2.028 12.28-.501 24.963-1.781 36.513-5.604 7.45-2.466 14.843-3.027 22.112-4.617 3.752-9.279 12.857-7.701 19.337-10.805 1.68-1.605 3.152-3.539 5.076-4.757 8.005-5.066 16.199-9.832 24.215-14.88 4.198-2.643 7.95-6.077 12.337-8.301 2.274-1.153 5.491-.449 8.682-.602-.47-5.468 3.066-5.946 7.164-7.477 11.45-4.276 22.472-2.347 33.692.123 1.433.316 2.99.035 4.488.09 1.493.055 3.298-.329 4.424.362 8.631 5.295 19.663 3.26 27.966 9.09 4.988 3.5 12.396 3.23 15.314 9.87 5.379-.568 7.904 4.034 11.634 6.443 3.442 2.224 7.007 4.317 10.16 6.902 1.61 1.32 2.437 3.593 4.161 6.284 3.677 1.39 8.217 3.44 8.487 9.658.031.715.586 1.735 1.19 2.048 6.531 3.376 10.392 8.477 10.99 15.961.065.82 1.206 1.645 1.99 2.296 1.288 1.07 3.256 1.705 3.946 3.038 2.572 4.965 4.683 10.166 7.104 15.213.547 1.14 1.62 2.038 2.504 2.999.424.461 1.327.75 1.406 1.22 1.193 7.038 6.726 12.98 5.166 20.737-.349 1.735-.051 3.6-.051 5.716 5.116.047 7.83 1.6 5.282 6.828-.337.693.141 2.615.419 2.652 4.82.646 2.986 4.446 3.894 7.172 1.327 3.986 3.413 7.65 1.952 12.025 6.593 2.496 1.96 9.106 4.864 13.516 2.512 3.816 1.351 9.94 2.215 14.976 1.843 10.755 4.742 21.39 5.75 32.211 1.416 15.19 1.78 30.496 2.07 45.763.207 11.001-.082 22.042-.81 33.022-.666 10.03-1.118 20.147-6.606 29.298-2.194 3.658-2.976 8.284-3.843 12.581-.81 4.023-2.802 6.19-5.546 6.26-2.837 4.105-5.236 7.37-7.363 10.804-.524.845.008 2.279-.242 3.375-.36 1.58-.676 4.22-1.554 4.465-6.823 1.905-6.394 9.93-11.694 13.205-4.88 3.015-8.17 8.902-15.913 7.35 2.512 4.104.512 5.556-2.692 6.739-1.972.727-5.155.083-5.315 3.618-.005.116-.228.312-.359.32-9.6.55-15.304 10.028-25.116 10.663-5.203.337-10.211 3.07-15.419 4.215-2.782.611-5.803.09-8.713.186-2.552.083-6.095-.674-7.445.684-2.937 2.955-6.067 1.916-9.24 2.176-5.003.408-9.992 1.41-14.988 1.413-124.48.08-248.958.075-373.437.012-4.386-.002-9.88.743-12.886-1.5-4.029-3.007-7.84-1.859-12.46-2.225-2.204.182-3.68.045-5.158-.092-.453.016-.906.032-1.986-.098-2.138-.96-3.648-1.774-5.16-2.588z"
    />
    <path
      fill="#FFFEFE"
      opacity={1}
      d="M677.157 622.071c-19.298 5.197-38.672 3.459-57.8 3.335-11.372-.074-22.729-3.403-34.075-5.365-2.601-.45-5.274-.985-7.654-2.057-2.107-.949-5.791.16-5.942-3.928-.012-.313-1.002-.717-1.59-.863-4.366-1.083-8.84-1.834-13.073-3.29-1.776-.611-2.907-2.893-4.595-4.024-1.774-1.188-3.81-2.055-5.836-2.768-.965-.34-3.13.069-3.132.03-.404-6.06-5.927-3.571-8.763-5.415-5.136-3.339-10.055-7.062-14.784-10.966-6.466-5.337-12.934-10.723-18.908-16.59-5.803-5.697-11.044-11.977-16.362-18.147-.67-.776-.309-2.44-.426-3.695-8.21-5.86-12.92-13.914-13.115-24.55-5.206-.153-7.01-3.18-7.405-7.696-.446-5.09-1.52-9.466-5.63-13.658-2.997-3.058-2.958-9.083-4.3-13.777a111.906 111.906 0 00-1.642-5.215c-.257-.758-.783-1.436-.97-2.204-3.987-16.425-3.629-33.157-3.465-49.873.054-5.493-.233-11.023.323-16.465.325-3.182 2.014-6.224 3.075-9.333.21-.616.597-1.297.494-1.875-2.269-12.816 4.323-23.762 7.548-35.399.364-1.314 2.194-2.221 3.344-3.317l1 .9c0-2.374-.992-5.76.195-6.923 2.978-2.916 2.602-8.297 4.611-9.615 6.72-4.408 5.24-12.989 10.561-17.65 1.882-1.648 4.085-2.939 5.913-4.638 1.054-.979 2.066-2.353 2.375-3.714.758-3.343 1.162-6.726 5.742-6.294.278-5.234 4.102-9.89 9.718-9.994.542-5.786 3.921-8.982 10.003-9.752.054-7.465 5.312-5.05 9.383-4.556.884-2.647 1.009-6.029 2.668-7.16 1.763-1.201 4.98-.27 8.031-.27-1.355-7.4 3.298-8.882 8.494-10.369 2.516-.72 4.647-2.762 6.972-4.174 3.389-2.057 6.566-4.647 11.01-3.852.806.145 2.194-.28 2.58-.9 3.48-5.592 9.697-5.897 15.001-7.862 5.261-1.948 10.955-1.8 16.299-4.44 4.673-2.308 10.627-2.105 16.042-2.808 7.977-1.036 15.957-2.294 23.975-2.699 6.423-.324 12.962-.001 18.926 3.276 1.209.664 2.921.739 4.36.61 11.991-1.08 23.319 1.073 34.383 5.863 7.048 3.052 14.964 4.247 21.749 7.723 10.881 5.575 21.451 11.902 31.574 18.765 7.717 5.232 14.537 11.788 21.797 17.788l-2.64 2.673c.93.823 1.908 2.403 2.78 2.346 5.346-.35 7.842 3.515 10.584 6.864 5.792 7.073 11.809 14.014 16.973 21.532 4.772 6.947 8.89 14.407 12.638 21.967 2.191 4.42 3.033 9.5 4.604 14.242.642 1.937 1.67 3.742 2.407 5.652.513 1.329 1.139 2.727 1.164 4.104.04 2.148-.658 4.354 2.37 5.172.472.127.76 1.402.91 2.19 1.048 5.479 2.211 10.944 3.005 16.462 1.11 7.716 2.363 15.45 2.78 23.22.811 15.074.638 30.126-3.469 44.874-1.101 3.956-1.191 8.2-2.369 12.126-2.287 7.623-5.021 15.113-7.556 22.662-.5 1.489-.935 2.998-1.488 4.782-4.451.278-4.582 2.963-4.676 7.091-.081 3.55-2.805 7.086-4.54 10.538-1.279 2.547-2.68 5.068-4.331 7.384-1.655 2.32-3.67 4.386-5.576 6.52-.277.31-1.121.29-1.206.572-3.385 11.332-13.778 17.338-20.264 26.338-3.372 4.679-9.271 7.518-13.949 11.288-1.085.875-1.687 2.355-2.78 3.214-4.367 3.433-8.189 8.173-13.78 6.455-.812 2.316-.9 4.833-2.053 5.497-7.903 4.549-15.92 8.934-24.13 12.894-3.823 1.844-8.118 2.801-12.289 3.773-1.23.287-3.054-1.458-4.107-1.033-2.157.87-4.312 1.284-6.276 3.666-2.254 2.735-7.216 3.237-11.415 4.785z"
    />
    <path
      fill="#EB7872"
      opacity={1}
      d="M376.112 1017.39c4.179-2.454 7.541-1.129 9.122 3.232.224.62 1.036 1.026 1.774 1.762a137.17 137.17 0 01-10.896-4.993zM313.922 918.578c.74 1.788 2.043 3.836 2.25 5.989.436 4.545.3 9.145.493 14.12-.664-3.324-1.586-7.023-2.126-10.777-.428-2.973-.386-6.014-.617-9.332zM314.414 844.316c1.526 5.338 3.907 11.068-.954 16.713.134-5.263.47-10.82.954-16.713zM325.66 960.3c.782 5.966.782 5.966 5.207 7.262 1.304 2.921-1.885 7.665 3.884 9.115-.678.242-2.463.334-2.47.265-.554-6.168-8.8-9.139-6.621-16.641zM317.155 940.196c1.37 2.837 2.89 6.027 4.047 9.344.75 2.15.972 4.482 1.513 7.132-1.8-5.09-3.683-10.58-5.56-16.476zM313.12 867.06c.097 4.126.02 8.659-.245 13.547-.102-4.143-.015-8.642.245-13.547zM390.255 1023.56a144.88 144.88 0 019.807 3.787c-3.043-1.022-6.293-2.31-9.807-3.787zM316.905 826.361c-.062 2.806-.402 5.855-.913 9.262.098-2.768.366-5.893.913-9.262zM359.206 1006.17c1.718 1.628 6.527-.591 6.263 4.604-2.036-1.18-4.121-2.73-6.263-4.604zM320.354 803.092c.035 1.921-.198 4.044-.55 6.547.014-1.86.148-4.104.55-6.547zM412.844 1029.672c1.537.555 3.047 1.37 4.847 2.359-1.432-.583-3.152-1.342-4.847-2.36zM420.267 1032.285c1.225-.05 2.702.088 4.504.099-1.201-.055-2.727.016-4.504-.1zM400.51 1027.925c2.122.237 4.442.763 7.115 1.475a49.584 49.584 0 01-7.115-1.475zM317.073 821.061c.267 1.3.33 2.82.253 4.69-.246-1.257-.352-2.863-.253-4.69zM312.041 905.2c.36 1.21.54 2.66.64 4.474-.327-1.17-.572-2.7-.64-4.474zM312.682 913.241c.393 1.2.625 2.671.917 4.512-.319-1.167-.698-2.702-.917-4.512zM344.892 992.592c.952.403 1.942 1.124 2.963 2.15-.954-.407-1.94-1.12-2.963-2.15zM342.124 989.214c.822.553 1.673 1.422 2.586 2.598-.812-.557-1.684-1.419-2.586-2.598zM319.036 812.944c.141.448.1 1.006-.107 1.8-.134-.406-.105-1.048.107-1.8zM337.003 983.393c.514.186 1.082.665 1.757 1.407-.497-.196-1.1-.656-1.757-1.407zM335.646 981.25c.468.258.837.724 1.236 1.492-.425-.228-.88-.757-1.236-1.493zM315.176 837.95c.126.46.064 1.024-.193 1.807-.128-.422-.06-1.062.193-1.807zM318.17 816.919c.098.477-.015 1.036-.305 1.82-.086-.429.004-1.084.305-1.82zM352.068 999.416c.527.142 1.182.55 1.946 1.235-.533-.138-1.175-.554-1.946-1.235zM366.392 1011.915c.64-.009 1.466.248 2.426.805-.657.02-1.45-.26-2.426-.805zM335.076 977.216c.272.228.523.734.642 1.53-.308-.225-.485-.738-.642-1.53zM324.148 957.443c.396-.115.98-.056 1.595.324-.448.164-.928.008-1.595-.324zM387.34 1022.83c.013-.138.432-.112.552.06.12.172-.242.31-.242.31s-.322-.23-.31-.37zM320.886 801.253c.306-.028.362.187.121.514-.114.053-.189-.33-.121-.514zM374.194 1016.112c.19-.102.537.018 1.011.397-.2.114-.526-.03-1.011-.397zM358.303 1004.918c.213-.04.509.175.834.676-.232.05-.492-.186-.834-.676zM357.023 1004.036c.015-.09.365-.123.329-.017-.037.107-.344.107-.33.017zM351.002 998.344c.27-.174.522 0 .767.512-.27.183-.529.015-.767-.512zM350.07 997.255c.2-.057.482.114.796.54-.295.17-.545-.019-.796-.54zM341.29 987.921c.21-.026.487.206.791.72-.223.035-.473-.213-.79-.72zM339.894 986.588c.248-.205.45-.097.603.327-.246.194-.445.083-.603-.327z"
    />
  </svg>
);

export const feedbackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.994}
    height={16.277}
    viewBox="0 0 15.994 16.277"
  >
    <path
      d="M.2 15.794V1.37A1.133 1.133 0 01.551.561 1.108 1.108 0 011.37.2h13.254a1.119 1.119 0 01.809.361 1.119 1.119 0 01.361.809v10.136a1.237 1.237 0 01-1.17 1.17H3.319zm1.17-2.826l1.462-1.462h11.792V1.37H1.37zm0-11.6h0z"
      fill="#707070"
      stroke="#707070"
      strokeWidth={0.4}
      opacity={0.735}
    />
  </svg>
);

export const clearFormIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.246}
    height={12.65}
    viewBox="0 0 15.246 12.65"
  >
    <path
      d="M6 26.65v-1.9h11.858v1.9zm1.694-5.376v-1.9h11.858v1.9zM9.388 15.9V14h11.858v1.9z"
      transform="translate(-6 -14)"
      fill="#474b89"
    />
  </svg>
);

export const eyeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.093}
    height={12.813}
    viewBox="0 0 17.093 12.813"
  >
    <g
      transform="translate(-.3 -3.3)"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21634"
        d="M1 9.707S3.853 4 8.847 4s7.847 5.707 7.847 5.707-2.853 5.707-7.847 5.707S1 9.707 1 9.707z"
      />
      <circle
        data-name="Ellipse 35"
        cx={2}
        cy={2}
        r={2}
        transform="translate(7 7.413)"
      />
    </g>
  </svg>
);

export const LockPadIcon = (
  <svg
    height="64px"
    width="64px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 451.277 451.277"
    xmlSpace="preserve"
    fill="#000"
  >
    <circle
      cx={225.638}
      cy={225.638}
      r={225.638}
      fill="#45b39c"
    />
    <path
      d="M444.558 280.446l-166.57-166.57-1.598-1.598c-13.116-12.787-31.028-20.638-50.773-20.638-40.195 0-72.963 32.767-72.963 72.963v38.033h-10.766c-8.556 0-15.467 6.911-15.467 15.467v126.086c0 4.137 1.645 7.945 4.372 10.719l.517.517 95.806 95.835c105.066-.679 193.066-73.139 217.442-170.814z"
      opacity={0.1}
    />
    <path
      d="M309.4 212.044H141.877c-8.535 0-15.456 6.92-15.456 15.456v116.667c0 8.536 6.92 15.456 15.456 15.456H309.4c8.535 0 15.455-6.92 15.455-15.456V227.5c0-8.536-6.92-15.456-15.455-15.456z"
      fill="#dc8744"
    />
    <path
      d="M272.568 164.618v38.023h26.034v-38.023c0-40.232-32.732-72.964-72.964-72.964v26.034c25.879 0 46.93 21.051 46.93 46.93z"
      fill="#3a556a"
    />
    <path
      d="M178.709 202.642v-38.023c0-25.879 21.052-46.93 46.929-46.93V91.654c-40.231 0-72.963 32.732-72.963 72.964v38.023h26.034z"
      fill="#64798a"
    />
    <path
      d="M309.4 202.642h-83.762V350.22H309.4c8.535 0 15.455-6.92 15.455-15.456V218.097c0-8.536-6.92-15.455-15.455-15.455z"
      fill="#f6c358"
    />
    <path
      d="M178.711 202.642H141.877c-8.535 0-15.456 6.92-15.456 15.456v116.667c0 8.536 6.92 15.456 15.456 15.456h83.761V202.642h-46.927z"
      fill="#fcd462"
    />
    <path
      d="M243.305 253.907c0-9.757-7.909-17.667-17.667-17.667-9.757 0-17.667 7.91-17.667 17.667 0 6.272 3.29 11.747 8.217 14.882l-5.269 25.104h29.436l-5.268-25.104c4.928-3.135 8.218-8.609 8.218-14.882z"
      fill="#dc8744"
    />
  </svg>
);

export const btnClearIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
  >
    <g
      data-name="close"
      transform="translate(-1137 -293)"
    >
      <rect
        data-name="Rectangle 753"
        width={26}
        height={26}
        rx={13}
        transform="translate(1137 293)"
        fill="none"
      />
      <g
        data-name="Group 17821"
        fill="none"
        stroke="currentColor"
      >
        <path
          data-name="Path 21632"
          d="M0 0v8.41"
          transform="translate(1147.027 303.027) rotate(45 2.974 7.179)"
        />
        <path
          data-name="Path 21633"
          d="M0 0v8.41"
          transform="translate(1147.027 303.027) rotate(135 1.742 4.205)"
        />
      </g>
    </g>
  </svg>
);

export const taxonomyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
  >
    <g
      data-name="grid (1)"
      transform="translate(-2.3 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Rectangle 11032"
        transform="translate(3 3)"
        d="M0 0H6V6H0z"
      />
      <path
        data-name="Rectangle 11033"
        transform="translate(12 3)"
        d="M0 0H6V6H0z"
      />
      <path
        data-name="Rectangle 11034"
        transform="translate(12 12)"
        d="M0 0H6V6H0z"
      />
      <path
        data-name="Rectangle 11035"
        transform="translate(3 12)"
        d="M0 0H6V6H0z"
      />
    </g>
  </svg>
);

export const learnerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21.739}
    height={15.147}
    viewBox="0 0 21.739 15.147"
  >
    <g
      data-name="Group 20501"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        data-name="user (1)"
        transform="translate(-244.42 -237.675) translate(245.12 238.375)"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 1"
          d="M12.219 13.747v-1.88c0-2.076-1.368-3.76-3.055-3.76H3.055C1.368 8.107 0 9.79 0 11.867v1.88"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.76}
          cy={3.76}
          r={3.76}
          transform="translate(2.35)"
        />
      </g>
      <g strokeWidth={1.1}>
        <path
          data-name="Path 10"
          d="M0 0h1.919A1.279 1.279 0 013.2 1.279v4.477a.959.959 0 00-.962-.956H0z"
          transform="translate(-244.42 -237.675) translate(259.214 239.968)"
        />
        <path
          data-name="Path 11"
          d="M6.398 0H4.477a1.279 1.279 0 00-1.279 1.279v4.477a.959.959 0 01.959-.959h2.241z"
          transform="translate(-244.42 -237.675) translate(259.214 239.968)"
        />
      </g>
    </g>
  </svg>
);

export const fieldManageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    viewBox="0 0 15 13"
  >
    <g
      data-name="edit-3 (1)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 12"
        d="M10.052 15.339H16.1"
        transform="translate(-2.3 -2.043)"
      />
      <path
        data-name="Path 13"
        d="M12.864 3.331a1.547 1.547 0 112.192 2.183l-9.133 9.1L3 15.339l.731-2.911z"
        transform="translate(-2.3 -2.043)"
      />
    </g>
  </svg>
);

export const activityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.4}
    height={14}
    viewBox="0 0 15.4 14"
  >
    <path
      d="M14.7 7h-2.8l-2.1 6.3L5.6.7 3.5 7H.7"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const usersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    viewBox="0 0 16.5 16.5"
  >
    <g
      data-name="user (1)"
      transform="translate(-3.3 -2.3)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 1"
        d="M17 17.625v-2c0-2.209-1.455-4-3.25-4h-6.5c-1.795 0-3.25 1.791-3.25 4v2"
      />
      <circle
        data-name="Ellipse 1"
        cx={4}
        cy={4}
        r={4}
        transform="translate(6.5 3)"
      />
    </g>
  </svg>
);

export const lectureListIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={18.4}
    viewBox="0 0 15 18.4"
  >
    <g
      data-name="book (2)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 27"
        d="M4 16.875a2.125 2.125 0 012.125-2.125H17.6"
        transform="translate(-3.3 -1.3)"
      />
      <path
        data-name="Path 28"
        d="M6.125 2H17.6v17H6.125A2.125 2.125 0 014 16.875V4.125A2.125 2.125 0 016.125 2z"
        transform="translate(-3.3 -1.3)"
      />
    </g>
  </svg>
);

export const accessorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21.398}
    height={15.147}
    viewBox="0 0 21.398 15.147"
  >
    <g
      data-name="Group 20528"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        data-name="user (1)"
        transform="translate(-244.42 -237.675) translate(245.12 238.375)"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 1"
          d="M12.219 13.747v-1.88c0-2.076-1.368-3.76-3.055-3.76H3.055C1.368 8.107 0 9.79 0 11.867v1.88"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.76}
          cy={3.76}
          r={3.76}
          transform="translate(2.35)"
        />
      </g>
      <path
        data-name="check (5)"
        d="M264.898 240.354l-3.8 3.8-1.728-1.727"
        strokeWidth={1.3}
        transform="translate(-244.42 -237.675)"
      />
    </g>
  </svg>
);

export const tutorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.16}
    height={16.455}
    viewBox="0 0 19.16 16.455"
  >
    <g data-name="Group 20498">
      <g
        data-name="Group 20495"
        fill="none"
        stroke="#84868b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      >
        <g
          data-name="user (1)"
          transform="translate(-198.92 -244.87) translate(-56.88) translate(252.5 243)"
        >
          <path
            data-name="Path 1"
            d="M17 17.625v-2c0-2.209-1.455-4-3.25-4h-6.5c-1.795 0-3.25 1.791-3.25 4v2"
          />
          <circle
            data-name="Ellipse 1"
            cx={4}
            cy={4}
            r={4}
            transform="translate(6.5 3)"
          />
        </g>
        <path
          data-name="Path 4"
          d="M272.678 245.86a5.4 5.4 0 010 7.64m-1.907-5.733a2.7 2.7 0 010 3.82"
          transform="translate(-198.92 -244.87) translate(-56.88)"
        />
      </g>
    </g>
  </svg>
);

export const feedbacksIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.436}
    height={15.436}
    viewBox="0 0 15.436 15.436"
  >
    <g
      data-name="Group 20509"
      transform="translate(-144.3 -246.3)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeWidth={1.4}
    >
      <path
        d="M159.036 256.357a1.56 1.56 0 01-1.56 1.56h-9.357L145 261.036V248.56a1.56 1.56 0 011.56-1.56h10.916a1.56 1.56 0 011.56 1.56z"
        strokeLinejoin="round"
      />
      <path
        data-name="Line 1443"
        transform="translate(149.656 250.36)"
        d="M0 0L4.725 0"
      />
      <path
        data-name="Line 1444"
        transform="translate(149.656 253.134)"
        d="M0 0L2.989 0"
      />
    </g>
  </svg>
);

export const targetsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.844}
    height={15.182}
    viewBox="0 0 14.844 15.182"
  >
    <g data-name="Group 20534">
      <g
        transform="translate(-307.078 -280.133) translate(6 4) translate(300 276)"
        fill="none"
        stroke="#84868b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
        data-name="Group 20531"
      >
        <ellipse
          data-name="Ellipse 324"
          cx={4.722}
          cy={4.891}
          rx={4.722}
          ry={4.891}
          transform="translate(3.778 2.833)"
        />
        <path
          data-name="Line 1453"
          transform="translate(8.5 .833)"
          d="M0 4L0 0"
        />
        <path
          data-name="Line 1454"
          transform="translate(8.5 10.615)"
          d="M0 4L0 0"
        />
        <path
          data-name="Line 1455"
          transform="translate(11.222 7.893)"
          d="M0 0L4 0"
        />
        <path
          data-name="Line 1456"
          transform="translate(1.778 7.893)"
          d="M0 0L4 0"
        />
      </g>
    </g>
  </svg>
);

export const quickAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.4}
    height={13.763}
    viewBox="0 0 14.4 13.763"
  >
    <path
      data-name="star (1)"
      d="M7.2.7l2.008 4.069 4.492.657-3.25 3.165.767 4.472L7.2 10.95l-4.017 2.113.767-4.472L.7 5.426l4.491-.657z"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const orgIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.047}
    height={18.734}
    viewBox="0 0 14.047 18.734"
  >
    <g
      data-name="Group 20529"
      fill="none"
    >
      <g
        data-name="Rectangle 11040"
        stroke="#84868b"
        strokeWidth={1.4}
      >
        <path
          d="M2 0h3.8a2 2 0 012 2v16.734H2a2 2 0 01-2-2V2a2 2 0 012-2z"
          stroke="none"
          transform="translate(-227.733 -143.149) translate(227.733 143.149)"
        />
        <path
          d="M2 .7h3.8A1.3 1.3 0 017.1 2v15.334a.7.7 0 01-.7.7H2a1.3 1.3 0 01-1.3-1.3V2A1.3 1.3 0 012 .7z"
          transform="translate(-227.733 -143.149) translate(227.733 143.149)"
        />
      </g>
      <g
        data-name="Rectangle 11043"
        transform="translate(-227.733 -143.149) translate(227.733 149.151)"
        stroke="#84868b"
        strokeWidth={1.4}
      >
        <path
          stroke="none"
          d="M0 0H7.803V7.305H0z"
        />
        <path d="M0.7 0.7H7.103V6.605H0.7z" />
      </g>
      <g
        data-name="Rectangle 11044"
        stroke="#84868b"
        strokeWidth={1.4}
      >
        <path
          d="M0 0h5.68a2 2 0 012 2v5.305H0V0z"
          stroke="none"
          transform="translate(-227.733 -143.149) translate(234.1 149.151)"
        />
        <path
          d="M1.4.7h4.28A1.3 1.3 0 016.98 2v3.905a.7.7 0 01-.7.7H1.4a.7.7 0 01-.7-.7V1.4a.7.7 0 01.7-.7z"
          transform="translate(-227.733 -143.149) translate(234.1 149.151)"
        />
      </g>
      <g data-name="Path 26">
        <path
          d="M.03 0h5.65a1.931 1.931 0 012 1.854v9.023a1.931 1.931 0 01-2 1.854H0z"
          transform="translate(-227.733 -143.149) translate(234.1 149.151)"
        />
        <path
          d="M1.427 1.4l-.024 9.932H5.68c.325 0 .6-.208.6-.455V1.854c0-.246-.275-.454-.6-.454H1.427M.03 0h5.65c1.105 0 2 .83 2 1.854v9.023c0 1.024-.895 1.855-2 1.855H0L.03 0z"
          fill="#84868b"
          transform="translate(-227.733 -143.149) translate(234.1 149.151)"
        />
      </g>
    </g>
  </svg>
);

export const docsBankIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.697}
    height={13.692}
    viewBox="0 0 16.697 13.692"
  >
    <g
      data-name="archive (1)"
      transform="translate(-.284 -2.552)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 17"
        d="M14.868 6.53v9.014H2.388V6.53"
      />
      <path
        data-name="Rectangle 11036"
        transform="translate(.984 3.252)"
        d="M0 0H15.297V3.278H0z"
      />
    </g>
  </svg>
);

export const profileCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={18.4}
    viewBox="0 0 18.4 18.4"
  >
    <g
      data-name="Group 20504"
      transform="translate(-105.8 -129.8)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <g
        data-name="user (1)"
        transform="translate(109.9 134.051)"
      >
        <path
          data-name="Path 1"
          d="M10.2 11.471V9.903a2.89 2.89 0 00-2.552-3.138h-5.1A2.89 2.89 0 000 9.903v1.569"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.233}
          cy={3.233}
          r={3.233}
          transform="translate(1.8)"
        />
      </g>
      <circle
        cx={8.5}
        cy={8.5}
        r={8.5}
        transform="translate(106.5 130.5)"
      />
    </g>
  </svg>
);

export const alertCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.4}
    height={17.4}
    viewBox="0 0 17.4 17.4"
  >
    <g
      data-name="alert-circle (1)"
      transform="rotate(180 9.35 9.35)"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle
        data-name="Ellipse 93"
        cx={8}
        cy={8}
        r={8}
        transform="translate(2 2)"
        strokeWidth={1.4}
      />
      <path
        data-name="Line 1449"
        transform="translate(10 6.5)"
        strokeWidth={1.5}
        d="M0 0L0 4"
      />
      <path
        data-name="Line 1450"
        transform="translate(9.999 13.2)"
        strokeWidth={1.5}
        d="M0 0L0.01 0"
      />
    </g>
  </svg>
);

export const keyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.23}
    height={14.828}
    viewBox="0 0 15.23 14.828"
  >
    <path
      d="M13.838.99l-1.383 1.383M7.193 7.635a3.8 3.8 0 11-5.379 0 3.8 3.8 0 015.379 0zm0 0l2.842-2.845m0 0l2.074 2.078 2.42-2.42-2.074-2.075m-2.42 2.417l2.42-2.42"
      fill="none"
      stroke="#84868b"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const administratorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g
      data-name="Group 27256"
      transform="translate(-31 -743)"
    >
      <circle
        data-name="Ellipse 453"
        cx={96}
        cy={96}
        r={96}
        transform="translate(31 743)"
        fill="#ededf6"
      />
      <g
        data-name="Group 27251"
        stroke="#6f75bc"
        strokeLinejoin="round"
      >
        <g
          data-name="user (1)"
          transform="translate(60 792) translate(0 8.457)"
          fill="#6f75bc"
          strokeWidth={1.4}
        >
          <path
            data-name="Path 1"
            d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
          />
          <circle
            data-name="Ellipse 1"
            cx={23.257}
            cy={23.257}
            r={23.257}
            transform="translate(14.535)"
            strokeLinecap="round"
          />
        </g>
        <path
          data-name="key (1)"
          d="M131.392 0l-5.366 5.366m-20.418 20.416a14.756 14.756 0 11-20.87 0 14.754 14.754 0 0120.87 0zm0 0l11.027-11.027m0 0l8.049 8.045 9.391-9.39-8.049-8.044m-9.391 9.39l9.391-9.39"
          fill="none"
          strokeLinecap="round"
          strokeWidth={6.1}
          transform="translate(60 792)"
        />
      </g>
    </g>
  </svg>
);

export const verifierIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g
      data-name="Group 27255"
      transform="translate(-280 -743)"
    >
      <circle
        data-name="Ellipse 452"
        cx={96}
        cy={96}
        r={96}
        transform="translate(280 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27250">
        <g data-name="Group 27238">
          <g
            data-name="user (1)"
            transform="translate(11 684.831) translate(299 109) translate(0 8.457)"
            fill="#6f75bc"
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth={1.4}
          >
            <path
              data-name="Path 1"
              d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
            />
            <circle
              data-name="Ellipse 1"
              cx={23.257}
              cy={23.257}
              r={23.257}
              transform="translate(14.535)"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g data-name="Group 27239">
          <g
            data-name="Group 20797"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={6}
          >
            <path
              d="M21.922 54.8s21.921-10.957 21.921-27.4V8.221L21.922 0 0 8.221V27.4c0 16.443 21.922 27.4 21.922 27.4z"
              transform="translate(11 684.831) translate(57.999 -422.128) translate(328.199 527.297)"
            />
            <path
              data-name="check (5)"
              d="M31.854 20.077L17.898 34.033l-6.344-6.343"
              transform="translate(11 684.831) translate(57.999 -422.128) translate(328.199 527.297)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const tutorsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g
      data-name="Group 27254"
      transform="translate(-527 -743)"
    >
      <circle
        data-name="Ellipse 451"
        cx={96}
        cy={96}
        r={96}
        transform="translate(527 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27249">
        <g data-name="Group 27241">
          <g data-name="Group 27238">
            <g
              data-name="user (1)"
              transform="translate(12 685.631) translate(247 1.831) translate(299 109) translate(0 8.457)"
              fill="#6f75bc"
              stroke="#6f75bc"
              strokeLinejoin="round"
              strokeWidth={1.4}
            >
              <path
                data-name="Path 1"
                d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
              />
              <circle
                data-name="Ellipse 1"
                cx={23.257}
                cy={23.257}
                r={23.257}
                transform="translate(14.535)"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
        <g data-name="Group 27242">
          <g data-name="Group 27208">
            <g
              data-name="Group 27203"
              transform="translate(12 685.631) translate(547.285 -257.879) translate(84 361.248)"
            >
              <rect
                data-name="Rectangle 11634"
                width={45}
                height={52}
                rx={2}
                transform="translate(-.285)"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
              />
              <path
                data-name="Line 1620"
                transform="translate(13.042 38.819)"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
                d="M19.829 0L0 0"
              />
              <path
                data-name="check (4)"
                d="M30.155 15.192L19.43 25.916l-4.875-4.874"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
                style={{
                  mixBlendMode: 'darken',
                  isolation: 'isolate',
                }}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const learnersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g
      data-name="Group 27253"
      transform="translate(-774 -743)"
    >
      <circle
        data-name="Ellipse 450"
        cx={96}
        cy={96}
        r={96}
        transform="translate(774 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27247">
        <g data-name="Group 27241">
          <g data-name="Group 27238">
            <g
              data-name="user (1)"
              transform="translate(10 680.141) translate(496 4.462) translate(299 109) translate(0 8.457)"
              fill="#6f75bc"
              stroke="#6f75bc"
              strokeLinejoin="round"
              strokeWidth={1.4}
            >
              <path
                data-name="Path 1"
                d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
              />
              <circle
                data-name="Ellipse 1"
                cx={23.257}
                cy={23.257}
                r={23.257}
                transform="translate(14.535)"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
        <g
          fill="none"
          stroke="#6f75bc"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={6}
        >
          <path
            data-name="Path 10"
            d="M0 0h13.934a9.289 9.289 0 019.289 9.289V41.8a6.967 6.967 0 00-6.967-6.967H0z"
            transform="translate(10 680.141) translate(877.584 109.859)"
          />
          <path
            data-name="Path 11"
            d="M46.446 0H32.512a9.289 9.289 0 00-9.289 9.289V41.8a6.967 6.967 0 016.967-6.967h16.256z"
            transform="translate(10 680.141) translate(877.584 109.859)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const assessorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="assessorIcon"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g
      data-name="Group 27252"
      transform="translate(-1020 -743)"
    >
      <circle
        data-name="Ellipse 449"
        cx={96}
        cy={96}
        r={96}
        transform="translate(1020 743)"
        fill="#ededf6"
      />
      <g
        data-name="Group 27248"
        transform="translate(11 686)"
      >
        <g data-name="Group 27245">
          <g data-name="Group 27241">
            <g data-name="Group 27238">
              <g
                data-name="user (1)"
                transform="translate(246 -2.859) translate(496 4.462) translate(299 109) translate(0 8.457)"
                fill="currentColor"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth={1.4}
              >
                <path
                  data-name="Path 1"
                  d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
                />
                <circle
                  data-name="Ellipse 1"
                  cx={23.257}
                  cy={23.257}
                  r={23.257}
                  transform="translate(14.535)"
                  strokeLinecap="round"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 48797"
          d="M1163.959 138.919h-10.555v-2.926l.343 1.171v1.756l-.343-3.388.343-4.666a54.338 54.338 0 011.494-7.205 59.597 59.597 0 011.615-4.9 32.62 32.62 0 011.05-2.442 14.733 14.733 0 001.15-3.149 8.981 8.981 0 00-.747-6.055 9.3 9.3 0 00-16.611 0 9.082 9.082 0 00-.747 6.055 15.9 15.9 0 001.15 3.149 26.244 26.244 0 011.05 2.442 61.273 61.273 0 011.615 4.9 51.282 51.282 0 011.494 7.205l.3 5.127v2.927h-10.636a4.339 4.339 0 00-4.34 4.339v5.066h36.714v-5.066a4.339 4.339 0 00-4.34-4.339z"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth={5}
        />
        <path
          data-name="Line 1623"
          transform="translate(1130.25 157.576)"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth={5}
          d="M0 0L39.359 0"
        />
      </g>
    </g>
  </svg>
);

export const accessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.473}
    height={10.795}
    viewBox="0 0 11.473 10.795"
  >
    <g
      data-name="download (1)"
      transform="rotate(90 5.037 5.737)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 48804"
        d="M9.395 3.132V1.044A1.044 1.044 0 008.351 0H1.044A1.044 1.044 0 000 1.044v2.088"
      />
      <path
        data-name="Path 48805"
        d="M2.088 6.42l2.61-2.61 2.61 2.61"
      />
      <path
        data-name="Line 1648"
        transform="translate(4.649 4.218)"
        d="M0 0L0 5.855"
      />
    </g>
  </svg>
);

export const unitBankIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.308}
    height={15.761}
    viewBox="0 0 16.308 15.761"
  >
    <g
      data-name="Group 27695"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <path
        data-name="Path 49083"
        d="M25.081 502.652L18 506.192l7.081 3.54 7.081-3.54z"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49084"
        d="M18 513.273l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49085"
        d="M18 509.732l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
    </g>
  </svg>
);

export const adminProfileIcon = (
  <svg
    className="dropdown-profile-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="22.925"
    height="16.592"
    viewBox="0 0 22.925 16.592"
  >
    <g
      id="Group_20551"
      data-name="Group 20551"
      transform="translate(-17.3 -456.855)"
    >
      <g
        id="user_1_"
        data-name="user (1)"
        transform="translate(18 459)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M16.219,20.64V18.76c0-2.076-1.368-3.76-3.055-3.76H7.055C5.368,15,4,16.683,4,18.76v1.88"
          transform="translate(-4 -6.893)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <circle
          id="Ellipse_1"
          data-name="Ellipse 1"
          cx="3.76"
          cy="3.76"
          r="3.76"
          transform="translate(2.35 0)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
      <path
        id="key_1_"
        data-name="key (1)"
        d="M10.242,2l-.868.867m-3.3,3.3a2.386,2.386,0,1,1-3.374,0,2.385,2.385,0,0,1,3.374,0Zm0,0L7.856,4.385m0,0,1.3,1.3,1.518-1.518-1.3-1.3M7.856,4.385,9.374,2.867"
        transform="translate(29 455.633)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1"
      />
    </g>
  </svg>
);

export const learnerProfileIcon = (
  <svg
    className="dropdown-profile-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21.739"
    height="15.147"
    viewBox="0 0 21.739 15.147"
  >
    <g
      id="Group_20548"
      data-name="Group 20548"
      transform="translate(-244.42 -237.675)"
    >
      <g
        id="user_1_"
        data-name="user (1)"
        transform="translate(245.12 238.375)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M16.219,20.64V18.76c0-2.076-1.368-3.76-3.055-3.76H7.055C5.368,15,4,16.683,4,18.76v1.88"
          transform="translate(-4 -6.893)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <circle
          id="Ellipse_1"
          data-name="Ellipse 1"
          cx="3.76"
          cy="3.76"
          r="3.76"
          transform="translate(2.35 0)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
      <g
        id="book-open"
        transform="translate(259.214 239.968)"
      >
        <path
          id="Path_10"
          data-name="Path 10"
          d="M2,3H3.919A1.279,1.279,0,0,1,5.2,4.279V8.756A.959.959,0,0,0,4.238,7.8H2Z"
          transform="translate(-2 -3)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.1"
        />
        <path
          id="Path_11"
          data-name="Path 11"
          d="M15.2,3H13.279A1.279,1.279,0,0,0,12,4.279V8.756a.959.959,0,0,1,.959-.959H15.2Z"
          transform="translate(-8.802 -3)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.1"
        />
      </g>
    </g>
  </svg>
);

export const tutorProfileIcon = (
  <svg
    className="dropdown-profile-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={23.184}
    height={20.27}
    viewBox="0 0 23.184 20.27"
  >
    <g data-name="Group 27291">
      <g
        data-name="user (1)"
        transform="translate(-595.3 -230.177) translate(596 236)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      >
        <path
          data-name="Path 1"
          d="M12.219 13.747v-1.88c0-2.076-1.368-3.76-3.055-3.76H3.055C1.368 8.107 0 9.79 0 11.867v1.88"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.76}
          cy={3.76}
          r={3.76}
          transform="translate(2.35)"
        />
      </g>
      <g data-name="Group 20560">
        <g data-name="Group 27208">
          <g
            data-name="Group 27203"
            transform="translate(-595.3 -230.177) translate(525 -130.371) translate(84 361.248)"
          >
            <rect
              data-name="Rectangle 11634"
              width={8.784}
              height={10.248}
              rx={2}
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.4}
            />
            <path
              data-name="Line 1620"
              transform="translate(2.562 7.625)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.3}
              d="M3.895 0L0 0"
            />
            <path
              data-name="check (4)"
              d="M5.923 2.984L3.816 5.09l-.957-.957"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.3}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const assessorProfileIcon = (
  <svg
    className="dropdown-profile-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="22.16"
    height="18.523"
    viewBox="0 0 22.16 18.523"
  >
    <g
      id="Group_20562"
      data-name="Group 20562"
      transform="translate(-403.301 -715.449)"
    >
      <g
        id="Group_27226"
        data-name="Group 27226"
        transform="translate(158.881 481.15)"
      >
        <g
          id="user_1_"
          data-name="user (1)"
          transform="translate(245.12 238.375)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M16.219,20.64V18.76c0-2.076-1.368-3.76-3.055-3.76H7.055C5.368,15,4,16.683,4,18.76v1.88"
            transform="translate(-4 -6.893)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.4"
          />
          <circle
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="3.76"
            cy="3.76"
            r="3.76"
            transform="translate(2.35 0)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.4"
          />
        </g>
      </g>
      <path
        id="Path_48797"
        data-name="Path 48797"
        d="M39.741,26.074H37.732v-.557l.065.223v.334l-.065-.645.065-.888a10.341,10.341,0,0,1,.284-1.371c.088-.315.192-.626.307-.933.061-.161.127-.311.2-.465a2.8,2.8,0,0,0,.219-.6,1.709,1.709,0,0,0-.142-1.152,1.771,1.771,0,0,0-3.161,0,1.729,1.729,0,0,0-.142,1.152,3.027,3.027,0,0,0,.219.6,5,5,0,0,1,.2.465c.115.307.219.618.307.933a9.76,9.76,0,0,1,.284,1.371l.058.976v.557H34.406a.826.826,0,0,0-.826.826v.964h6.987V26.9a.826.826,0,0,0-.826-.826Z"
        transform="translate(384.094 696.951)"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.1"
      />
      <line
        id="Line_1623"
        data-name="Line 1623"
        x2="7.49"
        transform="translate(417.42 726.576)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1"
      />
    </g>
  </svg>
);

export const verifierProfileIcon = (
  <svg
    className="dropdown-profile-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={23.23}
    height={19.086}
    viewBox="0 0 23.23 19.086"
  >
    <g data-name="Group 27288">
      <g data-name="Group 20555">
        <g
          data-name="user (1)"
          transform="translate(-595.3 -163.361) translate(578 -291) translate(18 459)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.4}
        >
          <path
            data-name="Path 1"
            d="M12.219 13.747v-1.88c0-2.076-1.368-3.76-3.055-3.76H3.055C1.368 8.107 0 9.79 0 11.867v1.88"
          />
          <circle
            data-name="Ellipse 1"
            cx={3.76}
            cy={3.76}
            r={3.76}
            transform="translate(2.35)"
          />
        </g>
      </g>
      <g
        data-name="Group 20558"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M35.865 536.875s4.365-2.183 4.365-5.457v-3.82l-4.365-1.637-4.365 1.637v3.82c0 3.274 4.365 5.457 4.365 5.457z"
          strokeWidth={1.2}
          transform="translate(-595.3 -163.361) translate(577.699 -362)"
        />
        <path
          data-name="check (5)"
          d="M37.844 529.959l-2.78 2.779-1.263-1.263"
          strokeWidth={1.15}
          transform="translate(-595.3 -163.361) translate(577.699 -362)"
        />
      </g>
    </g>
  </svg>
);
export const ratingIcon = (
  <svg
    width={46}
    height={47}
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.4 15.154l-5.773-12.33c-.514-1.099-2.073-1.099-2.587 0l-5.773 12.33-13.052 2c-1.15.175-1.62 1.581-.807 2.416l9.491 9.753L9.674 43c-.192 1.18 1.058 2.063 2.102 1.484l11.557-6.404 11.558 6.404c1.044.58 2.294-.304 2.102-1.484l-2.226-13.677 9.492-9.753c.812-.835.343-2.24-.807-2.417L30.4 15.154z"
      stroke="#6F75BC"
      strokeWidth={2.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const mailIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 48.00 48.00"
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth={0.00048000000000000007}
  >
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth={1.9200000000000004}
    >
      <defs>
        <style>{'.cls-1{fill:none;strokeLinecap:round;strokeLinejoin:round}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M6.47 10.71a2 2 0 00-2 2h0v22.61a2 2 0 002 2h35.06a2 2 0 002-2h0V12.68a2 2 0 00-2-2H6.47zm33.21 3.82L24 26.07 8.32 14.53"
      />
    </g>
    <g id="SVGRepo_iconCarrier">
      <defs>
        <style>{'.cls-1{fill:none;strokeLinecap:round;strokeLinejoin:round}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M6.47 10.71a2 2 0 00-2 2h0v22.61a2 2 0 002 2h35.06a2 2 0 002-2h0V12.68a2 2 0 00-2-2H6.47zm33.21 3.82L24 26.07 8.32 14.53"
      />
    </g>
  </svg>
);

export const errorIcon = (
  <svg
    width={161}
    height={135}
    viewBox="0 0 161 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 118V56.5c50.4-18.4 110-7.667 133.5 0V118C95.1 144.8 36.667 129.167 14 118z"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      d="M27 112.533v-47.66c40.395-14.259 88.165-5.941 107 0v47.66c-41.999 20.768-88.833 8.653-107 0zM147.5 104.5c9-6.333 21.6-21.9 0-33.5M13.427 104.5c-9-6.333-21.6-21.9 0-33.5"
      stroke="currentColor"
      strokeWidth={3}
    />
    <circle
      cx={58}
      cy={84}
      r={10}
      fill="currentColor"
    />
    <circle
      cx={80}
      cy={9}
      r={9}
      fill="currentColor"
    />
    <circle
      cx={100}
      cy={84}
      r={10}
      fill="currentColor"
    />
    <path
      d="M59.135 110.687c5.28-5.521 20.765-13.533 40.476-1.413M58.011 46.646c6.384-10.554 24.621-25.238 46.498.463"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      fill="currentColor"
      d="M77 16H84V32H77z"
    />
  </svg>
);

export const formBuilderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={22.65}
    viewBox="0 0 18.4 22.65"
  >
    <g data-name="Group 27305">
      <rect
        data-name="Rectangle 11637"
        width={17}
        height={21.25}
        rx={2}
        transform="translate(-846.3 -539.3) translate(843 538) translate(4 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
      <g
        data-name="Group 27304"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          data-name="Group 27301"
          strokeWidth={1.3}
        >
          <path
            data-name="Path 48806"
            d="M1028.976 552.18h-2.51c-.534 0-.966.28-.966.624v4.376c0 .345.432.624.966.624h6.759c.533 0 .966-.28.966-.624v-1.5"
            transform="translate(-846.3 -539.3) translate(-175.1 .112)"
          />
          <path
            data-name="Path 48807"
            d="M1034.4 549.791a.787.787 0 011.113 1.113l-3.529 3.525-1.484.371.371-1.484z"
            transform="translate(-846.3 -539.3) translate(-175.1 .112)"
          />
        </g>
        <g
          data-name="plus (2)"
          transform="translate(-846.3 -539.3) translate(853.35 543.2)"
          strokeWidth={1.4}
        >
          <path
            data-name="Line 1651"
            transform="translate(2.147)"
            d="M0 0L0 4.294"
          />
          <path
            data-name="Line 1652"
            transform="translate(0 2.147)"
            d="M0 0L4.294 0"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const quizIcon = (
  <svg
    fill="#808080"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 490 490"
    xml="preserve"
    width={18.4}
    height={22.65}
    stroke="#FFFFFF"
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    ></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <g>
            <path d="M357.071,87.929l-85-85c-1.912-1.912-4.47-2.904-7.071-2.905V0H10C4.477,0,0,4.477,0,10v470c0,5.523,4.477,10,10,10h340 c5.523,0,10-4.477,10-10V95h-0.024C359.975,92.399,358.983,89.841,357.071,87.929z M275,34.142L325.858,85H275V34.142z M340,470 H20V20h235v75c0,5.523,4.477,10,10,10h75V470z"></path>
            <path d="M470,235v155h-15V120h-0.012c0-1.302-0.242-2.609-0.757-3.846l-25-60C427.678,52.427,424.037,50,420,50 s-7.678,2.427-9.231,6.154l-25,60c-0.515,1.237-0.757,2.544-0.757,3.846H385v360c0,5.523,4.477,10,10,10h50 c5.523,0,10-4.477,10-10v-70h25c5.523,0,10-4.477,10-10V235H470z M420,86l10,24h-20L420,86z M435,470h-30v-60h30V470z M435,390 h-30V130h30V390z"></path>
            <path d="M125,135H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,139.477,130.523,135,125,135z M115,185H85v-30h30V185z"></path>
            <path d="M125,245H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,249.477,130.523,245,125,245z M115,295H85v-30h30V295z"></path>
            <path d="M125,355H75c-5.523,0-10,4.477-10,10v50c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-50 C135,359.477,130.523,355,125,355z M115,405H85v-30h30V405z"></path>
            <rect
              x="150"
              y="140"
              width="50"
              height="20"
            ></rect>
            <rect
              x="150"
              y="180"
              width="135"
              height="20"
            ></rect>
            <rect
              x="150"
              y="250"
              width="50"
              height="20"
            ></rect>
            <rect
              x="150"
              y="290"
              width="135"
              height="20"
            ></rect>
            <rect
              x="150"
              y="360"
              width="50"
              height="20"
            ></rect>
            <rect
              x="150"
              y="400"
              width="135"
              height="20"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const builderPencilIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={22.65}
    viewBox="0 0 18.4 22.65"
  >
    <g data-name="Group 27311">
      <rect
        data-name="Rectangle 11637"
        width={17}
        height={21.25}
        rx={2}
        transform="translate(-972.8 -539.3) translate(969.5 538) translate(4 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
      <g
        data-name="Group 27310"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-972.8 -539.3)"
      >
        <g data-name="Group 27309">
          <g
            data-name="Group 27297"
            transform="translate(410 -47.979)"
            strokeWidth={1.4}
          >
            <path
              data-name="Line 1659"
              transform="translate(570 600.5)"
              d="M0 0L7 0"
            />
            <path
              data-name="Line 1662"
              transform="translate(567 600.5)"
              d="M0 0L0.006 0"
            />
          </g>
          <path
            data-name="Path 48809"
            d="M983.253 543.335a1.144 1.144 0 011.615 1.621l-5.115 5.134-2.153.541.538-2.162z"
            strokeWidth={1.3}
          />
        </g>
        <path
          data-name="Rectangle 11640"
          transform="translate(977 554.8)"
          strokeWidth={1.4}
          d="M0 0H10V3H0z"
        />
      </g>
    </g>
  </svg>
);

export const closeMenuIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.828}
    height={14.828}
    viewBox="0 0 14.828 14.828"
  >
    <g
      transform="translate(-4.586 -4.586) translate(6 6)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path
        data-name="Line 1542"
        d="M12 0L0 12"
      />
      <path
        data-name="Line 1543"
        d="M0 0L12 12"
      />
    </g>
  </svg>
);

export const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.22}
    height={15.397}
    viewBox="0 0 7.22 15.397"
  >
    <path
      data-name="Path 49063"
      d="M1.402 1.402l4.818 6.3-4.818 6.294"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const dashboardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.801}
    height={16.268}
    viewBox="0 0 14.801 16.268"
  >
    <g
      data-name="Group 27700"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49075"
        d="M18 275.646l6.6-5.134 6.6 5.134v8.066a1.467 1.467 0 01-1.467 1.467H19.467A1.467 1.467 0 0118 283.712z"
        transform="translate(-17.2 -269.712)"
      />
      <path
        data-name="Path 49076"
        d="M22.401 285.18v-7.334h4.4v7.334"
        transform="translate(-17.2 -269.712)"
      />
    </g>
  </svg>
);

export const apprenticeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.584}
    height={14.66}
    viewBox="0 0 15.584 14.66"
  >
    <g
      data-name="Group 27698"
      transform="translate(-17.2 -364.05)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <rect
        data-name="Rectangle 11437"
        width={13.984}
        height={10.208}
        rx={2}
        transform="translate(18 367.702)"
      />
      <path
        data-name="Path 49073"
        d="M27.933 377.91v-11.609a1.451 1.451 0 00-1.447-1.451h-2.9a1.451 1.451 0 00-1.453 1.451v11.609"
      />
    </g>
  </svg>
);

export const documentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.399}
    height={15.099}
    viewBox="0 0 12.399 15.099"
  >
    <g
      data-name="Group 27697"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49071"
        d="M25.075 410.864H20.35a1.35 1.35 0 00-1.35 1.35v10.8a1.35 1.35 0 001.35 1.35h8.1a1.35 1.35 0 001.35-1.35v-7.425z"
        transform="translate(-18.2 -410.064)"
      />
      <path
        data-name="Path 49072"
        d="M25.075 410.864v4.725H29.8"
        transform="translate(-18.2 -410.064)"
      />
    </g>
  </svg>
);

export const communityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.589}
    height={15.098}
    viewBox="0 0 18.589 15.098"
  >
    <g
      data-name="Group 27696"
      transform="translate(-15.2 -456.405)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 21711"
        d="M27.616 470.703v-1.456a2.9 2.9 0 00-2.9-2.9H18.9a2.9 2.9 0 00-2.9 2.9v1.452"
      />
      <ellipse
        data-name="Ellipse 246"
        cx={3.042}
        cy={3.04}
        rx={3.042}
        ry={3.04}
        transform="translate(19.013 457.205)"
      />
      <path
        data-name="Path 21712"
        d="M32.989 470.609v-1.452a2.9 2.9 0 00-2.178-2.81"
      />
      <path
        data-name="Path 21713"
        d="M27.907 457.635a2.9 2.9 0 010 5.626"
      />
    </g>
  </svg>
);

export const marketIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.308}
    height={15.761}
    viewBox="0 0 16.308 15.761"
  >
    <g
      data-name="Group 27695"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49083"
        d="M25.081 502.652L18 506.192l7.081 3.54 7.081-3.54z"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49084"
        d="M18 513.273l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49085"
        d="M18 509.732l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
    </g>
  </svg>
);

export const calendarsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.6}
    height={15.6}
    viewBox="0 0 15.6 15.6"
  >
    <g data-name="Group 27694">
      <g
        data-name="Group 27686"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
        transform="translate(-17.2 -625.2)"
      >
        <rect
          data-name="Rectangle 11524"
          width={14}
          height={13}
          rx={2}
          transform="translate(18 627)"
        />
        <path
          data-name="Line 1554"
          transform="translate(28 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1555"
          transform="translate(22 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1556"
          transform="translate(18 632)"
          d="M0 0L14 0"
        />
      </g>
    </g>
  </svg>
);

export const messageSIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.478}
    height={16.1}
    viewBox="0 0 17.478 16.1"
  >
    <g data-name="Group 27688">
      <path
        d="M31.299 728.033a1.422 1.422 0 01-1.422 1.422h-8.534l-2.844 2.845v-11.378a1.422 1.422 0 011.422-1.422h9.956a1.422 1.422 0 011.422 1.422z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
        transform="translate(-17.699 -717)"
      />
    </g>
  </svg>
);

export const settingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.464}
    height={17.464}
    viewBox="0 0 17.464 17.464"
  >
    <g
      data-name="Group 27689"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49081"
        d="M27.096 770.732a2.163 2.163 0 11-2.164-2.163 2.163 2.163 0 012.164 2.163z"
        transform="translate(-16.2 -762)"
      />
      <path
        data-name="Path 49082"
        d="M30.268 772.9a1.19 1.19 0 00.238 1.312l.043.043a1.443 1.443 0 11-2.041 2.041l-.043-.043a1.2 1.2 0 00-2.033.851v.123a1.442 1.442 0 11-2.884 0v-.065a1.19 1.19 0 00-.779-1.089 1.19 1.19 0 00-1.312.238l-.043.043a1.443 1.443 0 11-2.041-2.041l.043-.043a1.2 1.2 0 00-.851-2.033h-.123a1.442 1.442 0 010-2.884h.065a1.19 1.19 0 001.093-.784 1.19 1.19 0 00-.238-1.312l-.043-.043a1.443 1.443 0 112.036-2.042l.043.043a1.19 1.19 0 001.312.238h.058a1.19 1.19 0 00.722-1.088v-.123a1.442 1.442 0 012.884 0v.065a1.2 1.2 0 002.033.851l.043-.043a1.443 1.443 0 112.041 2.041l-.043.043a1.19 1.19 0 00-.238 1.312v.058a1.19 1.19 0 001.09.721h.123a1.442 1.442 0 110 2.884h-.065a1.19 1.19 0 00-1.089.721z"
        transform="translate(-16.2 -762)"
      />
    </g>
  </svg>
);

export const helpsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.6}
    height={16.6}
    viewBox="0 0 16.6 16.6"
  >
    <g
      data-name="Group 27691"
      transform="translate(-16.2 -855.432)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <circle
        data-name="Ellipse 57"
        cx={7.5}
        cy={7.5}
        r={7.5}
        transform="translate(17 856.232)"
      />
      <path
        data-name="Path 21438"
        d="M22.596 861.543a2.133 2.133 0 014.146.711c0 1.422-2.133 2.133-2.133 2.133"
      />
      <path
        data-name="Line 124"
        transform="translate(25 867.232)"
        d="M0 0L0 0"
      />
    </g>
  </svg>
);

export const logOutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.6}
    height={17.158}
    viewBox="0 0 15.6 17.158"
  >
    <g data-name="Group 27693">
      <g data-name="Group 27692">
        <g
          data-name="power (1)"
          transform="translate(-17.201 -901.932) translate(15.006 900.732)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.6}
        >
          <path
            data-name="Path 49129"
            d="M14.946 6.64a6.013 6.013 0 010 9.045 7.476 7.476 0 01-9.9 0 6.013 6.013 0 010-9.045"
          />
          <path
            data-name="Line 8641"
            transform="translate(9.999 2)"
            d="M0 0L0 10"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const globeBoldIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={16.4}
    height={16.4}
    viewBox="0 0 16.4 16.4"
  >
    <g
      transform="translate(-1.188 -1.188)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 266"
        cx={7.5}
        cy={7.5}
        r={7.5}
        transform="translate(1.888 1.888)"
      />
      <path
        data-name="Line 836"
        transform="translate(1.888 9.888)"
        d="M0 0L15 0"
      />
      <path
        data-name="Path 40570"
        d="M9.388 1.993a11.314 11.314 0 012.958 7.395 11.314 11.314 0 01-2.958 7.4A11.314 11.314 0 016.43 9.393a11.314 11.314 0 012.958-7.4z"
      />
    </g>
  </svg>
);

export const briefcaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-briefcase"
    viewBox="0 0 16 16"
  >
    <path d="M6.5 1A1.5 1.5 0 005 2.5V3H1.5A1.5 1.5 0 000 4.5v8A1.5 1.5 0 001.5 14h13a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0014.5 3H11v-.5A1.5 1.5 0 009.5 1h-3zm0 1h3a.5.5 0 01.5.5V3H6v-.5a.5.5 0 01.5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V7.15l6.614 1.764a1.5 1.5 0 00.772 0zM1.5 4h13a.5.5 0 01.5.5v1.616L8.129 7.948a.5.5 0 01-.258 0L1 6.116V4.5a.5.5 0 01.5-.5z" />
  </svg>
);

export const layersStackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.016}
    height={15.538}
  >
    <g
      data-name="Icon feather-layers"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40526"
        d="M8.008.7.939 4.234l7.069 3.534 7.069-3.534Z"
      />
      <path
        data-name="Path 40527"
        d="m.939 11.303 7.069 3.534 7.069-3.534"
      />
      <path
        data-name="Path 40528"
        d="m.939 7.769 7.069 3.534 7.069-3.534"
      />
    </g>
  </svg>
);

export const unsubcribedMessageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.211}
    height={14}
    viewBox="0 0 16.211 14"
  >
    <path
      d="M11.368 14.208l-6.263-4v8.474h7.111a4.149 4.149 0 00.166 1.105H5.105a1.047 1.047 0 01-.774-.341A1.071 1.071 0 014 18.684V9.105a1.071 1.071 0 01.332-.764A1.047 1.047 0 015.105 8h12.527a1.169 1.169 0 011.105 1.105v5.361a2.983 2.983 0 00-.525-.212q-.322-.1-.58-.157v-3.886zm0-1.179l6.263-3.924H5.105zM16.766 22a3.338 3.338 0 01-2.441-.995 3.292 3.292 0 01-1-2.432 3.353 3.353 0 011-2.45 3.447 3.447 0 014.882 0 3.353 3.353 0 011 2.45 3.292 3.292 0 01-1 2.432 3.338 3.338 0 01-2.441.995zm-.608-2.763h.847v-2.948h-.847zm-11.053-.553z"
      transform="translate(-4 -8)"
    />
  </svg>
);

export const reviewIcon = (
  <svg
    width="15"
    height="18"
    viewBox="0 0 56 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52 0H4C1.789 0 0 1.789 0 4v56c0 2.211 1.789 4 4 4h48c2.211 0 4-1.789 4-4V4c0-2.211-1.789-4-4-4zm2 60a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h48a2 2 0 012 2v56z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path
      d="M45 25H11a1 1 0 100 2h34a1 1 0 100-2zM27.5 19h-17c-.277 0-.5.447-.5 1 0 .553.223 1 .5 1h17c.276 0 .5-.447.5-1 0-.553-.224-1-.5-1zM45 37H11a1 1 0 100 2h34a1 1 0 100-2zM45 43H11a1 1 0 100 2h34a1 1 0 100-2zM45 49H11a1 1 0 100 2h34a1 1 0 100-2zM45 31H11a1 1 0 100 2h34a1 1 0 100-2zM10.833 15h13.334c.46 0 .833-.447.833-1 0-.553-.372-1-.833-1H10.833c-.46 0-.833.447-.833 1 0 .553.373 1 .833 1z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path
      d="M38.422 7.756c.183-.43.275-.646.402-.713a.38.38 0 01.352 0c.127.067.22.282.402.713l1.46 3.434a.929.929 0 00.123.24.397.397 0 00.133.102c.058.027.124.034.256.048l3.566.395c.448.05.671.074.771.181a.428.428 0 01.109.351c-.021.148-.188.306-.523.622l-2.663 2.517c-.099.093-.148.14-.180.197a.43.43 0 00-.050.164c-.007.065.007.133.034.27l.744 3.678c.094.462.14.693.074.825a.397.397 0 01-.284.217c-.14.025-.336-.093-.726-.33l-3.106-1.878c-.115-.07-.172-.104-.234-.118a.38.38 0 00-.164 0c-.062.014-.12.049-.234.118l-3.106 1.879c-.39.236-.585.354-.726.329a.397.397 0 01-.284-.217c-.066-.133-.02-.363.074-.825l.744-3.678c.027-.137.041-.205.034-.27a.43.43 0 00-.05-.164.9.9 0 00-.18-.197l-2.663-2.517c-.335-.316-.502-.474-.523-.622a.428.428 0 01.109-.35c.1-.108.323-.132.771-.182l3.566-.395c.132-.014.198-.021.256-.048a.398.398 0 00.133-.102.933.933 0 00.123-.24l1.46-3.434z"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downUpArrowCounterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    key="updown"
  >
    <path
      d="M5.48678 8.67912C5.52118 8.76725 5.5299 8.86332 5.51195 8.9562C5.494 9.04908 5.4501 9.13498 5.38533 9.20397L3.47568 11.1125C3.38443 11.2007 3.26246 11.25 3.13552 11.25C3.00859 11.25 2.88662 11.2007 2.79537 11.1125L0.885718 9.20397C0.820952 9.13498 0.777053 9.04908 0.7591 8.9562C0.741147 8.86332 0.749872 8.76725 0.784268 8.67912C0.82079 8.59228 0.882216 8.51819 0.960803 8.46618C1.03939 8.41418 1.13162 8.38658 1.22587 8.38688H2.65811V1.22982C2.65811 1.10328 2.70841 0.981915 2.79794 0.892434C2.88748 0.802954 3.00891 0.752684 3.13552 0.752684C3.26214 0.752684 3.38357 0.802954 3.47311 0.892434C3.56264 0.981915 3.61294 1.10328 3.61294 1.22982V8.38688H5.04518C5.13943 8.38658 5.23166 8.41418 5.31025 8.46618C5.38883 8.51819 5.45026 8.59228 5.48678 8.67912ZM11.1143 2.79841L9.20463 0.889861C9.11412 0.800263 8.99187 0.75 8.86448 0.75C8.73708 0.75 8.61483 0.800263 8.52432 0.889861L6.61467 2.79841C6.5499 2.8674 6.506 2.9533 6.48805 3.04618C6.4701 3.13906 6.47882 3.23513 6.51322 3.32326C6.54974 3.4101 6.61117 3.48419 6.68975 3.5362C6.76834 3.58821 6.86057 3.6158 6.95483 3.61551H8.38706V10.7726C8.38706 10.8991 8.43736 11.0205 8.52689 11.1099C8.61643 11.1994 8.73786 11.2497 8.86448 11.2497C8.99109 11.2497 9.11253 11.1994 9.20206 11.1099C9.29159 11.0205 9.34189 10.8991 9.34189 10.7726V3.61551H10.7741C10.8684 3.6158 10.9606 3.58821 11.0392 3.5362C11.1178 3.48419 11.1792 3.4101 11.2157 3.32326C11.2501 3.23513 11.2589 3.13906 11.2409 3.04618C11.2229 2.9533 11.179 2.8674 11.1143 2.79841Z"
      fill="white"
    />
  </svg>
);
export const downArrowCounterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    key="down"
  >
    <path
      d="M4.68969 11.1218L0.752191 7.18521C0.671917 7.10125 0.6269 6.98971 0.62641 6.87356C0.626663 6.81551 0.637793 6.75803 0.659223 6.70407C0.692692 6.62447 0.748981 6.55655 0.820998 6.50887C0.893015 6.46119 0.977535 6.4359 1.06391 6.43617L4.56391 6.43617L4.56391 1.1874C4.56391 1.07139 4.61 0.960139 4.69205 0.878111C4.7741 0.796083 4.88538 0.75 5.00141 0.75C5.11744 0.75 5.22872 0.796083 5.31077 0.878111C5.39282 0.960139 5.43891 1.07139 5.43891 1.1874L5.43891 6.43617L8.93891 6.43617C9.02528 6.4359 9.1098 6.46119 9.18182 6.50887C9.25384 6.55655 9.31013 6.62447 9.3436 6.70407C9.37512 6.78486 9.38311 6.87293 9.36666 6.95807C9.35021 7.04322 9.30998 7.12197 9.25063 7.18521L5.31313 11.1218C5.23018 11.2039 5.11816 11.25 5.00141 11.25C4.88466 11.25 4.77264 11.2039 4.68969 11.1218Z"
      fill="#FEF2E1"
    />
  </svg>
);
export const upArrowCounterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    key="up"
  >
    <path
      d="M5.31031 0.878197L9.24781 4.81477C9.32808 4.89874 9.3731 5.01027 9.37359 5.12642C9.37334 5.18447 9.36221 5.24196 9.34078 5.29591C9.30731 5.37552 9.25102 5.44344 9.179 5.49112C9.10699 5.53879 9.02246 5.56409 8.93609 5.56382L5.43609 5.56382V10.8126C5.43609 10.9286 5.39 11.0398 5.30795 11.1219C5.2259 11.2039 5.11462 11.25 4.99859 11.25C4.88256 11.25 4.77128 11.2039 4.68923 11.1219C4.60718 11.0398 4.56109 10.9286 4.56109 10.8126V5.56382H1.06109C0.974717 5.56409 0.890196 5.53879 0.818179 5.49112C0.746162 5.44344 0.689872 5.37552 0.656403 5.29591C0.624883 5.21512 0.616887 5.12706 0.633339 5.04191C0.649792 4.95677 0.690021 4.87802 0.749372 4.81477L4.68687 0.878197C4.76982 0.796062 4.88184 0.749985 4.99859 0.749985C5.11534 0.749985 5.22736 0.796062 5.31031 0.878197Z"
      fill="#E0F5F0"
    />
  </svg>
);
export const dashboardUserInfoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6 8.07692C7.40195 8.07692 8.53846 6.94041 8.53846 5.53846C8.53846 4.13651 7.40195 3 6 3C4.59805 3 3.46154 4.13651 3.46154 5.53846C3.46154 6.94041 4.59805 8.07692 6 8.07692Z"
      fill="#6F42C1"
    />
    <path
      d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259971 4.80026 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19974 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34672 12 7.18669 12 6C11.997 4.40964 11.3638 2.88529 10.2393 1.76073C9.11471 0.63617 7.59036 0.0030496 6 0ZM9.79615 9.36923C9.42255 8.83331 8.94112 8.38135 8.38269 8.04231C7.74153 8.65656 6.88792 8.99947 6 8.99947C5.11208 8.99947 4.25847 8.65656 3.61731 8.04231C3.05889 8.38135 2.57745 8.83331 2.20385 9.36923C1.5541 8.63756 1.12965 7.73371 0.981556 6.76646C0.833467 5.79921 0.968057 4.80977 1.36913 3.91722C1.7702 3.02467 2.42066 2.26704 3.24223 1.73551C4.06381 1.20398 5.02148 0.9212 6 0.9212C6.97852 0.9212 7.9362 1.20398 8.75777 1.73551C9.57934 2.26704 10.2298 3.02467 10.6309 3.91722C11.0319 4.80977 11.1665 5.79921 11.0184 6.76646C10.8704 7.73371 10.4459 8.63756 9.79615 9.36923Z"
      fill="#6F42C1"
    />
  </svg>
);
export const dashboardUserSuccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10.0769C9.40195 10.0769 10.5385 8.94041 10.5385 7.53846C10.5385 6.13651 9.40195 5 8 5C6.59805 5 5.46154 6.13651 5.46154 7.53846C5.46154 8.94041 6.59805 10.0769 8 10.0769Z"
      fill="#60C6AB"
    />
    <path
      d="M8 2C6.81331 2 5.65328 2.35189 4.66658 3.01118C3.67989 3.67047 2.91085 4.60754 2.45673 5.7039C2.0026 6.80026 1.88378 8.00665 2.11529 9.17054C2.3468 10.3344 2.91825 11.4035 3.75736 12.2426C4.59648 13.0818 5.66557 13.6532 6.82946 13.8847C7.99335 14.1162 9.19974 13.9974 10.2961 13.5433C11.3925 13.0891 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C13.997 6.40964 13.3638 4.88529 12.2393 3.76073C11.1147 2.63617 9.59036 2.00305 8 2ZM11.7962 11.3692C11.4226 10.8333 10.9411 10.3814 10.3827 10.0423C9.74153 10.6566 8.88792 10.9995 8 10.9995C7.11208 10.9995 6.25847 10.6566 5.61731 10.0423C5.05889 10.3814 4.57745 10.8333 4.20385 11.3692C3.5541 10.6376 3.12965 9.73371 2.98156 8.76646C2.83347 7.79921 2.96806 6.80977 3.36913 5.91722C3.7702 5.02467 4.42066 4.26704 5.24223 3.73551C6.06381 3.20398 7.02148 2.9212 8 2.9212C8.97852 2.9212 9.9362 3.20398 10.7578 3.73551C11.5793 4.26704 12.2298 5.02467 12.6309 5.91722C13.0319 6.80977 13.1665 7.79921 13.0184 8.76646C12.8704 9.73371 12.4459 10.6376 11.7962 11.3692Z"
      fill="#60C6AB"
    />
  </svg>
);
export const dashboardUserprimaryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10.0769C9.40195 10.0769 10.5385 8.94041 10.5385 7.53846C10.5385 6.13651 9.40195 5 8 5C6.59805 5 5.46154 6.13651 5.46154 7.53846C5.46154 8.94041 6.59805 10.0769 8 10.0769Z"
      fill="#72A6FD"
    />
    <path
      d="M8 2C6.81331 2 5.65328 2.35189 4.66658 3.01118C3.67989 3.67047 2.91085 4.60754 2.45673 5.7039C2.0026 6.80026 1.88378 8.00665 2.11529 9.17054C2.3468 10.3344 2.91825 11.4035 3.75736 12.2426C4.59648 13.0818 5.66557 13.6532 6.82946 13.8847C7.99335 14.1162 9.19974 13.9974 10.2961 13.5433C11.3925 13.0891 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C13.997 6.40964 13.3638 4.88529 12.2393 3.76073C11.1147 2.63617 9.59036 2.00305 8 2ZM11.7962 11.3692C11.4226 10.8333 10.9411 10.3814 10.3827 10.0423C9.74153 10.6566 8.88792 10.9995 8 10.9995C7.11208 10.9995 6.25847 10.6566 5.61731 10.0423C5.05889 10.3814 4.57745 10.8333 4.20385 11.3692C3.5541 10.6376 3.12965 9.73371 2.98156 8.76646C2.83347 7.79921 2.96806 6.80977 3.36913 5.91722C3.7702 5.02467 4.42066 4.26704 5.24223 3.73551C6.06381 3.20398 7.02148 2.9212 8 2.9212C8.97852 2.9212 9.9362 3.20398 10.7578 3.73551C11.5793 4.26704 12.2298 5.02467 12.6309 5.91722C13.0319 6.80977 13.1665 7.79921 13.0184 8.76646C12.8704 9.73371 12.4459 10.6376 11.7962 11.3692Z"
      fill="#72A6FD"
    />
  </svg>
);

export const renderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g
      clipPath="url(#clip0_1608_9003)"
      fill="currentColor"
    >
      <path d="M7.735 11.64a.373.373 0 00.055.045l.03.016a.217.217 0 00.074.03l.03.009c.049.01.098.01.146 0l.032-.01.038-.011a.38.38 0 00.037-.02l.027-.015c.02-.014.04-.03.057-.048l3.364-3.36a.376.376 0 10-.526-.526l-2.724 2.72V.375a.375.375 0 00-.75 0V10.47L4.9 7.75a.375.375 0 00-.526.526l3.36 3.364z" />
      <path d="M15.625 11a.375.375 0 00-.375.375v2.75a1.125 1.125 0 01-1.125 1.125H1.875A1.125 1.125 0 01.75 14.125v-2.75a.375.375 0 00-.75 0v2.75A1.875 1.875 0 001.875 16h12.25A1.875 1.875 0 0016 14.125v-2.75a.375.375 0 00-.375-.375z" />
    </g>
    <defs>
      <clipPath id="clip0_1608_9003">
        <path
          fill="currentColor"
          d="M0 0H16V16H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const dashUsersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      opacity={0.14}
      d="M16 32.5c8.837 0 16-7.163 16-16S24.837.5 16 .5 0 7.663 0 16.5s7.163 16 16 16z"
      fill="currentColor"
    />
    <path
      d="M15.416 19.07a5.156 5.156 0 10-5.707 0 8.207 8.207 0 00-3.893 2.999.67.67 0 00-.051.713.697.697 0 00.61.37H18.75a.696.696 0 00.61-.37.67.67 0 00-.051-.713 8.207 8.207 0 00-3.893-3z"
      fill="currentColor"
    />
    <path
      d="M26.321 22.069a8.277 8.277 0 00-3.902-3 5.147 5.147 0 00-2.853-9.444 5.5 5.5 0 00-1.4.19.705.705 0 00-.465.446.688.688 0 00.104.627 6.513 6.513 0 01.326 7.296.696.696 0 00.18.911c.259.2.508.407.748.62l.043.042a9.675 9.675 0 012.192 3 .678.678 0 00.619.395h3.84a.696.696 0 00.69-.733.688.688 0 00-.122-.35z"
      fill="currentColor"
    />
  </svg>
);

export const dashApprenticeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      opacity={0.14}
      d="M16.5 32.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z"
      fill="currentColor"
    />
    <path
      d="M18.095 24.5v-1.859c0-2.053-1.41-3.717-3.15-3.717H8.65c-1.74 0-3.149 1.664-3.149 3.717V24.5M11.797 18.343c2.14 0 3.875-1.665 3.875-3.718s-1.735-3.718-3.875-3.718c-2.14 0-3.875 1.665-3.875 3.718s1.735 3.718 3.875 3.718z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.761 8.98a.49.49 0 01.5-.48h2.322c.543 0 1.064.207 1.448.575.384.369.6.868.6 1.39v5.196a.49.49 0 01-.5.48.49.49 0 01-.5-.48c0-.168-.07-.33-.194-.448a.676.676 0 00-.467-.186h-2.71a.49.49 0 01-.499-.48V8.98zm3.87 5.22v-3.736a.985.985 0 00-.307-.71 1.07 1.07 0 00-.741-.295H19.76v4.61h2.209c.23 0 .454.045.66.13z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.23 9.075a2.092 2.092 0 011.448-.575H27c.276 0 .5.215.5.48v5.568a.49.49 0 01-.5.48h-2.709a.676.676 0 00-.467.185.621.621 0 00-.194.448.49.49 0 01-.5.48.49.49 0 01-.5-.48v-5.197c0-.52.216-1.02.6-1.389zm.4 5.125c.207-.086.432-.132.661-.132h2.21V9.46h-1.823a1.07 1.07 0 00-.74.295.985.985 0 00-.308.71V14.2z"
      fill="currentColor"
    />
  </svg>
);

export const dashProgramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.25}
    height={14.252}
    viewBox="0 0 14.25 14.252"
  >
    <path
      d="M7.125.7h5a1.428 1.428 0 011.428 1.428v10a1.428 1.428 0 01-1.428 1.428h-5M7.125.7h-5A1.428 1.428 0 00.699 2.128v10a1.428 1.428 0 001.428 1.428h5M7.125.7v12.852"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const dashAssessorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      opacity={0.14}
      d="M16.5 32.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z"
      fill="currentColor"
    />
    <path
      d="M18.311 25.5v-2.001c0-2.21-1.434-4.003-3.203-4.003H8.703c-1.77 0-3.203 1.792-3.203 4.003V25.5M11.905 18.871c2.178 0 3.942-1.792 3.942-4.002s-1.764-4.003-3.941-4.003c-2.178 0-3.942 1.792-3.942 4.003 0 2.21 1.764 4.002 3.941 4.002z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.927 7.802a1.977 1.977 0 012.097 0 2.02 2.02 0 01.899 2.146l-.001.005c-.052.218-.128.43-.226.63-.06.129-.113.252-.163.384a9.016 9.016 0 00-.502 1.976l-.054.752.005.044.033.115h1.341a1.145 1.145 0 01.804.345 1.177 1.177 0 01.34.832v.872c0 .237-.19.43-.424.43h-6.223a.427.427 0 01-.423-.43v-.872a1.192 1.192 0 01.34-.833 1.16 1.16 0 01.82-.344h1.378v-.061l-.05-.854a8.503 8.503 0 00-.238-1.164c-.075-.271-.164-.541-.263-.809v-.001a4.11 4.11 0 00-.161-.38v-.001a3.2 3.2 0 01-.228-.638 2.02 2.02 0 01.899-2.145zm3.402 6.912h-1.777a.427.427 0 01-.424-.43v-.504c0-.013 0-.026.002-.04a.434.434 0 010-.07l.057-.803.003-.028c.06-.438.148-.87.265-1.296v-.001c.083-.298.179-.591.285-.879v-.001a6.088 6.088 0 01.196-.46c.07-.142.124-.293.161-.447a1.131 1.131 0 00-.092-.75 1.164 1.164 0 00-.425-.47 1.14 1.14 0 00-1.209 0 1.148 1.148 0 00-.517 1.22c.038.155.093.306.162.45.073.15.138.303.195.46.106.287.202.58.285.876l-.408.117.407-.117a9.396 9.396 0 01.269 1.332l.05.882a.42.42 0 01.002.025v.504c0 .238-.19.43-.424.43h-1.803a.308.308 0 00-.288.196.322.322 0 00-.024.12v.443h-.424v.43h.424v-.43h5.375v.43h.424v-.43h-.424v-.442a.32.32 0 00-.192-.293.308.308 0 00-.12-.024h-.011zm.97 3.211h-6.672v-.86H27.3v.86z"
      fill="currentColor"
    />
  </svg>
);

export const dashTutorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      opacity={0.14}
      d="M16.25 32.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z"
      fill="currentColor"
    />
    <path
      d="M17.507 25.513V23.5c0-2.224-1.4-4.027-3.126-4.027H8.13c-1.727 0-3.127 1.803-3.127 4.027v2.013M11.256 18.844c2.124 0 3.847-1.803 3.847-4.028 0-2.224-1.723-4.027-3.847-4.027-2.125 0-3.847 1.803-3.847 4.027 0 2.225 1.722 4.028 3.847 4.028z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.56 8.552v7.966h6.452V8.552H19.56zm-.992-.173c0-.478.37-.866.827-.866h6.782c.457 0 .827.388.827.866v8.312c0 .478-.37.866-.827.866h-6.782c-.456 0-.827-.388-.827-.866V8.379z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.773 14.755c0-.287.222-.52.496-.52h3.28c.274 0 .496.233.496.52 0 .287-.222.52-.496.52h-3.28a.508.508 0 01-.496-.52zM24.45 10.296a.537.537 0 010 .735l-1.773 1.857a.48.48 0 01-.702 0l-.806-.844a.537.537 0 010-.735.48.48 0 01.701 0l.456.477 1.423-1.49a.48.48 0 01.702 0z"
      fill="currentColor"
    />
  </svg>
);

export const wageTrackerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
    >
      <path d="M10.91 45.818v-13.09h10.908v13.09m0-8.835V26.182h10.91" />
      <path d="M32.727 45.818V10.91h10.91v34.91" />
      <path d="M3.273 25.686v20.132h40.363M21.818 11.455c0 5.12-4.396 9.272-9.818 9.272s-9.818-4.152-9.818-9.272c0-5.122 4.396-9.273 9.818-9.273s9.818 4.151 9.818 9.273z" />
      <path d="M10.91 7.09v5.92l3.272 1.717" />
    </g>
  </svg>
);

export const incrementIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.39"
    height="10.391"
    viewBox="0 0 10.39 10.391"
  >
    <g
      id="Group_17764"
      data-name="Group 17764"
      transform="translate(0.7 0.7)"
    >
      <path
        id="Path_9"
        data-name="Path 9"
        d="M1756.344,206.134h-8.99"
        transform="translate(-1747.354 -201.864)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_32"
        data-name="Path 32"
        d="M8.991,0H0"
        transform="translate(4.495) rotate(90)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const overviewDocsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={65}
    height={64}
    viewBox="0 0 65 64"
  >
    <defs>
      <path
        id="a"
        d="M40.286.333c1.683 0 3.047 1.327 3.047 2.963v47.408c0 1.636-1.364 2.963-3.047 2.963H3.714c-1.683 0-3.047-1.327-3.047-2.963V3.296C.667 1.66 2.03.333 3.714.333h36.572zm0 2.963H3.714v47.408h36.572V3.296zm-23.62 29.037V35h-8v-2.667h8zm10.667 0V35h-8v-2.667h8zm8-5.333v2.667H8.667V27h26.666zm0-5.333v2.666H8.667v-2.666h26.666zm0-5.334V19H8.667v-2.667h26.666z"
      />
    </defs>
    <use
      fill="currentColor"
      transform="translate(10 5)"
      xlinkHref="#a"
    />
  </svg>
);

export const resetIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.719 12A10.719 10.719 0 011.28 12h.838a9.916 9.916 0 101.373-5H8v1H2V2h1v4.2A10.71 10.71 0 0122.719 12z" />
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
  </svg>
);

export const alertDangerIcon = (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"
      fill="#fff"
    />
    <path
      d="M9.414 7.586L8 9l14.142 14.142 1.414-1.414L9.414 7.586z"
      fill="#FF5C25"
    />
    <path
      d="M23.414 9.414L22 8 7.858 22.142l1.414 1.414L23.414 9.414z"
      fill="#FF5C25"
    />
  </svg>
);

export const alertTickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"
      fill="#fff"
    />
    <path
      d="M6.454 17.06l4.243 4.243 2.121 2.122 12.728-12.728-2.121-2.122-10.607 10.607-4.243-4.243-2.12 2.122z"
      fill="#32CA50"
    />
  </svg>
);

export const refreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 3v5m0 0h-5m5 0l-3-2.708A9 9 0 1020.777 14"
    ></path>
  </svg>
);

export const playBtnIcon = (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.404 31.143c5.078-2.934 5.078-10.267 0-13.204L19.462 2.942c-5.081-2.938-11.44.732-11.44 6.603V39.54c0 5.871 6.359 9.54 11.44 6.6l25.942-14.997z"
      fill="currentColor"
    />
  </svg>
);

export const deadlineIcon = (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.5h-.5v-1h-1v1h-5v-1h-1v1H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm0 9H2V5h8v5.5zM10 4H2V2.5h8V4z"
      fill="currentColor"
    />
  </svg>
);

export const pieIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
      fill="currentColor"
    />
  </svg>
);

export const activitiesIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2.072h-4.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-16c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5v-16h2v3h10v-3h2v16z"
      fill="currentColor"
    />
  </svg>
);

export const remindersIcon = (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <path
        fillRule="nonzero"
        d="M0 0H24V24H0z"
      />
      <circle
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        cx={12}
        cy={12}
        r={9}
      />
      <path
        d="M9 12h2.5a.5.5 0 00.5-.5V7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const certificateIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.357 15.069a.679.679 0 01-.188.471.631.631 0 01-.455.195H7.857a.631.631 0 01-.454-.195.68.68 0 01-.189-.471c0-.177.068-.347.189-.471a.631.631 0 01.454-.196h3.857c.17 0 .334.07.455.196.12.124.188.294.188.47zm-.643-3.332H7.857c-.17 0-.334.07-.454.195a.68.68 0 00-.189.471c0 .177.068.346.189.471.12.125.284.195.454.195h3.857c.17 0 .334-.07.455-.195a.679.679 0 00.188-.47.679.679 0 00-.188-.472.631.631 0 00-.455-.195zm9 5.454v5.208a.686.686 0 01-.083.336.656.656 0 01-.236.246.626.626 0 01-.645.002l-1.928-1.145-1.929 1.145a.627.627 0 01-.88-.248.686.686 0 01-.084-.336V20.4H5.286c-.341 0-.668-.14-.91-.39A1.358 1.358 0 014 19.067V8.405c0-.354.135-.693.377-.943.24-.25.568-.39.909-.39h14.143c.34 0 .668.14.909.39s.377.59.377.943v2.543c.406.403.73.888.95 1.424a4.46 4.46 0 010 3.394 4.331 4.331 0 01-.95 1.425zm-5.785 1.876V17.19a4.393 4.393 0 01-1.252-2.634 4.456 4.456 0 01.657-2.857A4.197 4.197 0 0116.6 9.933a4.04 4.04 0 012.83.138V8.405H5.286v10.662h9.643zm4.5-1a4.042 4.042 0 01-3.215 0v3.184l1.286-.763a.625.625 0 01.638 0l1.286.764.005-3.184zm1.286-3.998c0-.593-.17-1.173-.488-1.666a2.917 2.917 0 00-1.298-1.104 2.798 2.798 0 00-1.672-.171 2.863 2.863 0 00-1.481.82c-.405.42-.68.954-.792 1.536a3.1 3.1 0 00.165 1.733c.219.548.59 1.016 1.065 1.346a2.804 2.804 0 002.714.277c.352-.151.67-.372.94-.65.268-.279.48-.61.626-.973.146-.364.22-.754.22-1.148zM13 6.072l.94-2.07 2.06-.93-2.06-.93L13 .072l-.92 2.07-2.08.93 2.08.93.92 2.07zM2.5 6.072l.5-2 2-.5-2-.5-.5-2-.5 2-2 .5 2 .5.5 2z" />
  </svg>
);

export const liveIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99 5a.75.75 0 010 1.06 8.5 8.5 0 000 12.022.75.75 0 01-1.061 1.06C1.024 15.237 1.024 8.906 4.929 5A.75.75 0 015.99 5zm13.08 0c3.905 3.906 3.905 10.238 0 14.143a.75.75 0 01-1.06-1.06 8.5 8.5 0 000-12.022A.75.75 0 1119.07 5zM8.818 7.83a.75.75 0 010 1.06 4.5 4.5 0 000 6.365.75.75 0 01-1.06 1.06 6 6 0 010-8.485.75.75 0 011.06 0zm7.425 0a6 6 0 010 8.485.752.752 0 01-1.07.01.75.75 0 01.009-1.07 4.501 4.501 0 000-6.364.75.75 0 011.06-1.06M12 10.572a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
      fill="currentColor"
    />
  </svg>
);

export const submittedIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 15.072h7v2H7v-2zm0-4h10v2H7v-2zm0-4h10v2H7v-2zm12-4h-4.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zm7 16.25H5v-14h14v14z"
      fill="currentColor"
    />
  </svg>
);

export const menuBookIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 4.572c1.17 0 2.39.15 3.5.5.75.25 1.4.55 2 1v14.6c0 .25-.25.5-.5.5-.1 0-.15 0-.25-.05-1.4-.75-3.1-1.05-4.75-1.05-1.7 0-4.15.65-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.45 0-3.4.45-4.75 1.1-.05 0-.087.012-.125.025-.038.012-.075.025-.125.025-.25 0-.5-.25-.5-.5V6.072c1.45-1.1 3.55-1.5 5.5-1.5 1.95 0 4.05.4 5.5 1.5 1.45-1.1 3.55-1.5 5.5-1.5zm0 13.5c1.2 0 2.4.15 3.5.5v-11.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v11.5c1.35-.85 3.8-1.5 5.5-1.5zm2.5-7.24c-.77-.17-1.62-.26-2.5-.26-1.8 0-3.37.35-4.5.99v-1.66c1.26-.54 2.8-.83 4.5-.83.86 0 1.71.09 2.5.24v1.52zm-7 1.73v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm0 2.67c1.26-.54 2.8-.83 4.5-.83.86 0 1.71.08 2.5.24v1.52c-.77-.17-1.62-.26-2.5-.26-1.8 0-3.37.35-4.5.99v-1.66z"
      fill="currentColor"
    />
  </svg>
);

export const alertCrossIcon = (
  <svg
    width={13}
    height={13}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.575 12.075L0 11.5 11.5 0l.575.575-11.5 11.5z"
      fill="currentColor"
    />
    <path
      d="M11.5 12.075L0 .575.575 0l11.5 11.5-.575.575z"
      fill="currentColor"
    />
  </svg>
);

export const alertQuestionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"
      fill="#fff"
    />
    <path
      d="M17 23h-2v-2h2v2zm2.07-7.75l-.9.92C17.45 16.9 17 17.5 17 19h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
      fill="#317CE4"
    />
  </svg>
);

export const alertWarningIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z"
      fill="#fff"
    />
    <path
      d="M13.5 24a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      fill="#FFC341"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 19h3V5h-3v14z"
      fill="#FFC341"
    />
  </svg>
);

export const archiveIcon = (
  <svg
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.333 2H7L5.667.667h-4C.933.667.333 1.267.333 2v8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V3.333c0-.733-.6-1.333-1.334-1.333zm0 8H1.667V2h3.446l1.334 1.333h5.886V10zM7.72 7.36l-.46 1.973L9 8.313l1.74 1.02-.46-1.973 1.533-1.327-2.02-.173L9 4l-.793 1.86-2.02.173L7.72 7.36z"
      fill="currentColor"
      strokeWidth={0.1}
    />
  </svg>
);

export const myconnectIcon = (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.333 10c.734 0 1.327-.6 1.327-1.333L14.667 2c0-.733-.6-1.333-1.334-1.333H2.667c-.734 0-1.334.6-1.334 1.333v6.667c0 .733.6 1.333 1.334 1.333H0v1.333h16V10h-2.667zM2.667 2h10.666v6.667H2.667V2z"
      fill="currentColor"
      strokeWidth={0.1}
    />
  </svg>
);

export const coursIcon = (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.667 0c.78 0 1.593.1 2.333.333.5.167.933.367 1.333.667v9.733a.359.359 0 01-.333.334c-.067 0-.1 0-.167-.034-.933-.5-2.066-.7-3.166-.7-1.134 0-2.767.434-3.667 1-.967-.733-2.367-1-3.667-1-.966 0-2.266.3-3.166.734a.247.247 0 00-.084.016A.245.245 0 011 11.1a.358.358 0 01-.333-.333V1c.966-.733 2.366-1 3.666-1 1.3 0 2.7.267 3.667 1 .967-.733 2.367-1 3.667-1zm0 9c.8 0 1.6.1 2.333.333V1.667c-.733-.234-1.533-.334-2.333-.334-1.134 0-2.767.434-3.667 1V10c.9-.567 2.533-1 3.667-1zm1.666-4.827A7.797 7.797 0 0011.667 4c-1.2 0-2.247.233-3 .66V3.553c.84-.36 1.866-.553 3-.553.573 0 1.14.06 1.666.16v1.013zM8.667 5.327v1.106c.753-.426 1.8-.66 3-.66.586 0 1.153.06 1.666.174V4.933a9.003 9.003 0 00-1.666-.16c-1.134 0-2.16.2-3 .554zm0 1.78c.84-.36 1.866-.554 3-.554.573 0 1.14.054 1.666.16v1.014a7.796 7.796 0 00-1.666-.174c-1.2 0-2.247.234-3 .66V7.107z"
      fill="currentColor"
      strokeWidth={0.1}
    />
  </svg>
);

export const apprenticeshipIcon = (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.667 3H.333v9.333c0 .734.6 1.334 1.334 1.334H11v-1.334H1.667V3zM12.333.333h-8C3.6.333 3 .933 3 1.667v8C3 10.4 3.6 11 4.333 11h8c.734 0 1.334-.6 1.334-1.333v-8c0-.734-.6-1.334-1.334-1.334zm-2 1.334V5l-.666-.5L9 5V1.667h1.333zm2 8h-8v-8h3.334v6l2-1.5 2 1.5v-6h.666v8z"
      fill="currentColor"
      strokeWidth={0.1}
    />
  </svg>
);

export const dashIcon = (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.667 1.333v1.334H8V1.333h2.667zM4 1.333v4H1.333v-4H4zm6.667 5.334v4H8v-4h2.667zM4 9.333v1.334H1.333V9.333H4zM12 0H6.667v4H12V0zM5.333 0H0v6.667h5.333V0zM12 5.333H6.667V12H12V5.333zM5.333 8H0v4h5.333V8z"
      fill="currentColor"
    />
  </svg>
);

export const eventIcon = (
  <svg
    id="Icon_Set"
    data-name="Icon Set"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 51.98 45.62"
    strokeWidth={3}
  >
    <path
      d="M8.36 24.36l-5.3 4.36A7 7 0 00.5 34.13v11.4"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M27.55 24.45L31.69 27.86"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M9.06 35.83L9.04 39.56 9.04 45.53"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <circle
      cx="17.9"
      cy="11.51"
      r="11.01"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M26.75 35.83L26.77 39.56 26.77 45.53"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M35.42 16.12H51.48V45.12H35.42z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 25.12L47.46 25.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 31.12L44.02 31.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M40.51 38.79L42.66 40.34 47.19 35.99"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 28.12L47.46 28.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M47.53 16.12L47.53 20.62 39.37 20.62 39.37 16.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export const journeyWalkerRateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={27}
    viewBox="0 0 26 27"
    strokeWidth={2}
  >
    <g
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
    >
      <path d="M2.5 26v-7.258h8V26m0-4.839V14.71h6m0 11.29V5.839h8V26" />
      <path d="M2.293 14v12H25M11.81 6.242c0 2.895-2.308 5.242-5.155 5.242-2.847 0-5.155-2.347-5.155-5.242S3.808 1 6.655 1c2.847 0 5.155 2.347 5.155 5.242z" />
      <path d="M6.259 4v3.125l1.586.907" />
    </g>
  </svg>
);

export const programNewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={28}
    viewBox="0 0 29 28"
    strokeWidth={2}
  >
    <g
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
    >
      <path d="M15.241 18.285L2.324 11.001a1.592 1.592 0 01-.765-.937 1.213 1.213 0 01-.057-.413c0-1.008.488-1.627 1.52-2.209L15.326.5l12.179 6.872a.641.641 0 010 1.123l-11.31 6.38c-1.03.583-1.519 1.202-1.519 2.21s.885 1.8 1.916 1.217L28.5 11.584m-7 11.916l7-4m-14 7L1.343 18.415c-.375-.207-.667-.538-.783-.936a1.263 1.263 0 01-.058-.412c0-1.008.5-1.626 1.555-2.207l.58-.36" />
      <path d="M28.5 15.5l-12.89 7.593c-1.029.606-1.516 1.25-1.516 2.298 0 1.049.883 1.872 1.912 1.267l2.996-1.755V27.5l2.268-1.384v-2.567c0-.593-.24-1.057-.744-1.35" />
    </g>
  </svg>
);

export const quizNewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64.000000 66.000000"
  >
    <path
      fill="currentColor"
      d="M72 648c-7-7-12-22-12-34 0-15-8-24-24-28-14-3-27-15-31-26-8-24 11-60 30-60 9 0 15-10 15-25 0-18-5-25-20-25-13 0-22-9-26-25-7-27 10-55 32-55 8 0 14-10 14-25 0-18-5-25-20-25-13 0-22-9-26-25-7-27 10-55 32-55 23 0 16-44-8-55-41-18-31-75 13-75 15 0 19-7 19-35 0-24 6-37 19-45 12-6 104-10 230-10h211v100c0 60-4 100-10 100s-10-35-10-85V50H90v26c0 14 10 34 22 43 27 22 19 71-12 71-15 0-20 7-20 25 0 15 6 25 14 25 22 0 39 28 32 55-4 16-13 25-26 25-15 0-20 7-20 25 0 15 6 25 14 25 22 0 39 28 32 55-4 16-13 25-26 25-29 0-27 42 3 55s34 50 8 72c-12 9-21 25-21 35 0 15 9 18 50 18h50V510c0-122 6-140 38-108 9 9 15 9 24 0 32-32 38-14 38 108v120h210v-55c0-30 5-55 10-55 6 0 10 30 10 70v70H302c-156 0-221-3-230-12zm188-113c0-88-1-95-20-95s-20 7-20 95 1 95 20 95 20-7 20-95zm-160 10c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm0-130c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm0-130c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm-2-132c-5-25-61-25-66 0-3 14 4 17 33 17s36-3 33-17z"
      transform="matrix(.1 0 0 -.1 0 66)"
    />
    <path
      fill="currentColor"
      d="M555 469c-4-6-19-7-36-4-25 6-36 0-87-49-40-38-54-58-47-65 8-8 26 4 60 39 27 28 56 50 64 50s-44-60-116-132C285 198 260 167 250 131c-12-46-8-60 12-44 7 6 27 13 43 17 20 5 78 55 183 159 83 83 152 157 152 163 0 16-44 54-63 54-9 0-19-5-22-11zm44-32c8-10 4-20-19-42-25-24-32-26-45-15-14 12-13 16 11 42 31 32 37 33 53 15zm-81-80c9-10-10-35-83-107-82-82-96-92-110-80s-6 24 77 107c51 51 96 93 99 93 4 0 11-6 17-13zM306 132c-22-5-30 3-21 18 5 8 11 7 22-2 15-12 14-13-1-16z"
      transform="matrix(.1 0 0 -.1 0 66)"
    />
  </svg>
);

export const reviewNewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={39}
    viewBox="0 0 36 39"
  >
    <g
      fill="none"
      // fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M16.25.569c-.215-.498-.753-.71-1.202-.47L8.694 3.47c-.449.238-.638.835-.424 1.333.215.499.753.71 1.201.471l.41-.217 3.001 5.288-.906 2.609 3.83-2.034 3.83-2.033-2.397-.855-1.824-5.913.41-.218c.449-.238.639-.835.424-1.333zm-1.523 11.063l4.091 4.777-1.318-6.045" />
      <path d="M21.273 12.955l8.182 3.08L22.652 38 2.455 30.602l6.954-20.238" />
      <path d="M22.423 8.378l12.746 4.577L28.66 33.83l-3.386-1.504m-13.001-9.871l8.182 2.59m-9.819.865l8.182 2.59m2.174-12.955c.648 1.173.136 2.604-1.142 3.198-1.279.593-2.84.124-3.486-1.048" />
    </g>
  </svg>
);

export const workflowIcon = (
  <svg
    id="Icon_Set"
    data-name="Icon Set"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36.87 37"
    strokeWidth={2}
  >
    <path
      d="M26.7 5.13V.5H15.53v19.2l-4.76-4.82L6 19.7V.5H1.55a1 1 0 00-1 1.05v33.9a1 1 0 001.05 1h10.72"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 0.5L6.31 0.5"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M34.06 28.1h-5.63v-1.57h.18a1.37 1.37 0 000-2.73 27.82 27.82 0 01.77-3.8c.25-.88.54-1.75.86-2.61.17-.45.35-.87.56-1.31a7.78 7.78 0 00.61-1.67 4.78 4.78 0 00-.4-3.26 5 5 0 00-8.85 0 4.89 4.89 0 00-.4 3.26 8.39 8.39 0 00.62 1.59c.21.44.39.86.56 1.31.32.86.61 1.73.85 2.61a26.45 26.45 0 01.8 3.84 1.37 1.37 0 000 2.73h.17v1.57h-5.64a2.31 2.31 0 00-2.32 2.31v2.66h19.57v-2.62a2.3 2.3 0 00-2.31-2.31z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M16.64 36.45L36.57 36.45"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export const sendIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="-0.5 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.161 12.942l-6.25-.51c-.49-.12-.56-.76-.11-.97l17.91-7.91c.47-.21.96.26.73.7l-8.43 16.96c-.23.43-.89.36-1.01-.1l-.83-7.9 7.27-6.8"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const deleteNotificationIcon = (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.425 5h18.702M6.62 5V3c0-.53.22-1.04.609-1.414A2.12 2.12 0 018.699 1h4.155c.552 0 1.08.21 1.47.586.39.375.608.884.608 1.414v2m3.117 0v14c0 .53-.218 1.04-.608 1.414a2.12 2.12 0 01-1.47.586H5.581a2.12 2.12 0 01-1.47-.586A1.963 1.963 0 013.504 19V5H18.05z"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const envelopeOpenIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M3 20V8.588a1 1 0 01.514-.874l8-4.444a1 1 0 01.972 0l8 4.444a1 1 0 01.514.874V20a1 1 0 01-1 1H4a1 1 0 01-1-1z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.5l9 5 9-5"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const verticalEllipsisIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M8 2.5a1.22 1.22 0 011.25 1.17A1.21 1.21 0 018 4.84a1.21 1.21 0 01-1.25-1.17A1.22 1.22 0 018 2.5zm0 8.66a1.17 1.17 0 11-1.25 1.17A1.21 1.21 0 018 11.16zm0-4.33a1.17 1.17 0 110 2.34 1.17 1.17 0 110-2.34z"
    />
  </svg>
);

export const partyIcon = (
  <svg
    width="100px"
    height="100px"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    fill="#64CAA1"
  >
    <g
      color="#64CAA1"
      fill="#64CAA1"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={4.1}
    >
      <path
        d="M306.52 28.428c-.652.012-1.285.197-1.766.677a2.162 2.162 0 00-.438.641 1 1 0 00-.01.014l-12.238 27.63a1 1 0 001.318 1.32l27.555-12.206a1 1 0 00.031-.018c.254-.107.492-.255.7-.463.64-.64.757-1.554.636-2.416-.12-.862-.463-1.778-.974-2.77-1.023-1.98-2.738-4.253-4.94-6.454-2.201-2.202-4.471-3.915-6.453-4.938-.99-.51-1.907-.856-2.77-.976a4.186 4.186 0 00-.652-.041zm.05 1.996c.09 0 .196.007.325.025.514.072 1.269.33 2.128.774 1.72.887 3.878 2.494 5.957 4.574 2.08 2.08 3.69 4.24 4.577 5.959.443.86.7 1.612.771 2.127.072.515-.027.684-.07.726-.043.043-.212.144-.727.073-.515-.072-1.269-.328-2.129-.772-1.72-.887-3.879-2.496-5.959-4.576-2.08-2.08-3.687-4.237-4.574-5.957-.443-.86-.7-1.614-.771-2.129-.053-.374-.014-.563.027-.656l.01-.02v-.002a.247.247 0 01.033-.05c.032-.032.135-.096.403-.096zm-1.793 3.213c.098.215.202.433.317.656 1.022 1.982 2.734 4.253 4.935 6.455 2.202 2.202 4.476 3.915 6.457 4.938.222.114.438.217.653.314l-7.71 3.414c-1.635-.96-3.511-2.441-5.245-4.174a30.656 30.656 0 01-3.004-3.482zm-4.52 10.205c.758.952 1.604 1.9 2.513 2.81 1.448 1.448 2.978 2.73 4.46 3.737l-12.285 5.443zM341.629 26.143c-5.453-.473-9.993 1.468-13.307 3.83-4.418 3.149-6.822 7.068-6.822 7.068a1 1 0 00.328 1.377 1 1 0 001.375-.328s2.22-3.595 6.28-6.488c4.06-2.894 9.795-5.062 17.177-2.24a1 1 0 001.291-.577 1 1 0 00-.576-1.29c-2.01-.769-3.928-1.195-5.746-1.352zM332.387 8.055a1 1 0 00-1.088.902s-.402 4.205-2.764 8.596c-2.361 4.39-6.547 8.873-14.416 9.607a1 1 0 00-.902 1.088 1 1 0 001.088.902c8.566-.8 13.422-5.872 15.992-10.65 2.57-4.778 2.992-9.357 2.992-9.357a1 1 0 00-.902-1.088zM310.213 15.604c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .435 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.565.436-1 1-1zM343.428 7.752a3.633 3.633 0 00-3.617 3.617 3.633 3.633 0 003.617 3.617 3.633 3.633 0 003.617-3.617 3.633 3.633 0 00-3.617-3.617zm0 2c.904 0 1.617.712 1.617 1.617s-.713 1.617-1.617 1.617a1.603 1.603 0 01-1.617-1.617c0-.905.712-1.617 1.617-1.617zM345.018 45.775c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .565-.436 1-1 1-.565 0-1-.435-1-1 0-.564.435-1 1-1zM323.254 7.836a1 1 0 00-1 1v1.387h-1.387a1 1 0 00-1 1 1 1 0 001 1h1.387v1.386a1 1 0 001 1 1 1 0 001-1v-1.386h1.387a1 1 0 001-1 1 1 0 00-1-1h-1.387V8.836a1 1 0 00-1-1zM335.436 17.988a1 1 0 00-.707.293 1 1 0 000 1.414l.98.98-.98.981a1 1 0 000 1.414 1 1 0 001.414 0l.98-.98.98.98a1 1 0 001.415 0 1 1 0 000-1.414l-.98-.98.98-.98a1 1 0 000-1.415 1 1 0 00-.707-.293 1 1 0 00-.707.293l-.98.98-.981-.98a1 1 0 00-.707-.293zM336.424 36.18a1 1 0 00-1 1v1.386h-1.387a1 1 0 00-1 1 1 1 0 001 1h1.387v1.387a1 1 0 001 1 1 1 0 001-1v-1.387h1.387a1 1 0 001-1 1 1 0 00-1-1h-1.387V37.18a1 1 0 00-1-1zM327.123 45.207a1 1 0 00-.861 1.123 1 1 0 001.123.86c.279-.037.564-.037.844 0 .322.042.623.135.875.27.249.136.46.32.595.524.134.2.205.439.201.641a.822.822 0 01-.191.514c-.074.08-.194.167-.348.232a2.475 2.475 0 01-.578.15c-.454.071-1.04.067-1.726.204a5.228 5.228 0 00-2.88 1.652 5.228 5.228 0 00-1.298 3.055 5.224 5.224 0 00.807 3.218 5.23 5.23 0 002.585 2.082 5.23 5.23 0 003.319.1 5.224 5.224 0 002.705-1.922 5.228 5.228 0 00.998-3.166 5.227 5.227 0 00-1.113-3.127 1 1 0 00-1.405-.168 1 1 0 00-.168 1.405c.425.54.673 1.24.686 1.927a3.273 3.273 0 01-.615 1.951 3.275 3.275 0 01-1.668 1.186c-.658.199-1.4.176-2.045-.063a3.279 3.279 0 01-1.596-1.283c-.37-.578-.55-1.3-.496-1.984.054-.685.345-1.37.8-1.883a3.275 3.275 0 011.776-1.017c.423-.085.978-.087 1.64-.19.333-.052.692-.132 1.056-.287a2.968 2.968 0 001.04-.72 2.767 2.767 0 00.715-1.835 3.119 3.119 0 00-.539-1.783c-.34-.51-.8-.898-1.304-1.172a4.52 4.52 0 00-1.567-.494 5.211 5.211 0 00-1.367 0zM301.021 4.111a3.396 3.396 0 00-1.748.006 3.396 3.396 0 00-1.515.871 1 1 0 00-.004 1.416 1 1 0 001.414.004c.17-.168.394-.297.625-.36.23-.061.49-.062.72-.001.232.06.455.188.626.355.17.168.302.391.367.621.114.409.038 1.026-.004 1.825-.021.401-.024.854.082 1.34.107.491.325 1.006.738 1.433.347.359.787.605 1.273.715a2.542 2.542 0 002.62-.984c.294-.403.461-.877.486-1.375a1 1 0 00-.95-1.05 1 1 0 00-1.048.95.583.583 0 01-.106.297.578.578 0 01-.25.19.576.576 0 01-.312.02.579.579 0 01-.274-.154 1.007 1.007 0 01-.222-.468 3.152 3.152 0 01-.041-.809c.033-.639.207-1.493-.067-2.47a3.402 3.402 0 00-2.41-2.372z"
        transform="translate(-288)"
      />
    </g>
  </svg>
);

export const externalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l5.09 10.26L22 12l-5.09 10.26L12 22l-5.09-10.26L2 12l5.09-10.26z"></path>
  </svg>
);

export const stackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-stack"
    viewBox="0 0 16 16"
  >
    <path d="M14.12 10.163l1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 01-.534 0L.165 11.555a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 01.534 0l7.568 3.784a.3.3 0 010 .535L8.267 8.165a.598.598 0 01-.534 0L.165 4.382a.299.299 0 010-.535L7.733.063z" />
    <path d="M14.12 6.576l1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 01-.534 0L.165 7.968a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z" />
  </svg>
);

export const rightArrowLong = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrow-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1 8a.5.5 0 01.5-.5h11.793l-3.147-3.146a.5.5 0 01.708-.708l4 4a.5.5 0 010 .708l-4 4a.5.5 0 01-.708-.708L13.293 8.5H1.5A.5.5 0 011 8"
    />
  </svg>
);

// Dashboard
export const homeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.966}
    height={14.252}
    viewBox="0 0 12.966 14.252"
  >
    <g
      data-name="Icon feather-home"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 49075"
        d="M4.5 7.5L10.283 3l5.783 4.5v7.068a1.285 1.285 0 01-1.285 1.285h-9A1.285 1.285 0 014.5 14.566z"
        transform="translate(-3.8 -2.3)"
      />
      <path
        data-name="Path 49076"
        d="M8.355 15.852V9.426h3.855v6.426"
        transform="translate(-3.8 -2.3)"
      />
    </g>
  </svg>
);

// Courses
export const coursesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.191}
    height={14.191}
    viewBox="0 0 14.191 14.191"
  >
    <path
      d="M24.8 318.846h4.9a1.4 1.4 0 011.4 1.4v9.793a1.4 1.4 0 01-1.4 1.4h-4.9m0-12.593h-4.9a1.4 1.4 0 00-1.4 1.4v9.793a1.4 1.4 0 001.4 1.4h4.9m0-12.593v12.591"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      transform="translate(-17.7 -318.046)"
      data-name="Group 27699"
    />
  </svg>
);

// MyConnect
export const laptopIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-laptop"
    viewBox="0 0 16 16"
  >
    <path d="M13.5 3a.5.5 0 01.5.5V11H2V3.5a.5.5 0 01.5-.5zm-11-1A1.5 1.5 0 001 3.5V12h14V3.5A1.5 1.5 0 0013.5 2zM0 12.5h16a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 12.5" />
  </svg>
);

// Learner Profile
export const learnersProfileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 100-6 3 3 0 000 6zm2-3a2 2 0 11-4 0 2 2 0 014 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

// Settings
export const settingsIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.526 15.162C14.459 15.162 16.026 13.8188 16.026 12.162C16.026 10.5051 14.459 9.16199 12.526 9.16199C10.593 9.16199 9.026 10.5051 9.026 12.162C9.026 13.8188 10.593 15.162 12.526 15.162Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.377 14.983C19.2441 15.2843 19.2044 15.6186 19.2633 15.9426C19.3221 16.2666 19.4766 16.5656 19.707 16.801L19.767 16.861C19.9654 17.0436 20.1248 17.2644 20.2357 17.5102C20.3465 17.7559 20.4066 18.0216 20.4121 18.2911C20.4177 18.5607 20.3688 18.8286 20.2682 19.0788C20.1676 19.3289 20.0174 19.5561 19.8268 19.7468C19.6361 19.9374 19.4089 20.0876 19.1588 20.1882C18.9086 20.2888 18.6407 20.3377 18.3711 20.3321C18.1016 20.3266 17.8359 20.2665 17.5902 20.1557C17.3444 20.0448 17.1236 19.8854 16.941 19.687L16.881 19.627C16.6475 19.401 16.3528 19.2485 16.0335 19.1884C15.7142 19.1282 15.3842 19.163 15.0845 19.2885C14.7847 19.414 14.5284 19.6246 14.3472 19.8944C14.166 20.1641 14.0679 20.4811 14.065 20.806V20.976C14.065 21.5064 13.8543 22.0151 13.4792 22.3902C13.1041 22.7653 12.5954 22.976 12.065 22.976C11.5346 22.976 11.0259 22.7653 10.6508 22.3902C10.2757 22.0151 10.065 21.5064 10.065 20.976V20.886C10.0577 20.5557 9.95133 20.2352 9.75963 19.9661C9.56794 19.697 9.2998 19.4918 8.99 19.377C8.68869 19.2441 8.35445 19.2044 8.0304 19.2633C7.70636 19.3221 7.40737 19.4766 7.172 19.707L7.112 19.767C6.929 19.964 6.70817 20.122 6.4627 20.2317C6.21723 20.3414 5.95217 20.4004 5.68336 20.4054C5.41454 20.4103 5.1475 20.3609 4.89819 20.2603C4.64887 20.1597 4.42241 20.0098 4.23233 19.8196C4.04225 19.6295 3.89247 19.403 3.79192 19.1536C3.69137 18.9043 3.64213 18.6372 3.64714 18.3684C3.65215 18.0996 3.71131 17.8346 3.82108 17.5891C3.93084 17.3437 4.08897 17.1229 4.286 16.94L4.346 16.88C4.57197 16.6465 4.72448 16.3518 4.78465 16.0325C4.84482 15.7132 4.81 15.3832 4.68451 15.0835C4.55901 14.7837 4.34836 14.5274 4.07863 14.3462C3.80889 14.165 3.49193 14.0669 3.167 14.064H3C2.46957 14.064 1.96086 13.8533 1.58579 13.4782C1.21071 13.1031 1 12.5944 1 12.064C1 11.5336 1.21071 11.0249 1.58579 10.6498C1.96086 10.2747 2.46957 10.064 3 10.064H3.09C3.42035 10.057 3.74098 9.95084 4.01024 9.75932C4.27951 9.56781 4.48499 9.29977 4.6 8.99C4.73295 8.68869 4.77257 8.35445 4.71375 8.0304C4.65493 7.70636 4.50037 7.40737 4.27 7.172L4.21 7.112C4.00704 6.93083 3.84317 6.71015 3.72843 6.46346C3.61369 6.21678 3.55048 5.94928 3.54268 5.67733C3.53488 5.40538 3.58264 5.13469 3.68305 4.88184C3.78346 4.62898 3.9344 4.39927 4.12664 4.20676C4.31888 4.01424 4.54838 3.86297 4.80109 3.76221C5.05381 3.66144 5.32442 3.61329 5.59639 3.62071C5.86835 3.62813 6.13594 3.69096 6.38278 3.80535C6.62963 3.91974 6.85054 4.08329 7.032 4.286L7.092 4.346C7.32737 4.57637 7.62636 4.73093 7.9504 4.78975C8.27445 4.84857 8.60869 4.80895 8.91 4.676H8.99C9.28561 4.54959 9.53779 4.33946 9.71547 4.07152C9.89316 3.80357 9.98858 3.4895 9.99 3.168V3C9.99 2.46957 10.2007 1.96086 10.5758 1.58579C10.9509 1.21071 11.4596 1 11.99 1C12.5204 1 13.0291 1.21071 13.4042 1.58579C13.7793 1.96086 13.99 2.46957 13.99 3V3.09C13.9945 3.41348 14.0934 3.72859 14.2746 3.99665C14.4557 4.2647 14.7112 4.47402 15.0096 4.59892C15.308 4.72381 15.6364 4.75884 15.9545 4.6997C16.2725 4.64056 16.5664 4.48982 16.8 4.266L16.86 4.206C17.0426 4.00762 17.2634 3.8482 17.5092 3.73734C17.7549 3.62647 18.0206 3.56644 18.2901 3.56085C18.5597 3.55527 18.8276 3.60425 19.0778 3.70484C19.3279 3.80543 19.5551 3.95556 19.7458 4.14621C19.9364 4.33686 20.0866 4.56409 20.1872 4.81424C20.2878 5.06439 20.3367 5.33229 20.3311 5.60185C20.3256 5.87141 20.2655 6.13706 20.1547 6.38283C20.0438 6.6286 19.8844 6.84941 19.686 7.032L19.626 7.092C19.3963 7.32781 19.2425 7.62701 19.1844 7.95104C19.1263 8.27507 19.1665 8.60907 19.3 8.91V8.99C19.4264 9.28561 19.6365 9.53779 19.9045 9.71547C20.1724 9.89316 20.4865 9.98858 20.808 9.99H20.978C21.5084 9.99 22.0171 10.2007 22.3922 10.5758C22.7673 10.9509 22.978 11.4596 22.978 11.99C22.978 12.5204 22.7673 13.0291 22.3922 13.4042C22.0171 13.7793 21.5084 13.99 20.978 13.99H20.888C20.5668 13.9902 20.2526 14.0844 19.9842 14.2608C19.7157 14.4372 19.5047 14.6882 19.377 14.983V14.983Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const exclamationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-exclamation-circle"
  >
    <path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108 0a8 8 0 000 16z" />
    <path d="M7.002 11a1 1 0 112 0 1 1 0 01-2 0zM7.1 4.995a.905.905 0 111.8 0l-.35 3.507a.552.552 0 01-1.1 0L7.1 4.995z" />
  </svg>
);
// Bundle
export const bundleBoxIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box-seam"
    viewBox="0 0 16 16"
  >
    <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
  </svg>
);

// Events
export const eventsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.6}
    height={15.6}
    viewBox="0 0 15.6 15.6"
  >
    <g data-name="Group 27694">
      <g
        data-name="Group 27686"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
        transform="translate(-17.2 -625.2)"
      >
        <rect
          data-name="Rectangle 11524"
          width={14}
          height={13}
          rx={2}
          transform="translate(18 627)"
        />
        <path
          data-name="Line 1554"
          transform="translate(28 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1555"
          transform="translate(22 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1556"
          transform="translate(18 632)"
          d="M0 0L14 0"
        />
      </g>
    </g>
  </svg>
);
// Archive
export const learnerArchiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.676}
    height={11.773}
    viewBox="0 0 13.676 11.773"
  >
    <g
      transform="translate(.731 .7)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 49028"
        d="M11.104 7.225V0h-10v7.225"
      />
      <path
        data-name="Rectangle 11316"
        transform="translate(-.031 7.304)"
        d="M0 0H12.276V3.069H0z"
      />
      <path
        data-name="Line 1470"
        transform="translate(5.339 5.002)"
        d="M0 0L1.534 0"
      />
    </g>
  </svg>
);
// Documents
export const learnerDocumentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.399}
    height={15.099}
    viewBox="0 0 12.399 15.099"
  >
    <g
      data-name="Group 27697"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49071"
        d="M25.075 410.864H20.35a1.35 1.35 0 00-1.35 1.35v10.8a1.35 1.35 0 001.35 1.35h8.1a1.35 1.35 0 001.35-1.35v-7.425z"
        transform="translate(-18.2 -410.064)"
      />
      <path
        data-name="Path 49072"
        d="M25.075 410.864v4.725H29.8"
        transform="translate(-18.2 -410.064)"
      />
    </g>
  </svg>
);

// Programs
export const learnerProgram = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.584}
    height={14.66}
    viewBox="0 0 15.584 14.66"
  >
    <g
      data-name="Group 27698"
      transform="translate(-17.2 -364.05)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <rect
        data-name="Rectangle 11437"
        width={13.984}
        height={10.208}
        rx={2}
        transform="translate(18 367.702)"
      />
      <path
        data-name="Path 49073"
        d="M27.933 377.91v-11.609a1.451 1.451 0 00-1.447-1.451h-2.9a1.451 1.451 0 00-1.453 1.451v11.609"
      />
    </g>
  </svg>
);

export const eyeOpenedIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.093}
    height={14}
  >
    <g
      transform="translate(-.3 -3.3)"
      fill="none"
      stroke="currentColor"
    >
      <path
        data-name="Path 21634"
        d="M1 9.707S3.853 4 8.847 4s7.847 5.707 7.847 5.707-2.853 5.707-7.847 5.707S1 9.707 1 9.707Z"
      />
      <circle
        data-name="Ellipse 35"
        cx={2}
        cy={2}
        r={2}
        transform="translate(7 7.413)"
      />
    </g>
  </svg>
);

export const downLoadBIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-download"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
  </svg>
);

export const upLoadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
  </svg>
);

export const redBinIcon = (
  <svg
    width="14.999"
    height="16.288"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="SVGRepo_bgCarrier"
      stroke-width="0"
    ></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M4 7H20"
        stroke="#f20202"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
      <path
        d="M6 7V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V7"
        stroke="#f20202"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
      <path
        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
        stroke="#f20202"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
    </g>
  </svg>
);
